import React, {
  useState,
  useEffect,
  useRef,
  useCallback,
  useMemo,
} from "react";
import { pdfjs } from "react-pdf";
import "react-pdf/dist/esm/Page/AnnotationLayer.css";
import "react-pdf/dist/esm/Page/TextLayer.css";
import ZoomDropdown from "../components/ZoomDropdown";
import logo from "../assets/logo.png";
import CheckBoxIcon from "@mui/icons-material/CheckBox";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import {
  Grid2,
  Box,
  Typography,
  Button,
  TextField,
  IconButton,
  DialogContent,
  DialogTitle,
  FormControl,
  Select,
  MenuItem,
  CircularProgress,
  fabClasses,
  DialogActions,
  useMediaQuery,
  useTheme,
} from "@mui/material";

import CloseIcon from "@mui/icons-material/Close";
import Dialog from "@mui/material/Dialog";
import SignatureModalContent from "../components/SignatureModalContent";
import { format, parse, isValid } from "date-fns";
import FileUpload from "../components/FileUpload";
import "../styles/App.styles.css";
import "../App.css";
import { Rnd } from "react-rnd";
import ForYou from "../components/ForYou";
import ForOthers from "../components/ForOthers";
import TextPropertiesPanel from "../components/TextPropertiesPanel";
import DatePickerComponent from "../components/DatePickerComponent";
import ImageCropperModal from "../components/ImageCropperModal";
import SignersDialog from "../components/SignersDialog";
import SignerFieldProperties from "../components/SignerFieldProperty";
import TextEntryDialog from "../components/TextEntryDialog";
import {
  downloadOriginalPdf,
  downloadPdfWithTextAnnotations,
  getColorWithNewOpacity,
  getSignerBoxContent,
  getSignerBoxContentSvg,
  hashIds,
  saveData,
  unhashIds,
} from "../components/utlis";
import {
  FrontendBaseUrl,
  getUrlWithSubdomain,
  post,
  postFormData,
  link_base_url,
  refreshRegionExports,
} from "../apis/apis";
import { regionFromHashPayload, setActiveRegion } from "../configs/regionConfig";
import DropdownPropertiesPanel from "../components/DropdownPropertiesPanel";
import toastAlert from "../components/toastAlert";
import getActivityLogUserFiles from "../components/getActivityLogUserFiles";
import {
  acroformFieldsToAnnotations,
  groupAnnotationsByPage,
} from "../utlis/acroformToAnnotations";
pdfjs.GlobalWorkerOptions.workerSrc = `https://unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.mjs`;

const PLACEHOLDER_LABEL_COLOR = "rgba(0, 0, 0, 0.45)";
const LABEL_PLACEHOLDER_FONT_PX = 12;

function EsignSetupCopy() {
  const theme = useTheme();
  const isMobileOrTablet = useMediaQuery(theme.breakpoints.down('md'));
  const [saveConfirmModalOpen, setSaveConfirmModalOpen] = useState(false);
  const [isSaving, setIsSaving] = useState(false);
  const [activePage, setActivePage] = useState(1); // Track active page

  const [pageSizes, setPageSizes] = useState({});
  const [globalIsRequired, setGlobalIsRequired] = useState(true);
  const [textFieldMetrics, setTextFieldMetrics] = useState({
    width: 100,
    height: 30,
  });
  const [annotationSettings, setAnnotationSettings] = useState({
    my_text: {
      fontSize: 21,
      fontFamily: "Helvetica",
      color: "#000000",
      format: [],
      letterSpacing: 0,
      alignment: "left",
      opacity: 1,
      width: 200,
      height: 30,
      lineHeight: 1.35, // Match template-builder text vertical spacing
    },
    signer_text: {
      fontSize: 21,
      fontFamily: "Helvetica",
      isRequired: false,
      width: 200,
      height: 30,
      lineHeight: 1.35, // Match template-builder text vertical spacing
    },
    signer_initials: {
      isRequired: false,
      width: 250,
      height: 100,
    },
    signer_initials_text: {
      isRequired: false,
      width: 100,
      height: 100,
    },
    signer_date: {
      isRequired: false,
      dateFormat: "MMM dd, yyyy",
      fontSize: 21,
      fontFamily: "Helvetica",
      format: [],
      width: 150,
      height: 30,
      lineHeight: 1,
    },
    date: {
      dateFormat: "MMM dd, yyyy",
      fontSize: 21,
      fontFamily: "Helvetica",
      format: [],
      width: 150,
      height: 30,
      lineHeight: 1,
    },
    signer_checkmark: {
      isRequired: false,
      width: 30,
      height: 30,
    },
    signer_dropdown: {
      isRequired: false,
      options: [],
      width: 150,
      height: 30,
    },
  });
  // Add new state at the top of App component
  const [signerToEdit, setSignerToEdit] = useState(null);
  const [loadingStamps, setLoadingStamps] = useState({});

  const [pageNoClicked, setPageNoClicked] = useState(null);
  const styles = {
    sidebarStyle: {
      cursor: "default !important",
      "& *": {
        cursor: "default !important",
      },
      "& button": {
        cursor: "pointer !important",
      },
      "& .thumbnail-container": {
        cursor: "pointer !important",
      },
    },
  };
  const debounce = (func, wait) => {
    let timeout;
    return function executedFunction(...args) {
      const later = () => {
        clearTimeout(timeout);
        func(...args);
      };
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
    };
  };

  // check

  useEffect(() => {
    const pdfContainer = pdfContainerRef.current;
    if (!pdfContainer) return;

    const handleScroll = debounce((e) => {
      const container = e.target;
      const containerRect = container.getBoundingClientRect();
      const elements = document.querySelectorAll(".pdf-page-container");

      let detectedPage = null;

      elements.forEach((element) => {
        const rect = element.getBoundingClientRect();
        const isVisible =
          rect.top >= containerRect.top && rect.bottom <= containerRect.bottom;

        if (isVisible && !detectedPage) {
          detectedPage = parseInt(element.id.split("-")[1]);
        }
      });

      if (detectedPage) {
        setActivePage(detectedPage);
      }
    }, 16); // 60fps debounce

    pdfContainer.addEventListener("scroll", handleScroll);
    return () => pdfContainer.removeEventListener("scroll", handleScroll);
  }, []);

  const scrollThumbnailIntoView = (pageNum) => {
    const thumbnailElement = document.getElementById(`thumbnail-${pageNum}`);

    if (thumbnailElement && sidebarRef.current) {
      thumbnailElement.scrollIntoView({
        behavior: "smooth",
        block: "nearest",
        inline: "nearest",
      });
    }
  };
  useEffect(() => {
    // if (sidebarVisible) {
    scrollThumbnailIntoView(activePage);
    // }
  }, [activePage]);

  const handlePageHover = (pageNum) => {
    setActivePage(pageNum); // Nothing else!
  };

  const colortheme = "rgb(35, 179, 232)";
  const [pdfFile, setPdfFile] = useState(null);
  const [scale, setScale] = useState(1); // Changed initial scale to 0.8
  const [pdfImages, setPdfImages] = useState([]);
  // Store actual PDF page dimensions (in PDF points) for accurate text wrapping
  const [pdfPageDimensions, setPdfPageDimensions] = useState({});
  useEffect(() => {
    const updatePageSizes = () => {
      const newSizes = {};
      pdfImages.forEach((_, pageIndex) => {
        const pageElement = document.getElementById(`img-${pageIndex + 1}`);
        if (pageElement) {
          newSizes[pageIndex + 1] = {
            width: pageElement.clientWidth,
            height: pageElement.clientHeight,
          };
        }
      });
      setPageSizes(newSizes);
    };

    updatePageSizes();

    window.addEventListener("resize", updatePageSizes);
    return () => window.removeEventListener("resize", updatePageSizes);
  }, [pdfImages, scale]);
  const [containerWidth, setContainerWidth] = useState(0);
  const [firstPageHeight, setFirstPageHeight] = useState(null);
  // At the top with other state declarations
  const [annotationType, setAnnotationType] = useState(null); // 'text' or 'image'
  // Modify the annotations state to store per-page annotations
  const [annotations, setAnnotations] = useState({}); // Changed from array to object with page keys
  const [isAnnotating, setIsAnnotating] = useState(false);
  const [focusedAnnotation, setFocusedAnnotation] = useState(null);
  const [active, setActive] = useState("1");
  const [selectedSigner, setSelectedSigner] = useState([]);
  // First, add a state for storing click position
  const [stampClickPosition, setStampClickPosition] = useState(null);
  // Add this state in your App component
  const [signersDialogOpen, setSignersDialogOpen] = useState(false);
  const [signers, setSigners] = useState([]);
  // Inside your App.js, add this state
  const [selectedSignerId, setSelectedSignerId] = useState(null);
  // Add these helper functions

  // Add these states in your App component
  const [signatureModalOpen, setSignatureModalOpen] = useState(false);
  const getTypeListItem = (type) => {
    setIsAnnotating(true);
    setAnnotationType(type);
    setSelectedAnnotation(null); // Reset right sidebar to Preview when picking a new annotation type
  };

  const [initialsBox, setInitialBox] = useState(false);
  /** Last resized size (width/height as % of page) for FOR ME signature / initials — reused on next placement */
  const lastMeSignatureDimensionsRef = useRef(null);
  const lastMeInitialsDimensionsRef = useRef(null);
  /** Match FOR OTHERS signature/initials placement to FOR ME resize memory */
  const lastSignerSignatureDimensionsRef = useRef(null);
  const lastSignerInitialsDimensionsRef = useRef(null);
  const pdfContainerRef = useRef(null);
  const sidebarRef = useRef(null);
  const [isLoading, setIsLoading] = useState(true);
  const [loadingPhase, setLoadingPhase] = useState("Loading...");
  const getSignerColorById = (signerId, signers) => {
    const signer = signers.find(
      (s) =>
        parseInt(s.signer_id) === parseInt(signerId) ||
        parseInt(s.id) === parseInt(signerId)
    );
    return signer?.color || "rgba(0, 0, 0, 0.1)"; // Default color if signer not found
  };
  // Phase-based loader: no count, just phase text (e.g. Loading..., 30%, Viewing document...)
  const FullScreenLoader = () => (
    <Box
      sx={{
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: "rgba(3, 3, 3, 0.8)",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        zIndex: 9999,
      }}
    >
      <CircularProgress
        size={60}
        thickness={4}
        sx={{
          color: "rgb(35, 179, 232)",
          marginBottom: 2,
        }}
      />
      <Typography variant="h6" color="textSecondary" style={{ color: "white" }}>
        {loadingPhase}
      </Typography>
    </Box>
  );

  // Add new state at the top of your App component
  const [isDragging, setIsDragging] = useState(false);
  const [isResizing, setIsResizing] = useState(false);

  const annotationRefs = useRef({}); // Store refs for each annotation
  const cursorRef = useRef(null);
  const [selectedAnnotation, setSelectedAnnotation] = useState(null);
  const [activeAnnotationId, setActiveAnnotationId] = useState(null);

  const textAnnotationTypes = ["my_text", "signer_text", "date"];
  // states
  const [fileName, setFileName] = useState("");
  const [emailMessage, setEmailMessage] = useState("");
  const [emailSubject, setEmailSubject] = useState("");
  const [securedShare, setSecuredShare] = useState(false);
  const [statusFile, setStatusFile] = useState("");
  const [uniqIdDoc, setUniqIdDoc] = useState("");

  const [stampInputRef] = useState(React.createRef());
  // Add these states at the top of your App component
  const [cropperModalOpen, setCropperModalOpen] = useState(false);
  const [cropSrc, setCropSrc] = useState(null);
  const [pendingStampAction, setPendingStampAction] = useState(null);
  // Text entry dialog state
  const [textEntryDialogOpen, setTextEntryDialogOpen] = useState(false);
  const [pendingTextAnnotation, setPendingTextAnnotation] = useState(null);
  const [textEntryInitialText, setTextEntryInitialText] = useState("");

  const handleStampFileSelect = async (event) => {
    const file = event.target.files[0];
    if (!file) return;

    // Create temporary loading annotation
    if (pageNoClicked && stampClickPosition) {
      const tempAnnotation = {
        id: Date.now(),
        x: stampClickPosition.x,
        y: stampClickPosition.y,
        type: "stamp",
        // width: 150 / scale,
        // height: 150 / scale,
        width: stampClickPosition.width,
        height: stampClickPosition.height,
        isLoading: true,
        page_no: pageNoClicked,
      };

      // Add temporary annotation with loader
      setAnnotations((prev) => ({
        ...prev,
        [pageNoClicked]: [...(prev[pageNoClicked] || []), tempAnnotation],
      }));
    }

    const reader = new FileReader();
    reader.onload = (e) => {
      setCropSrc(e.target.result);
      setPendingStampAction({
        isEdit: !!editingAnnotation,
        editData: editingAnnotation,
        newStampPosition: stampClickPosition,
      });
      setCropperModalOpen(true);
    };
    reader.readAsDataURL(file);
    event.target.value = "";
  };

  // Update handleCroppedStamp function
  const handleCroppedStamp = async (croppedImage) => {
    try {
      // Upload cropped image
      const base64Response = await fetch(croppedImage);
      const blob = await base64Response.blob();
      const fileObject = new File([blob], "stamp.png", { type: "image/png" });

      const postData = {
        image: fileObject,
        user_id: userId,
      };

      const apiData = await postFormData(postData);

      if (!apiData.public_url) {
        toastAlert("error", "Error uploading stamp");
        return;
      }

      const ImageUrl = apiData.public_url;

      if (pendingStampAction.isEdit) {
        // Handle editing existing stamp
        setAnnotations((prev) => {
          const updatedAnnotations = { ...prev };
          const { pageNum, index } = pendingStampAction.editData;

          const existingAnnot = updatedAnnotations[pageNum][index];
          updatedAnnotations[pageNum][index] = {
            ...existingAnnot,
            imageUrl: ImageUrl,
            isLoading: false,
          };

          return updatedAnnotations;
        });
      } else {
        // Handle new stamp
        setAnnotations((prev) => {
          const pageAnnotations = prev[pageNoClicked] || [];
          const loadingIndex = pageAnnotations.findIndex((a) => a.isLoading);

          if (loadingIndex !== -1) {
            const newAnnotations = [...pageAnnotations];
            newAnnotations[loadingIndex] = {
              ...newAnnotations[loadingIndex],
              imageUrl: ImageUrl,
              isLoading: false,
            };

            return {
              ...prev,
              [pageNoClicked]: newAnnotations,
            };
          }

          return prev;
        });
      }

      // Reset states
      setCropperModalOpen(false);
      setCropSrc(null);
      setPendingStampAction(null);
      setStampClickPosition(null);
    } catch (error) {
      console.error("Error handling stamp:", error);
      toastAlert("error", "Error uploading stamp");

      // Clean up loading annotation on error
      setAnnotations((prev) => {
        const pageAnnotations = prev[pageNoClicked] || [];
        return {
          ...prev,
          [pageNoClicked]: pageAnnotations.filter((a) => !a.isLoading),
        };
      });
    }
  };

  // const calculateImageWidth = useCallback((scaleValue) => {
  //   const baseWidth = 100;

  //   // Simple screen size detection
  //   const isLargeScreen = window.innerWidth >= 1920; // 4K, ultrawide monitors
  //   const isLaptop = window.innerWidth >= 1440 && window.innerWidth < 1920;

  //   let effectiveScale = scaleValue;

  //   if (isLargeScreen) {
  //     // For large screens, cap the scale to prevent oversized PDFs
  //     // effectiveScale = Math.min(scaleValue, 1.0);
  //     effectiveScale = 0.9;
  //   } else if (isLaptop) {
  //     // For laptop screens, use scale as intended
  //     effectiveScale = scaleValue;
  //   }

  //   const scaledWidth = baseWidth * effectiveScale;
  //   return Math.max(scaledWidth, 50);
  // }, []);
  // Memoize container width update
  const calculateImageWidth = useCallback((scaleValue) => {
    // Use a fixed maximum width approach instead of viewport-dependent scaling
    const containerWidth =
      pdfContainerRef.current?.offsetWidth || window.innerWidth * 0.8;
    const maxPdfWidth = containerWidth * 0.95; // 95% of container width

    // Base PDF width should be consistent
    const basePdfWidth = Math.min(800, maxPdfWidth); // Max 800px base width

    // Apply scale factor
    const scaledWidth = basePdfWidth * scaleValue;

    // Convert to percentage of container
    return Math.min(95, (scaledWidth / containerWidth) * 100);
  }, []);

  const updateContainerWidth = useCallback(() => {
    if (pdfContainerRef.current) {
      setContainerWidth(pdfContainerRef.current.offsetWidth);
    }
  }, []);

  // Combine container width and resize effects
  useEffect(() => {
    updateContainerWidth();
    window.addEventListener("resize", updateContainerWidth);
    return () => window.removeEventListener("resize", updateContainerWidth);
  }, [updateContainerWidth, scale]);
  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.key === "Escape") {
        setSelectedAnnotation(null);
        setAnnotationType(null);
        setIsAnnotating(false);
      }
    };

    // Add event listener when the component mounts
    document.body.addEventListener("keydown", handleKeyDown);

    // Remove event listener when the component unmounts
    return () => {
      document.body.removeEventListener("keydown", handleKeyDown);
    };
  }, []);

  const loadPdfFromUrl = async (url, token = null) => {
    setLoadingPhase("30%");
    console.log("=== LOAD PDF FROM URL START ===");
    console.log("URL:", url);
    console.log("Token provided:", token ? 'Yes' : 'No');
    console.log("AuthToken from state:", authToken ? 'Yes' : 'No');

    try {
      // Check if this is an encrypted view URL
      const isEncryptedView = url.includes('/api/encrypted-view');
      console.log("Is encrypted view URL?", isEncryptedView);

      const fetchOptions = {
        method: 'GET',
        // Don't use credentials: 'include' when backend uses Access-Control-Allow-Origin: *
        // We're using Authorization header instead, so credentials aren't needed
      };

      // Add headers for encrypted view URL
      if (isEncryptedView) {
        fetchOptions.headers = {
          'Accept': 'application/pdf, */*',
        };

        // Use token parameter if provided, otherwise try state, then localStorage
        let tokenToUse = token || authToken;
        if (!tokenToUse) {
          try {
            const userData = localStorage.getItem('user_data');
            if (userData) {
              // Try to parse and get token (similar to portal)
              const parsed = JSON.parse(userData);
              tokenToUse = parsed?.token;
              console.log("Token retrieved from localStorage:", tokenToUse ? 'Yes' : 'No');
            }
          } catch (e) {
            console.log('No auth token found in localStorage');
          }
        }

        if (tokenToUse) {
          fetchOptions.headers['Authorization'] = `Bearer ${tokenToUse}`;
          console.log('Using auth token for encrypted view');
        } else {
          console.warn('No auth token available for encrypted view URL');
        }

        console.log('Fetch options for encrypted view:', {
          url,
          method: fetchOptions.method,
          hasAuth: !!tokenToUse,
          headers: Object.keys(fetchOptions.headers || {})
        });
      }

      console.log('Fetching URL:', url);
      console.log('Fetch options:', JSON.stringify(fetchOptions, null, 2));
      const response = await fetch(url, fetchOptions);
      console.log('Response status:', response.status, response.statusText);
      console.log('Response ok:', response.ok);

      // Get content type first
      const contentType = response.headers.get('content-type');
      console.log('Response content-type:', contentType);
      console.log('All response headers:', Object.fromEntries(response.headers.entries()));

      // If we get HTML, it's likely an error page - read it to see the error
      if (contentType && contentType.includes('text/html')) {
        const errorText = await response.text();
        console.error('Got HTML response instead of PDF. Status:', response.status);
        console.error('HTML content (first 1000 chars):', errorText.substring(0, 1000));

        // Try to extract error message from HTML if it's a JSON error
        try {
          const jsonMatch = errorText.match(/\{[\s\S]*"error"[\s\S]*\}/);
          if (jsonMatch) {
            const errorJson = JSON.parse(jsonMatch[0]);
            throw new Error(`Backend error: ${errorJson.message || 'Unknown error'}`);
          }
        } catch (e) {
          // Not JSON, check for common error patterns
          if (errorText.includes('401') || errorText.includes('Unauthorized')) {
            throw new Error('Authentication failed. Please check if auth token is valid.');
          }
          if (errorText.includes('404') || errorText.includes('Not Found')) {
            throw new Error('File not found. The encrypted file ID may be invalid.');
          }
          if (errorText.includes('403') || errorText.includes('Forbidden')) {
            throw new Error('Access forbidden. You may not have permission to view this file.');
          }
        }

        throw new Error(`Received HTML instead of PDF. Status: ${response.status}. The endpoint may require authentication or the file may not exist.`);
      }

      // Check if response is OK
      if (!response.ok) {
        const errorText = await response.text();
        console.error('Error response:', response.status, errorText);
        throw new Error(`Failed to load PDF: ${response.status} ${response.statusText}`);
      }

      if (!contentType || !contentType.includes('application/pdf')) {
        // Clone response to read text without consuming the original
        const clonedResponse = response.clone();
        const text = await clonedResponse.text();
        console.error('Expected PDF but got:', contentType, text.substring(0, 200));
        throw new Error('Response is not a PDF. Content-Type: ' + contentType);
      }

      const pdfBlob = await response.blob();
      console.log("PDF Blob received:", {
        size: pdfBlob.size,
        type: pdfBlob.type
      });
      setPdfFile(pdfBlob);
      console.log("PDF file set in state");
      setLoadingPhase("Viewing document...");
      console.log("Converting PDF to images...");
      await convertPdfToImages(pdfBlob);
      console.log("=== LOAD PDF FROM URL SUCCESS ===");
    } catch (error) {
      console.error("=== LOAD PDF FROM URL ERROR ===");
      console.error("Error loading PDF from URL:", error);
      console.error("Error message:", error.message);
      console.error("Error stack:", error.stack);
      setIsLoading(false);
      toastAlert("error", `Failed to load PDF: ${error.message}`);
      // Re-throw error so caller can handle fallback
      throw error;
    }
  };

  // Update the convertPdfToImages function
  const convertPdfToImages = useCallback(async (file) => {
    try {
      let pdfData;
      if (file instanceof Blob) {
        // If file is already a Blob (from file upload)
        pdfData = await file.arrayBuffer();
      } else {
        // If file is a URL
        const response = await fetch(file);
        pdfData = await response.arrayBuffer();
      }

      const loadingTask = pdfjs.getDocument({ data: pdfData });
      const pdf = await loadingTask.promise;

      // Store actual PDF page dimensions for accurate text wrapping
      const pageDimensions = {};
      const images = await Promise.all(
        Array.from({ length: pdf.numPages }, async (_, i) => {
          const page = await pdf.getPage(i + 1);
          // Get actual PDF page size - use viewport dimensions directly
          // pdfjs viewport at scale 1 gives dimensions that match PDF rendering
          const viewportAtScale1 = page.getViewport({ scale: 1 });
          const pdfWidth = viewportAtScale1.width; // Use CSS px directly (matches PDF rendering)
          const pdfHeight = viewportAtScale1.height; // Use CSS px directly (matches PDF rendering)
          pageDimensions[i + 1] = { width: pdfWidth, height: pdfHeight };

          const viewport = page.getViewport({ scale: 2 });
          const canvas = document.createElement("canvas");
          const context = canvas.getContext("2d");

          canvas.width = viewport.width;
          canvas.height = viewport.height;

          await page.render({
            canvasContext: context,
            viewport,
          }).promise;

          return canvas.toDataURL("image/png");
        })
      );

      setPdfImages(images);
      setPdfPageDimensions(pageDimensions);
      console.log("PDF page dimensions set:", pageDimensions);

      // Set loading to false only after images are set and DOM is ready
      setTimeout(() => {
        setIsLoading(false);
      }, 100);
    } catch (error) {
      console.error("Error converting PDF:", error);
      setIsLoading(false);
    }
  }, []);
  // hashed
  const [documentId, setDocumentId] = useState(null);
  const [userId, setUserId] = useState(null);
  const [encryptedFileId, setEncryptedFileId] = useState(null);
  const [authToken, setAuthToken] = useState(null);
  // Function to generate hashed URL
  const generateHashedUrl = (documentId, userId) => {
    const data = { documentId, userId };
    const hashedData = hashIds(data);
    const baseUrl = window.location.origin + window.location.pathname;
    return `${baseUrl}?data=${hashedData}`;
  };

  // funxtions
  const fetchFileData = async (fileId, user_id) => {
    // get Images from db
    console.log("user_iudsfjsf");
    console.log(user_id);
    const postData = {
      file_id: fileId,
      user_id: user_id,
    };
    const apiData = await post("file/get-file", postData); // Specify the endpoint you want to call
    console.log("File Dta Fetch");

    console.log(apiData);
    if (apiData.error) {
      toastAlert("error", "No File exist");
    } else {
      setFileName(apiData?.data?.name || "");

      setEmailMessage(
        apiData?.data?.email_message ||
        `Please review and e-sign the document\n${apiData?.data?.name}\nat your earliest convenience. Thank you!`
      );
      setEmailSubject(apiData?.data?.email_subject || "");
      setUniqIdDoc(apiData?.data?.uniq_id);
      setSecuredShare(apiData.data.secured_share || false);

      setStatusFile(apiData.data.status || "");
    }
  };
  const [user_email, setUserEmail] = useState("");
  const [logo, setLogo] = useState(null);
  const [primaryColorComp, setPrimaryColorComp] = useState(null);

  const fetchuser = async (user_id) => {
    // get Images from db
    console.log("user_iudsfjsf");
    console.log(user_id);
    const postData = {
      user_id: user_id,
    };
    const apiData = await post("user/getUser1ById", postData); // Specify the endpoint you want to call
    console.log("get user.   11111");

    console.log(apiData);
    // setUniqIdDoc(apiData.data.uniq_id)
    if (apiData.error) {
      // window.location.href = "/error";
      toastAlert("error", "No USER exist");
    } else {
      setUserEmail(apiData?.result[0]?.email || "");
      // get logo
      if (apiData?.companyProfile === null) {
        if (apiData?.result[0]?.logo) {
          setLogo(apiData?.result[0]?.logo);
          console.log("logogogog");
        } else {
          setLogo(null);
          console.log("logo null");
        }
      } else {
        if (apiData?.companyProfile?.company_logo === null) {
          setLogo(null);
        } else {
          setLogo(apiData?.companyProfile?.company_logo);
        }
        if (apiData?.companyProfile?.primary_color === null) {
          setPrimaryColorComp(null);
        } else {
          setPrimaryColorComp(apiData?.companyProfile?.primary_color);
        }
      }
      return apiData;
      // show tour
      // if (apiData?.userDocuments === 1) {
      //   setShowTour(true);
      // }

      // toastAlert("success", "File exist")
    }
  };

  const fetchSignerData = async (fileId) => {
    const postData = {
      file_id: fileId,
    };
    try {
      const apiData = await post("file/getAllSignersByFileId", postData); // Specify the endpoint you want to call
      console.log("Signers ");

      console.log(apiData);
      if (apiData.error) {
        setSigners([]);
        setSelectedSigner([]);
        setActive("1");
      } else {
        const fetchedSigners = apiData.result;
        setSigners(fetchedSigners);
        if (fetchedSigners.length > 0) {
          // Just set selected signer to first actual signer for "For Others" tab
          if (active === "2") {
            setSelectedSigner(fetchedSigners[0]);
          }
        }
        // const meExists = fetchedSigners.some(
        //   (s) => s.signer_id === "me" || s.isMe
        // );

        // if (!meExists) {
        //   const updatedSigners = [defaultMeSigner, ...fetchedSigners];
        //   setSigners(updatedSigners);

        //   // Set initial selection based on active tab
        //   if (active === "1") {
        //     setSelectedSigner(defaultMeSigner);
        //   } else {
        //     setSelectedSigner(fetchedSigners[0]);
        //   }
        // } else {
        //   setSigners(fetchedSigners);
        // }
        // setSigners(apiData.result);
        // setSelectedSigner(apiData.result[apiData.result.length - 1]);
      }
    } catch (error) {
      //console.log('Error fetching data:', error);
    }
  };

  const seedAcroformAnnotations = async (fileId) => {
    try {
      const apiData = await post("file/getDetectedFormFields", {
        file_id: fileId,
      });
      const fields = apiData?.detected_form_fields || [];
      if (!Array.isArray(fields) || !fields.length) {
        console.log("=== ACROFORM: no detected_form_fields ===");
        setAnnotations({});
        return {};
      }
      const flat = acroformFieldsToAnnotations(fields);
      const grouped = groupAnnotationsByPage(flat);
      console.log("=== ACROFORM: seeded annotations ===", flat.length);
      setAnnotations(grouped);
      return grouped;
    } catch (err) {
      console.error("Error seeding acroform annotations:", err);
      setAnnotations({});
      return {};
    }
  };

  const fetchDataPositions = async (fileId) => {
    try {
      const postData = {
        file_id: fileId,
      };

      const apiData = await post("file/getallPositionsFromFile_Id", postData);
      console.log("Position Data");
      console.log(apiData);
      if (!apiData.error && apiData.result?.[0]?.position_array) {
        let positionsData = apiData.result[0].position_array;
        console.log("pos");

        // Parse if string
        if (typeof positionsData === "string") {
          positionsData = JSON.parse(positionsData);
        }
        // Ensure positionsData is an array
        if (!Array.isArray(positionsData)) {
          console.warn("Position data is not an array:", positionsData);
          return await seedAcroformAnnotations(fileId);
        }

        // Empty saved canvas — auto-seed fillable AcroForm fields if present
        if (positionsData.length === 0) {
          return await seedAcroformAnnotations(fileId);
        }

        // Group by page number
        const groupedAnnotations = positionsData.reduce((acc, annotation) => {
          const pageNum = annotation.page_no || 1;
          if (!acc[pageNum]) {
            acc[pageNum] = [];
          }

          // Ensure coordinates are stored as percentages (0-100 range)
          // If your database stores them as decimals (0-1 range), multiply by 100
          const x = annotation.x > 1 ? annotation.x : annotation.x * 100;
          const y = annotation.y > 1 ? annotation.y : annotation.y * 100;
          const width =
            annotation.width > 1 ? annotation.width : annotation.width * 100;
          const height =
            annotation.height > 1 ? annotation.height : annotation.height * 100;

          // Ensure all required properties are present
          const formattedAnnotation = {
            id: annotation.id,
            type: annotation.type,
            // x: annotation.x,
            // y: annotation.y,
            // width: annotation.width || 150,
            // height: annotation.height || 30,
            x: Math.max(0, Math.min(100, x)), // Clamp between 0-100
            y: Math.max(0, Math.min(100, y)), // Clamp between 0-100
            width: Math.max(0.1, Math.min(100, width)), // Minimum 0.1% width
            height: Math.max(0.1, Math.min(100, height)), // Minimum 0.1% height

            text: annotation.type === "signer_date" ? "" : (annotation.text || ""),
            checked: annotation.checked || false,
            imageUrl: annotation.imageUrl || null,
            format: annotation.format || [],
            fontSize: annotation.fontSize || (annotation.type === "signer_text" ? (annotationSettings.signer_text?.fontSize || 21) : (annotationSettings.my_text?.fontSize || 21)),
            fontFamily: annotation.fontFamily || (annotation.type === "signer_text" ? (annotationSettings.signer_text?.fontFamily || "Helvetica") : (annotationSettings.my_text?.fontFamily || "Helvetica")),
            backgroundColor:
              annotation.signerId === null
                ? annotation.backgroundColor
                : getColorWithNewOpacity(
                  getSignerColorById(annotation.signerId, signers), // Use signerId to get color
                  annotation.isRequired
                ),
            // backgroundColor: annotation.backgroundColor || null,
            borderColor: annotation.borderColor || null,
            signerId: annotation.signerId || null,
            signerColor: annotation.signerColor || null,
            isRequired: annotation.isRequired || false,
            fieldLabel: annotation.fieldLabel || "",
            page_no: pageNum,
            pageWidth: annotation.pageWidth || null, // Store page width for font scaling in PDF
            source: annotation.source || null,
            acroform_name: annotation.acroform_name || "",
            isPendingText: annotation.isPendingText || false,
            dateFormat: annotation.dateFormat,
            lineHeight: annotation.lineHeight,
          };

          acc[pageNum].push(formattedAnnotation);
          return acc;
        }, {});

        console.log("=== FETCH DATA POSITIONS SUCCESS ===");
        console.log("Grouped annotations:", Object.keys(groupedAnnotations));
        console.log("Total annotations loaded:", Object.values(groupedAnnotations).reduce((sum, arr) => sum + arr.length, 0));
        setAnnotations(groupedAnnotations);
      } else {
        // No saved positions — auto-seed from detected fillable fields
        console.log("=== FETCH DATA POSITIONS - NO DATA; seeding acroform ===");
        return await seedAcroformAnnotations(fileId);
      }

      return {};
    } catch (error) {
      console.error("Error fetching positions:", error);
      return await seedAcroformAnnotations(fileId);
    }
  };
  const [hasParamsD, setHasParamsD] = useState("");

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const hashedParams = params.get("data");
    const hashedParamsStatus = params.get("status");
    console.log("fhfhfh", hashedParamsStatus);
    setHasParamsD(hashedParamsStatus);
    if (hashedParams) {
      const unhashedData = unhashIds(hashedParams);
      console.log("Unhashed data:", unhashedData);
      if (unhashedData) {
        // Multi-region: pin API/link bases from portal hashIds region_code before any fetches
        setActiveRegion(regionFromHashPayload(unhashedData));
        refreshRegionExports();
        const { documentId, userId, encryptedFileId, authToken } = unhashedData;
        console.log("Extracted values:", { documentId, userId, encryptedFileId, authToken: authToken ? 'present' : 'missing' });
        setDocumentId(documentId);
        setUserId(userId);
        // Store encryptedFileId if available (for encrypted uploads)
        if (encryptedFileId) {
          setEncryptedFileId(encryptedFileId);
          console.log("Encrypted File ID set:", encryptedFileId);
        }
        // Store authToken if available (for encrypted view authentication)
        if (authToken) {
          setAuthToken(authToken);
          console.log("Auth token set:", authToken ? 'present' : 'missing');
        } else {
          console.warn("Auth token not found in hash data");
        }

        // Create an async function to handle all API calls
        const fetchAllData = async () => {
          try {
            setIsLoading(true);
            setLoadingPhase("Loading...");
            await fetchFileData(documentId, userId);
            await fetchuser(userId);

            await fetchSignerData(documentId);

            // Pass encryptedFileId and authToken directly to fetchData (state updates are async)
            await fetchData(documentId, userId, encryptedFileId, authToken);
            await fetchDataPositions(documentId);
          } catch (error) {
            console.error("Error fetching data:", error);
            toastAlert("error", "Error loading document data");
          }
          // Don't set isLoading to false here - let it be handled by document loading
        };

        fetchAllData();
      }
    }
  }, []);
  const [originalPdf, setOriginalPdf] = useState("");

  // Track originalPdf changes
  useEffect(() => {
    if (originalPdf) {
      console.log("=== ORIGINAL PDF URL CHANGED ===");
      console.log("New originalPdf URL:", originalPdf);
      console.log("Is encrypted URL?", originalPdf?.includes('encrypted-view'));
      console.log("URL length:", originalPdf?.length || 0);
    }
  }, [originalPdf]);

  const fetchData = async (fileId, userIdParam = null, encryptedFileIdParam = null, authTokenParam = null) => {
    console.log("fetchData called with fileId:", fileId);
    // Use parameters if provided, otherwise fall back to state
    const effectiveUserId = userIdParam || userId;
    const effectiveEncryptedFileId = encryptedFileIdParam || encryptedFileId;
    const effectiveAuthToken = authTokenParam || authToken;

    console.log("Using values - encryptedFileId:", effectiveEncryptedFileId, "userId:", effectiveUserId, "authToken:", effectiveAuthToken ? 'present' : 'missing');

    // If encryptedFileId is available, use encrypted view URL
    if (effectiveEncryptedFileId && effectiveUserId) {
      // Build encrypted view URL with user_id as query parameter
      const encryptedViewUrl = `${link_base_url}/api/encrypted-view/${effectiveEncryptedFileId}?user_id=${effectiveUserId}`;
      console.log("=== FETCH DATA - ENCRYPTED VIEW ===");
      console.log("Using encrypted view URL:", encryptedViewUrl);
      console.log("Encrypted File ID:", effectiveEncryptedFileId);
      console.log("User ID:", effectiveUserId);
      console.log("Auth Token available:", effectiveAuthToken ? 'Yes' : 'No');
      console.log("Setting originalPdf to encrypted URL");
      setOriginalPdf(encryptedViewUrl);
      console.log("originalPdf state set to:", encryptedViewUrl);

      try {
        // Pass authToken to loadPdfFromUrl
        await loadPdfFromUrl(encryptedViewUrl, effectiveAuthToken);
        return; // Success, exit early
      } catch (error) {
        console.error("Failed to load encrypted PDF, falling back to old method:", error);
        // Fall through to old method
      }
    } else {
      console.log("Not using encrypted view - encryptedFileId:", effectiveEncryptedFileId, "userId:", effectiveUserId);
    }

    // Fallback to old method for non-encrypted files or if encrypted view fails
    const postData = {
      file_id: fileId,
    };
    const apiData = await post("file/getbgImagesByFileId", postData); // Specify the endpoint you want to call
    console.log("apixxsData");

    console.log(apiData);
    if (apiData.error) {
      // setIsLoadingDoc(false);
    } else {
      const pdfUrl = apiData?.result[0]?.image;
      console.log("=== FETCH DATA - FALLBACK METHOD ===");
      console.log("PDF URL from API:", pdfUrl);
      console.log("Is encrypted URL?", pdfUrl?.includes('encrypted-view'));
      console.log("Setting originalPdf to:", pdfUrl);
      setOriginalPdf(pdfUrl);
      console.log("originalPdf state set to:", pdfUrl);
      // const pdfUrl = `https://y5f8.c1.e2-7.dev/requiresign-testing-bucket/${documentId}/document.pdf`;
      loadPdfFromUrl(pdfUrl);
      // setImageUrls(apiData.result[0].image);
      // setIsLoadingDoc(false);
      // setIsLoaded(false);
    }
  };

  const [activeAnnotation, setActiveAnnotation] = useState(null);
  const getInitialImageDimensions = (event, pageElement, pageNum) => {
    const imageElem = pageElement.querySelector(".pdf-image");
    if (!imageElem) return { xPercent: 0, yPercent: 0 };

    // Get the actual rendered PDF dimensions (not container dimensions)
    const imageRect = imageElem.getBoundingClientRect();

    // Calculate click position relative to the PDF image itself
    const relativeX = event.clientX - imageRect.left;
    const relativeY = event.clientY - imageRect.top;

    // Convert to percentage of the actual PDF dimensions
    const xPercent = (relativeX / imageRect.width) * 100;
    const yPercent = (relativeY / imageRect.height) * 100;

    // Ensure coordinates are within bounds
    return {
      xPercent: Math.max(0, Math.min(100, xPercent)),
      yPercent: Math.max(0, Math.min(100, yPercent)),
    };
  };
  // const getInitialImageDimensions = (event, pageElement, pageNum) => {
  //   const pdfContentBox =
  //     pdfContainerRef.current?.querySelector(".pdf-content-box");
  //   if (!pdfContentBox) return;

  //   // ✅ Get scrolling offsets
  //   const scrollOffsetY = pdfContentBox.scrollTop;
  //   const scrollOffsetX = pdfContentBox.scrollLeft;

  //   // ✅ Get bounding rects
  //   const pageRect = pageElement.getBoundingClientRect();
  //   const pdfContentBoxRect = pdfContentBox.getBoundingClientRect();

  //   // ✅ Calculate the total height of all pages above the clicked page
  //   let totalOffsetAbove = 0;
  //   const allPages = [...document.querySelectorAll(".pdf-page-container")];

  //   for (const page of allPages) {
  //     if (page === pageElement) break;
  //     totalOffsetAbove +=
  //       page.offsetHeight +
  //       parseFloat(window.getComputedStyle(page).marginBottom);
  //   }

  //   // ✅ Compute Y relative to the full document
  //   let yAbsolute = event.clientY + scrollOffsetY - pdfContentBoxRect.top;
  //   let xAbsolute = event.clientX + scrollOffsetX - pageRect.left;

  //   // ✅ Distances from Top, Center, and Bottom
  //   const distanceFromTop = event.clientY - pageRect.top;
  //   const distanceFromBottom = pageRect.bottom - event.clientY;
  //   const pageHeight = pageRect.height;

  //   // Define more granular page regions
  //   const isVeryTopEdge = distanceFromTop < pageHeight * 0.05; // Top 5%
  //   const isNearTop =
  //     distanceFromTop >= pageHeight * 0.05 &&
  //     distanceFromTop < pageHeight * 0.15; // 5-15%
  //   const isUpperCenter =
  //     distanceFromTop >= pageHeight * 0.15 &&
  //     distanceFromTop < pageHeight * 0.4; // 15-40%
  //   const isMiddle =
  //     distanceFromTop >= pageHeight * 0.4 &&
  //     distanceFromTop <= pageHeight * 0.6; // 40-60%
  //   const isLowerCenter =
  //     distanceFromTop > pageHeight * 0.6 &&
  //     distanceFromTop <= pageHeight * 0.85; // 60-85%
  //   const isNearBottom =
  //     distanceFromTop > pageHeight * 0.85 &&
  //     distanceFromTop <= pageHeight * 0.95; // 85-95%
  //   const isVeryBottomEdge = distanceFromTop > pageHeight * 0.95; // Bottom 5%

  //   console.log("distanceFromTop:", distanceFromTop);
  //   console.log("distanceFromBottom:", distanceFromBottom);
  //   console.log(
  //     "isVeryTopEdge:",
  //     isVeryTopEdge,
  //     "isNearTop:",
  //     isNearTop,
  //     "isUpperCenter:",
  //     isUpperCenter,
  //     "isMiddle:",
  //     isMiddle,
  //     "isLowerCenter:",
  //     isLowerCenter,
  //     "isNearBottom:",
  //     isNearBottom,
  //     "isVeryBottomEdge:",
  //     isVeryBottomEdge
  //   );

  //   // Check if current annotation type is text-related
  //   const isTextType = [
  //     "my_text",
  //     "signer_text",
  //     "date",
  //     "signer_date",
  //   ].includes(annotationType);

  //   if (isTextType) {
  //     // Text fields need specific adjustments
  //     if (isVeryTopEdge) {
  //       yAbsolute -= 4; // Strong upward correction at the very top edge
  //     } else if (isNearTop) {
  //       yAbsolute -= 3; // 🔥 Slight upward correction at the top
  //     } else if (isUpperCenter) {
  //       yAbsolute += 3; // 🔥 Tiny correction in upper center
  //     } else if (isMiddle) {
  //       yAbsolute += 6; // ✅ No change in the middle (already working fine)
  //     } else if (isLowerCenter) {
  //       yAbsolute += 13; // 🔥 More correction for lower center
  //     } else if (isNearBottom) {
  //       yAbsolute += 15; // 🔥 More correction at the bottom
  //     } else if (isVeryBottomEdge) {
  //       yAbsolute += 18; // Extra strong correction at very bottom edge
  //     }
  //   } else {
  //     // Non-text fields (signatures, checkmarks, etc.) need different adjustments
  //     if (isVeryTopEdge) {
  //       yAbsolute -= 3; // Less extreme adjustment for non-text at top edge
  //     } else if (isNearTop) {
  //       yAbsolute -= 1; // 🔥 Very slight upward correction at the top
  //     } else if (isUpperCenter) {
  //       yAbsolute += 6; // 🔥 Tiny correction in upper center
  //     } else if (isMiddle) {
  //       yAbsolute += 9; // ✅ Slight lift in the middle for non-text types
  //     } else if (isLowerCenter) {
  //       yAbsolute += 14; // 🔥 More correction for lower center
  //     } else if (isNearBottom) {
  //       yAbsolute += 18; // 🔥 More correction at the bottom
  //     } else if (isVeryBottomEdge) {
  //       yAbsolute += 18; // Extra strong correction at very bottom edge
  //     }
  //   }

  //   // ✅ Convert to percentage relative to the page
  //   const xPercent = (xAbsolute / pageRect.width) * 100;
  //   const yPercent = ((yAbsolute - totalOffsetAbove) / pageRect.height) * 100;

  //   return { xPercent, yPercent };
  // };

  // Add this helper function to get initial dimensions based on type
  const getDefaultDimensions = (type, scale) => {
    const settings = annotationSettings[type] || {};

    // Use existing settings if available, otherwise use defaults
    switch (type) {
      case "my_text":
      case "signer_text":
        return {
          // width: (settings.width || 150) / scale,
          // height: (settings.height || 30) / scale,
          width: settings.width || 150,
          height: settings.height || 30,
        };
      case "signer_initials":
        return {
          width: settings.width || 250,
          height: settings.height || 100,
        };
      case "signer_initials_text":
        return {
          width: settings.width || 100,
          height: settings.height || 100,
        };
      case "signer_date":
      case "date":
        return {
          width: settings.width || 150,
          height: settings.height || 30,
        };
      case "signer_checkmark":
      case "checkmark":
        return {
          width: settings.width || 30,
          height: settings.height || 30,
        };
      case "signer_dropdown":
        return {
          width: settings.width || 150,
          height: settings.height || 30,
        };
      case "signer_chooseImgStamp":
        return {
          width: settings.width || 150,
          height: settings.height || 150,
        };
      case "signer_chooseImgDrivingL":
        return {
          width: settings.width || 350,
          height: settings.height || 200,
        };
      case "signer_chooseImgPassportPhoto":
        return {
          width: settings.width || 450,
          height: settings.height || 300,
        };
      case "highlight":
        return {
          width: settings.width || 150,
          height: settings.height || 30,
        };
      default:
        return {
          width: 150,
          height: 30,
        };
    }
  };
  const truncateName = (name, maxLength = 30) => {
    if (!name) return "";
    return name.length > maxLength
      ? `${name.substring(0, maxLength)}...`
      : name;
  };

  // Add this function to get the appropriate icon and text for each type
  // const getSignerBoxContent = (type) => {
  //   switch (type) {
  //     case "signer_initials":
  //       return {
  //         icon: <EditIcon sx={{ fontSize: 20 }} />,
  //         text: "Signature",
  //       };
  //     case "signer_initials_text":
  //       return {
  //         icon: <EditIcon sx={{ fontSize: 20 }} />,
  //         text: "Initials",
  //       };
  //     case "signer_chooseImgStamp":
  //       return {
  //         icon: <EditIcon sx={{ fontSize: 20 }} />,
  //         text: "Stamp",
  //       };
  //     case "signer_chooseImgDrivingL":
  //       return {
  //         icon: <EditIcon sx={{ fontSize: 20 }} />,
  //         text: "Driving License",
  //       };
  //     case "signer_chooseImgPassportPhoto":
  //       return {
  //         icon: <EditIcon sx={{ fontSize: 20 }} />,
  //         text: "Passport Photo",
  //       };
  //     default:
  //       return null;
  //   }
  // };
  // Add this effect to measure first page height
  useEffect(() => {
    if (pdfImages.length > 0) {
      const img = new Image();
      img.onload = () => {
        setFirstPageHeight(img.height);
      };
      img.src = pdfImages[0];
    }
  }, [pdfImages]);
  // Add this useEffect to automatically select the last added signer
  useEffect(() => {
    if (signers.length > 0) {
      setSelectedSignerId(signers[signers.length - 1]);
      setSelectedSigner(signers[signers.length - 1]);
      setActive("2");
    }
  }, [signers]);
  // Add this useEffect near your other useEffects
  useEffect(() => {
    // Set appropriate default signer based on active tab
    if (active === "1") {
      // For "For You" tab, use the virtual "Me" signer
      const meValue = {
        signer_id: "me",
        name: "Me",
        email: user_email,
        color: primaryColorComp || colortheme,
        isMe: true,
      };
      setSelectedSignerId(meValue);
      setSelectedSigner(meValue);
    } else if (active === "2" && signers.length > 0) {
      // For "For Others" tab, use the first available signer
      setSelectedSignerId(signers[signers.length - 1]);
      setSelectedSigner(signers[signers.length - 1]);
    } else if (active === "2" && signers.length === 0) {
      toastAlert("info", "No signers available. Please add signers first.");
      // If "For Others" tab is active but no signers exist, switch to "For You"
      setActive("1");
      const meValue = {
        signer_id: "me",
        name: "Me",
        email: user_email,
        color: primaryColorComp || colortheme,
        isMe: true,
      };
      setSelectedSignerId(meValue);
      setSelectedSigner(meValue);
    }
  }, [active, signers.length, primaryColorComp, colortheme, user_email]);
  // Add this useEffect to update cursor color when signer changes
  useEffect(() => {
    // Only run if we're in annotation mode and using a "signer_" type annotation
    if (isAnnotating && annotationType?.startsWith("signer_")) {
      // If we have a box cursor currently displayed
      if (
        cursorRef.current &&
        cursorRef.current.classList.contains("custom-cursor-box")
      ) {
        // Update the background color to match selected signer
        cursorRef.current.style.backgroundColor =
          selectedSigner?.color || "#f0f0f0";

        // For checkboxes, update the inner content too
        if (
          annotationType === "signer_checkmark" &&
          cursorRef.current.querySelector("div > div")
        ) {
          cursorRef.current.querySelector("div").style.backgroundColor =
            selectedSigner?.color || "#f0f0f0";
        }
      }
    }
  }, [selectedSigner, isAnnotating, annotationType]);
  const defaultMeSigner = {
    signer_id: "me",
    name: "Me",
    email: user_email,
    color: "#23B3E8", // Using your app's primary color theme
    isMe: true,
  };

  // Update your useEffect where you handle signers
  // useEffect(() => {
  //   if (signers.length > 0) {
  //     // Check if "Me" signer already exists in the list
  //     const meExists = signers.some((s) => s.signer_id === "me" || s.isMe);

  //     if (!meExists) {
  //       // Add "Me" signer to the beginning of the list
  //       setSigners((prevSigners) => [defaultMeSigner, ...prevSigners]);
  //     }

  //     // Set the appropriate default signer based on active tab
  //     if (active === "1") {
  //       // "For You" tab - set "Me" as selected signer
  //       const meSigner =
  //         signers.find((s) => s.signer_id === "me" || s.isMe) ||
  //         defaultMeSigner;
  //       setSelectedSignerId(meSigner);
  //       setSelectedSigner(meSigner);
  //     } else {
  //       // "For Others" tab - set first regular signer
  //       const otherSigners = signers.filter(
  //         (s) => s.signer_id !== "me" && !s.isMe
  //       );
  //       if (otherSigners.length > 0) {
  //         setSelectedSignerId(otherSigners[0]);
  //         setSelectedSigner(otherSigners[0]);
  //       }
  //     }
  //   }
  // }, [signers, active]);
  const [isSignatureLoading, setIsSignatureLoading] = useState(false);

  const [isInteracting, setIsInteracting] = useState(false);
  const handleSignatureComplete = async (signatureData, typeData) => {
    // Close modal immediately when signature is completed
    setSignatureModalOpen(false);

    if (!editingAnnotation) {
      // Handle new signature creation
      if (!lastClickPosition) {
        console.log("No click position available");
        return;
      }

      setIsSignatureLoading(true);
      try {
        // Crop white space from signature/initial image (including profile URL images)
        const croppedSignatureData = await cropWhiteSpace(signatureData);

        const img = new Image();
        img.crossOrigin = "anonymous";
        img.src = croppedSignatureData;

        img.onload = async () => {
          const targetPage = lastClickPageNum ?? activePage;
          const intrinsicWidth = img.width;
          const intrinsicHeight = img.height;
          const widthd = typeData ? 100 : 100;
          const widthdt = typeData ? 400 : 200;

          // Define the desired display width
          const displayWidth = initialsBox ? widthd : widthdt;
          const aspectRatio = intrinsicWidth / intrinsicHeight;
          const displayHeight = displayWidth / aspectRatio;

          // Adjust dimensions based on the current scale
          const adjustedWidth = displayWidth / scale;
          const adjustedHeight = displayHeight / scale;

          // Convert cropped base64 to file
          const base64Response = await fetch(croppedSignatureData);
          const blob = await base64Response.blob();
          const fileObject = new File([blob], "signature.png", {
            type: "image/png",
          });

          // Upload to API
          const postData = {
            image: fileObject,
            user_id: userId,
          };

          try {
            const apiData = await postFormData(postData);
            if (!apiData.public_url) {
              toastAlert("error", "Error uploading Files");
              setIsSignatureLoading(false);
              setAnnotations((prev) => {
                const pageAnnotations = prev[targetPage] || [];
                return {
                  ...prev,
                  [targetPage]: pageAnnotations.filter((a) => !a.isLoading),
                };
              });
              return;
            }

            const ImageUrl = apiData.public_url;

            setAnnotations((prev) => {
              const pageAnnotations = prev[targetPage] || [];
              const loadingIndex = pageAnnotations.findIndex((a) => a.isLoading);

              if (loadingIndex !== -1) {
                const newAnnotations = [...pageAnnotations];
                newAnnotations[loadingIndex] = {
                  ...newAnnotations[loadingIndex],
                  imageUrl: ImageUrl,
                  croppedImageData: croppedSignatureData,
                  isLoading: false,
                  isSignature: true,
                  aspectRatio,
                };
                handleAnnotationClick(targetPage, loadingIndex, newAnnotations);

                return {
                  ...prev,
                  [targetPage]: newAnnotations,
                };
              }

              return prev;
            });

            // Persist for Adopt and Sign: next placement reuses this signature/initials without opening modal
            if (initialsBox) {
              setAdoptedInitialsData(croppedSignatureData);
            } else {
              setAdoptedSignatureData(croppedSignatureData);
            }
            setLastClickPosition(null);
            setLastClickPageNum(null);
            setIsSignatureLoading(false);
          } catch (error) {
            console.error("Error uploading signature:", error);
            toastAlert("error", "Error uploading Files");
            setIsSignatureLoading(false);
            setAnnotations((prev) => {
              const pageAnnotations = prev[targetPage] || [];
              return {
                ...prev,
                [targetPage]: pageAnnotations.filter((a) => !a.isLoading),
              };
            });
          }
        };
      } catch (error) {
        console.error("Error uploading signature:", error);
        setIsSignatureLoading(false);
        toastAlert("error", "Error uploading signature");
        const targetPage = lastClickPageNum ?? activePage;
        setAnnotations((prev) => {
          const pageAnnotations = prev[targetPage] || [];
          return {
            ...prev,
            [targetPage]: pageAnnotations.filter((a) => !a.isLoading),
          };
        });
      }
      return;
    }

    // Handle editing existing signature
    const { pageNum, index } = editingAnnotation;
    const annotationKey = `${pageNum}-${index}`;

    // Mark annotation as loading
    setLoadingAnnotations((prev) => new Set(prev).add(annotationKey));

    try {
      // Crop white space from signature/initial image
      const croppedSignatureData = await cropWhiteSpace(signatureData);
      const editedAspectRatio = await new Promise((resolve) => {
        const img = new Image();
        img.onload = () => resolve(img.width / img.height);
        img.onerror = () => resolve(null);
        img.src = croppedSignatureData;
      });

      // Immediately update with cropped base64 data for quick display
      setAnnotations((prev) => {
        const updatedAnnotations = { ...prev };
        updatedAnnotations[pageNum][index] = {
          ...updatedAnnotations[pageNum][index],
          imageUrl: croppedSignatureData, // Use cropped base64 immediately for quick display
          croppedImageData: croppedSignatureData,
          ...(Number.isFinite(editedAspectRatio) && editedAspectRatio > 0
            ? { aspectRatio: editedAspectRatio }
            : {}),
        };
        return updatedAnnotations;
      });

      // Convert cropped base64 to file
      const base64Response = await fetch(croppedSignatureData);
      const blob = await base64Response.blob();
      const fileObject = new File([blob], "signature.png", { type: "image/png" });

      // Upload to API
      const postData = {
        image: fileObject,
        user_id: userId,
      };

      const apiData = await postFormData(postData);
      console.log("apiData", apiData);

      if (!apiData.public_url) {
        toastAlert("error", "Error uploading Files");
        setLoadingAnnotations((prev) => {
          const newSet = new Set(prev);
          newSet.delete(annotationKey);
          return newSet;
        });
        return;
      }

      const ImageUrl = apiData.public_url;

      // Update with final URL
      setAnnotations((prev) => {
        const updatedAnnotations = { ...prev };
        updatedAnnotations[pageNum][index] = {
          ...updatedAnnotations[pageNum][index],
          imageUrl: ImageUrl,
          croppedImageData: croppedSignatureData,
          ...(Number.isFinite(editedAspectRatio) && editedAspectRatio > 0
            ? { aspectRatio: editedAspectRatio }
            : {}),
        };
        return updatedAnnotations;
      });
    } catch (error) {
      console.error("Error uploading signature:", error);
      toastAlert("error", "Error uploading Files");
    } finally {
      // Remove loading state
      setLoadingAnnotations((prev) => {
        const newSet = new Set(prev);
        newSet.delete(annotationKey);
        return newSet;
      });
      // Clean up state
      setEditingAnnotation(null);
      setInitialBox(false);
    }
  };
  // All annotations: resize from all 4 corners
  const getResizeHandles = () => ({
    topRight: true,
    topLeft: true,
    bottomRight: true,
    bottomLeft: true,
  });

  const shouldLockAspectRatio = (type) => {
    const typesWithLockedAspectRatio = [
      "stamp",
      // "highlight",
      // "my_signature", // Removed - now resizes from bottom-right only like text fields
      "signer_chooseImgStamp",
      "signer_chooseImgDrivingL",
      "signer_chooseImgPassportPhoto",
    ];
    return typesWithLockedAspectRatio.includes(type);
  };
  // 1. Add a new state for tracking the annotation being edited
  const [editingAnnotation, setEditingAnnotation] = useState(null);
  // Track loading state for annotations
  const [loadingAnnotations, setLoadingAnnotations] = useState(new Set());

  // Function to crop white space from signature/initial images.
  const cropWhiteSpace = (base64Image) => {
    return new Promise((resolve, reject) => {
      const img = new Image();
      img.crossOrigin = "anonymous";
      img.onload = () => {
        const canvas = document.createElement("canvas");
        const ctx = canvas.getContext("2d");

        // Draw image to canvas
        canvas.width = img.width;
        canvas.height = img.height;
        ctx.drawImage(img, 0, 0);

        // Get image data (will throw if canvas was tainted by cross-origin)
        let imageData;
        try {
          imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
        } catch (e) {
          reject(new Error("Image could not be processed (cross-origin or security)."));
          return;
        }
        const data = imageData.data;

        // Find bounding box of non-white pixels
        let minX = canvas.width;
        let minY = canvas.height;
        let maxX = 0;
        let maxY = 0;

        // Threshold for "white" (adjust if needed, 250 means very light colors are considered white)
        const whiteThreshold = 250;

        for (let y = 0; y < canvas.height; y++) {
          for (let x = 0; x < canvas.width; x++) {
            const idx = (y * canvas.width + x) * 4;
            const r = data[idx];
            const g = data[idx + 1];
            const b = data[idx + 2];
            const a = data[idx + 3];

            // Check if pixel is not white/transparent
            if (a > 0 && (r < whiteThreshold || g < whiteThreshold || b < whiteThreshold)) {
              minX = Math.min(minX, x);
              minY = Math.min(minY, y);
              maxX = Math.max(maxX, x);
              maxY = Math.max(maxY, y);
            }
          }
        }

        // Keep signatures left-flush while preserving breathing room on other sides.
        // This ensures typed signatures start from the left edge in merged PDFs.
        const paddingLeft = 0;
        const paddingRight = 5;
        const paddingTop = 5;
        const paddingBottom = 5;
        minX = Math.max(0, minX - paddingLeft);
        minY = Math.max(0, minY - paddingTop);
        maxX = Math.min(canvas.width, maxX + paddingRight);
        maxY = Math.min(canvas.height, maxY + paddingBottom);

        // If no content found, return original
        if (minX >= maxX || minY >= maxY) {
          resolve(base64Image);
          return;
        }

        // Create new canvas with cropped dimensions
        const croppedCanvas = document.createElement("canvas");
        const croppedCtx = croppedCanvas.getContext("2d");
        const width = maxX - minX;
        const height = maxY - minY;

        croppedCanvas.width = width;
        croppedCanvas.height = height;

        // Draw cropped portion
        croppedCtx.drawImage(
          img,
          minX, minY, width, height,
          0, 0, width, height
        );

        // Convert to base64
        const croppedBase64 = croppedCanvas.toDataURL("image/png");
        resolve(croppedBase64);
      };

      img.onerror = async () => {
        const isUrl = typeof base64Image === "string" && /^https?:\/\//i.test(base64Image);
        if (!isUrl) {
          reject(new Error("Failed to load image"));
          return;
        }
        // Fallback for remote profile signatures: fetch -> dataURL -> crop.
        try {
          const response = await fetch(base64Image, { mode: "cors" });
          if (!response.ok) {
            throw new Error(`Failed to fetch image: ${response.status}`);
          }
          const blob = await response.blob();
          const reader = new FileReader();
          reader.onloadend = async () => {
            try {
              const dataUrl = reader.result;
              if (typeof dataUrl !== "string") {
                throw new Error("Failed to convert image to base64");
              }
              const cropped = await cropWhiteSpace(dataUrl);
              resolve(cropped);
            } catch (error) {
              reject(error);
            }
          };
          reader.onerror = () => reject(new Error("Failed to convert image to base64"));
          reader.readAsDataURL(blob);
        } catch (error) {
          reject(error);
        }
      };

      img.src = base64Image;
    });
  };

  // 2. Add handler for editing signature
  const handleEditSignature = (pageNum, index, annot) => {
    // Reset state before opening
    setEditingAnnotation(null);
    setInitialBox(false);
    // Small delay to ensure clean state
    setTimeout(() => {
      const shouldBeInitialBox = annot.type === "signer_initials_text" || annot.type === "my_initials";
      setEditingAnnotation({ pageNum, index, annot });
      setInitialBox(shouldBeInitialBox);
      setSignatureModalOpen(true);
    }, 0);
  };

  // 3. Add handler for editing stamp
  const handleEditStamp = (pageNum, index, annot) => {
    setEditingAnnotation({ pageNum, index, annot });
    stampInputRef.current.click();
  };

  // 4. Add handler for editing text
  const handleEditText = (pageNum, index, annot) => {
    setPendingTextAnnotation({ pageNum, index });
    setTextEntryInitialText(annot?.text || "");
    setTextEntryDialogOpen(true);
  };

  const preserveAcroformBox = (annot) =>
    annot?.source === "acroform" || annot?.preserveBox === true;

  // Adopt and Sign: place persisted signature/initials without opening modal
  const applyAdoptedSignature = useCallback(
    (pageNum, adoptedData, isInitials) => {
      setIsSignatureLoading(true);
      const img = new Image();
      img.onload = async () => {
        const displayWidth = isInitials ? 100 : 400;
        const aspectRatio = img.width / img.height;
        const displayHeight = displayWidth / aspectRatio;
        const base64Response = await fetch(adoptedData);
        const blob = await base64Response.blob();
        const fileObject = new File([blob], "signature.png", { type: "image/png" });
        const postData = { image: fileObject, user_id: userId };
        try {
          const apiData = await postFormData(postData);
          if (!apiData.public_url) {
            toastAlert("error", "Error uploading Files");
            setIsSignatureLoading(false);
            setAnnotations((prev) => {
              const pageAnnotations = prev[pageNum] || [];
              return { ...prev, [pageNum]: pageAnnotations.filter((a) => !a.isLoading) };
            });
            return;
          }
          setAnnotations((prev) => {
            const pageAnnotations = prev[pageNum] || [];
            const loadingIndex = pageAnnotations.findIndex((a) => a.isLoading);
            if (loadingIndex === -1) return prev;
            const newAnnotations = [...pageAnnotations];
            newAnnotations[loadingIndex] = {
              ...newAnnotations[loadingIndex],
              imageUrl: apiData.public_url,
              croppedImageData: adoptedData,
              isLoading: false,
              isSignature: true,
              aspectRatio,
            };
            return { ...prev, [pageNum]: newAnnotations };
          });
          setLastClickPosition(null);
          setLastClickPageNum(null);
        } catch (error) {
          console.error("Error uploading adopted signature:", error);
          toastAlert("error", "Error uploading Files");
          setAnnotations((prev) => {
            const pageAnnotations = prev[pageNum] || [];
            return { ...prev, [pageNum]: pageAnnotations.filter((a) => !a.isLoading) };
          });
        }
        setIsSignatureLoading(false);
      };
      img.onerror = () => {
        setIsSignatureLoading(false);
        setAnnotations((prev) => {
          const pageAnnotations = prev[pageNum] || [];
          return { ...prev, [pageNum]: pageAnnotations.filter((a) => !a.isLoading) };
        });
      };
      img.src = adoptedData;
    },
    [userId, scale]
  );

  const [lastClickPosition, setLastClickPosition] = useState(null);
  const [lastClickPageNum, setLastClickPageNum] = useState(null);
  const [loadingPositions, setLoadingPositions] = useState({});
  // Adopt and Sign: persist last-drawn signature/initials so user can place again without reopening modal
  const [adoptedSignatureData, setAdoptedSignatureData] = useState(null);
  const [adoptedInitialsData, setAdoptedInitialsData] = useState(null);
  // Check if the current annotationType is in the array
  const calculateTextWidth = (
    text,
    fontSize = 16,
    fontFamily = "Helvetica"
  ) => {
    if (!text || !text.trim()) {
      return 0; // Return 0 for empty text
    }

    const canvas = document.createElement("canvas");
    const ctx = canvas.getContext("2d");

    // Use PDF-equivalent font size for measurement to match PDF behavior
    // PDF uses 72 DPI (points), CSS uses 96 DPI (pixels)
    // This ensures text width calculation matches what PDF will render
    const pdfFontSize = fontSize * (72 / 96);
    ctx.font = `${pdfFontSize}px ${fontFamily}`;

    // Measure text at PDF-equivalent font size
    const textWidthAtPdfSize = ctx.measureText(text).width;

    // Scale back up to CSS pixel space for comparison with screen dimensions
    const textWidth = Math.ceil(textWidthAtPdfSize * (96 / 72));

    return textWidth;
  };

  // Wrap text exactly like PDF does - word by word, checking width at each step
  // Now that PDF uses font size directly (no conversion), measure at the same size
  const wrapTextLikePdf = (text, fontSize, fontFamily, maxWidth, isPdfPoints = false) => {
    if (!text || !text.trim()) return text;

    // PDF now uses font size directly (no conversion), so measure at the same size
    // Use exact width without any tolerance to eliminate all right spacing
    const maxWidthToUse = maxWidth;

    const canvas = document.createElement("canvas");
    const ctx = canvas.getContext("2d");

    // Measure at the exact font size (no conversion needed)
    ctx.font = `${fontSize}px ${fontFamily}`;

    // Measure text width
    const fullTextWidth = ctx.measureText(text).width;

    if (fullTextWidth <= maxWidthToUse) {
      return text; // Single line, no wrapping
    }

    // Split by spaces and wrap word by word (same as PDF algorithm)
    const words = text.split(" ");
    let line = "";
    const lines = [];

    for (const word of words) {
      const testLine = line + (line ? " " : "") + word;
      const testWidth = ctx.measureText(testLine).width;

      // Compare with tolerance (like PDF does, accounting for measurement differences)
      if (testWidth > maxWidthToUse && line) {
        lines.push(line);
        line = word;
      } else {
        line = testLine;
      }
    }

    if (line) {
      lines.push(line);
    }

    return lines.join("\n");
  };

  // Calculate text height considering wrapping and multiline text
  const calculateTextHeight = (text, fontSize, fontFamily, availableWidth, lineHeight = 1) => {
    const effectiveLineHeight = lineHeight || 1;
    if (!text || !text.trim()) {
      return fontSize * effectiveLineHeight;
    }

    // Use a temporary DOM element for more accurate measurement
    const tempDiv = document.createElement("div");
    tempDiv.style.cssText = `
      position: absolute;
      visibility: hidden;
      width: ${availableWidth}px;
      font-size: ${fontSize}px;
      font-family: ${fontFamily};
      line-height: ${effectiveLineHeight};
      white-space: pre-wrap;
      word-wrap: break-word;
      word-break: break-word;
      overflow-wrap: break-word;
      padding: 0;
      margin: 0;
      box-sizing: border-box;
    `;
    tempDiv.textContent = text;
    document.body.appendChild(tempDiv);

    // Get the actual rendered height
    const actualHeight = tempDiv.offsetHeight;
    document.body.removeChild(tempDiv);

    const minHeight = fontSize * effectiveLineHeight;
    return Math.max(minHeight, actualHeight);
  };

  const handlePdfClick = (event) => {
    if (!isAnnotating || isDragging || isResizing || isInteracting) return;

    const pageElement = event.target.closest(".pdf-page-container");
    if (!pageElement) return;
    // Get page number from element ID
    const pageNum = parseInt(pageElement.id.split("-")[1]);

    const isAnnotationClick =
      event.target.closest(".annotation") ||
      event.target.closest(".react-rnd-resizable-handle") ||
      event.target.closest(".MuiIconButton-root");

    if (isAnnotationClick) return;

    // // Get saved settings for the current annotation type
    const settings = annotationSettings[annotationType] || {};

    // // scroll
    console.log("settings", settings);
    // // end
    const { xPercent, yPercent } = getInitialImageDimensions(
      event,
      pageElement
    );

    const pageWidth = pageElement.getBoundingClientRect().width;
    const pageHeight = pageElement.getBoundingClientRect().height;

    console.log("pdf width", pageWidth);

    const fontSize = settings.fontSize || 21;

    const defaultWidth = 150; // Default text box width in pixels
    const defaultHeight = 30; // Default height in pixels
    const pageRect = pageElement.getBoundingClientRect();
    let baseAnnotation = {
      id: Date.now(),
      x: xPercent,
      y: yPercent,
      page_no: pageNum,
      type: annotationType,
      width: settings?.width / scale,
      height: settings?.height / scale,
    };
    if (annotationType === "my_text") {
      // Calculate width automatically based on text (initially empty, so use small default)
      // For empty text, use a small default width that will adjust when text is added
      const initialWidthPx = 20; // Small default for empty text, will adjust when text is entered
      // Calculate height based on fontSize and lineHeight (no extra padding)
      const initialHeightPx = fontSize * (settings.lineHeight || 1);
      const heightPercent = (initialHeightPx / pageRect.height) * 100;

      // Position text box so bottom aligns with click point (cursor arrow tip)
      // Since text resizes from bottom, the click point should be at the bottom of the text box
      // The cursor arrow tip points to where the bottom of the text will be
      let adjustedYPercent = yPercent - heightPercent;
      // Ensure box stays within page bounds
      adjustedYPercent = Math.max(0, adjustedYPercent); // Don't go above page
      adjustedYPercent = Math.min(100 - heightPercent, adjustedYPercent); // Don't go below page

      const newAnnotation = {
        ...baseAnnotation,
        id: Date.now(),
        type: "my_text",
        width: (initialWidthPx / pageRect.width) * 100,
        height: heightPercent,
        y: adjustedYPercent, // Position box so bottom aligns with click point
        text: "",
        fontSize, // Save font size directly
        fontFamily: settings.fontFamily || "Helvetica",
        format: settings.format || [],
        lineHeight: settings.lineHeight || 1,
        backgroundColor: "rgba(0, 247, 255, 0.25)",
        borderColor: "rgba(0, 0, 0, 0.23)",
        isPendingText: true, // Flag to identify placeholder state
        pageWidth: pageRect.width, // Store page width for font scaling in PDF
      };

      setAnnotations((prev) => {
        console.log("=== ADDING MY_TEXT ANNOTATION (PLACEHOLDER) ===");
        console.log("Page:", activePage);
        console.log("Annotation:", newAnnotation);
        console.log("Previous annotations on this page:", prev[activePage]?.length || 0);

        const updatedAnnotations = {
          ...prev,
          [activePage]: [...(prev[activePage] || []), newAnnotation],
        };

        console.log("New annotations on this page:", updatedAnnotations[activePage].length);
        console.log("Total pages with annotations:", Object.keys(updatedAnnotations).length);

        // Store the annotation index for text entry
        const annotationIndex = updatedAnnotations[activePage].length - 1;
        setPendingTextAnnotation({ pageNum: activePage, index: annotationIndex });
        setTextEntryInitialText(""); // Empty for new annotations

        // Open text entry dialog
        setTextEntryDialogOpen(true);

        return updatedAnnotations;
      });
    }
    if (annotationType === "signer_text") {
      // Calculate height based on fontSize and lineHeight (no extra padding)
      const calculatedHeight = settings.fontSize * (settings.lineHeight || 1);
      console.log("calculatedHeight", calculatedHeight);
      const heightPercent = (calculatedHeight / pageRect.height) * 100;

      // Adjust Y position so text appears above the click point (like DigiSigner)
      // Subtract height from Y to position box above the click point
      // But ensure the box doesn't go above the page or below the page
      let adjustedYPercent = yPercent - heightPercent;
      // Ensure box stays within page bounds
      adjustedYPercent = Math.max(0, adjustedYPercent); // Don't go above page
      adjustedYPercent = Math.min(100 - heightPercent, adjustedYPercent); // Don't go below page

      const newAnnotation = {
        ...baseAnnotation,
        id: Date.now(),

        text: "",
        imageUrl: null,
        type: annotationType,
        fontSize,
        fontFamily: settings.fontFamily || "Helvetica",
        format: settings.format || [],
        lineHeight: settings.lineHeight || 1,

        // width: (calculatedWidth / pageRect.width) * 100,
        width: (settings.width / pageRect.width) * 100,

        height: heightPercent,
        y: adjustedYPercent, // Position box above click point
        backgroundColor: `${selectedSigner?.color}`,
        signerColor: `${selectedSigner?.color}`,
        borderColor: selectedSigner?.color,
        signerId: selectedSigner?.signer_id, // Add signer ID
        signerName: selectedSigner?.name, // Optional: add signer name for reference
        isRequired: globalIsRequired,
        pageWidth: pageRect.width, // Store page width for font scaling in PDF
      };
      // setAnnotations((prev) => ({
      //   ...prev,
      //   [activePage]: [...(prev[activePage] || []), newAnnotation],
      // }));
      setAnnotations((prev) => {
        const updatedAnnotations = {
          ...prev,
          [activePage]: [...(prev[activePage] || []), newAnnotation],
        };

        // Get the index of the newly added annotation
        const newIndex = updatedAnnotations[activePage].length - 1;

        // Set the selected annotation immediately after creation
        setSelectedAnnotation({
          ...newAnnotation,
          pageNum: activePage,
          index: newIndex,
        });

        // Set the active annotation ID
        setActiveAnnotationId(`${activePage}-${newIndex}`);
        setActiveAnnotation(`${activePage}-${newIndex}`);

        return updatedAnnotations;
      });
    }
    if (annotationType === "signer_dropdown") {
      const heightPercent = (30 / pageRect.height) * 100;
      let adjustedYPercent = yPercent - heightPercent;
      adjustedYPercent = Math.max(0, adjustedYPercent);
      adjustedYPercent = Math.min(100 - heightPercent, adjustedYPercent);
      const newAnnotation = {
        ...baseAnnotation,
        id: Date.now(),
        // x,
        // y,
        type: annotationType,
        // width: 150 / scale,
        // height: 30 / scale,
        width: (150 / pageRect.width) * 100,
        height: heightPercent,
        y: adjustedYPercent,
        page_no: pageNum, //
        options: [],
        selectedOption: "",
        signerId: selectedSigner?.signer_id,
        signerColor: selectedSigner?.color,
        signerName: selectedSigner?.name,
        backgroundColor: `${selectedSigner?.color}`,
        borderColor: selectedSigner?.color,
        // isRequired: false,
        isRequired: globalIsRequired,
      };

      // setAnnotations((prev) => ({
      //   ...prev,
      //   [activePage]: [...(prev[activePage] || []), newAnnotation],
      // }));
      setAnnotations((prev) => {
        const updatedAnnotations = {
          ...prev,
          [activePage]: [...(prev[activePage] || []), newAnnotation],
        };

        // Get the index of the newly added annotation
        const newIndex = updatedAnnotations[activePage].length - 1;

        // Set the selected annotation immediately after creation
        setSelectedAnnotation({
          ...newAnnotation,
          pageNum: activePage,
          index: newIndex,
        });

        // Set the active annotation ID
        setActiveAnnotationId(`${activePage}-${newIndex}`);
        setActiveAnnotation(`${activePage}-${newIndex}`);

        return updatedAnnotations;
      });
    }
    if (annotationType === "signer_date" || annotationType === "date") {
      const currentDate = new Date();
      console.log("sin er date", annotationType);
      const defaultFormat = "MMM dd, yyyy";
      try {
        // For signer_date (other section), don't show date label text; for date (my date), show formatted date
        const displayText = annotationType === "signer_date"
          ? ""
          : format(new Date(), settings.dateFormat || "MMM dd, yyyy");

        // Date line height 1 (text fields keep their line height)
        const dateLineHeight = settings.lineHeight ?? 1;
        const calculatedHeight = (settings.fontSize || 21) * dateLineHeight;
        const heightPercent = (calculatedHeight / pageRect.height) * 100;

        // Match textCursor preview: box sits above the click, plus the same tip offset
        // used in cursor transform (translate(0, -(boxHeight + 6))).
        // Without this, the placed field lands ~6–13px lower than the DATE cursor preview.
        const pointerTipYOffsetPx = 6;
        const tipOffsetPercent = (pointerTipYOffsetPx / pageRect.height) * 100;
        let adjustedYPercent = yPercent - heightPercent - tipOffsetPercent;
        // Ensure box stays within page bounds
        adjustedYPercent = Math.max(0, adjustedYPercent); // Don't go above page
        adjustedYPercent = Math.min(100 - heightPercent, adjustedYPercent); // Don't go below page

        // Calculate width based on the date text to ensure it fits on one line
        // Use a canvas to measure text width
        const canvas = document.createElement("canvas");
        const ctx = canvas.getContext("2d");
        const fontSize = settings.fontSize || 21;
        ctx.font = `${fontSize}px ${settings.fontFamily || "Helvetica"}`;
        const dateText = format(new Date(), settings.dateFormat || "MMM dd, yyyy");
        const textWidth = ctx.measureText(dateText).width;
        // Add padding for the date field
        const dateFieldWidth = Math.max(120, textWidth + 20);

        const newAnnotation = {
          ...baseAnnotation,
          id: Date.now(),
          // x: xPercent,
          // y: yPercent,
          // Use displayText instead of formattedDate
          text: displayText,
          type: annotationType,
          // fontSize: 14,
          fontSize: settings.fontSize || 21,
          fontFamily: settings.fontFamily || "Helvetica",
          format: settings.format || [],
          lineHeight: dateLineHeight,
          dateFormat: settings.dateFormat || defaultFormat,
          // Use arrow image width (120px) to match cursor
          width: (dateFieldWidth / pageRect.width) * 100,
          height: heightPercent,
          y: adjustedYPercent, // Position box above click point
          signerId:
            annotationType === "signer_date" ? selectedSigner?.signer_id : null,
          page_no: pageNum, //
          date: annotationType === "signer_date" ? null : currentDate,
          backgroundColor:
            annotationType === "signer_date"
              ? `${selectedSigner?.color}` // Add 20 for opacity
              : "rgba(0, 247, 255, 0.25)", // Same cyan color as my_text
          signerColor:
            annotationType === "signer_date"
              ? `${selectedSigner?.color}` // Add 20 for opacity
              : "rgba(0, 247, 255, 0.25)", // Same cyan color as my_text
          borderColor:
            annotationType === "signer_date"
              ? selectedSigner?.color
              : "rgba(0, 0, 0, 0.23)",
          isRequired:
            annotationType === "signer_date" ? globalIsRequired : false,
          pageWidth: pageRect.width, // Store page width for font scaling in PDF
        };
        console.log("newAnnotation", newAnnotation);
        setAnnotations((prev) => {
          const updatedAnnotations = {
            ...prev,
            [activePage]: [...(prev[activePage] || []), newAnnotation],
          };

          // Get the index of the newly added annotation
          const newIndex = updatedAnnotations[activePage].length - 1;

          // Set the selected annotation immediately after creation
          setSelectedAnnotation({
            ...newAnnotation,
            pageNum: activePage,
            index: newIndex,
          });

          // Set the active annotation ID and active annotation so icons are visible
          setActiveAnnotationId(`${activePage}-${newIndex}`);
          setActiveAnnotation(`${activePage}-${newIndex}`);

          return updatedAnnotations;
        });
      } catch (error) {
        console.error("Error creating date annotation:", error);
      }
      return;
    }
    // Add this condition for stamp type
    if (annotationType === "stamp") {
      const heightPercent = (150 / pageRect.height) * 100;
      let adjustedYPercent = yPercent - heightPercent;
      adjustedYPercent = Math.max(0, adjustedYPercent);
      adjustedYPercent = Math.min(100 - heightPercent, adjustedYPercent);
      const clickPosition = {
        x: xPercent,
        y: adjustedYPercent,
        width: (150 / pageRect.width) * 100,
        height: heightPercent,
      };
      setPageNoClicked(pageNum);
      setStampClickPosition(clickPosition); // Store click position
      const input = stampInputRef.current;
      input.click();
      return;
    }
    // In App.js
    if (annotationType === "checkmark") {
      // const newAnnotation = {
      //   ...baseAnnotation,
      //   id: Date.now(),
      //   // x,
      //   // y,
      //   type: "checkmark",
      //   checked: true,
      //   page_no: pageNum, //
      //   width: (250 / pageRect.width) * 100,
      //   height: (250 / pageRect.height) * 100,
      // };
      const defaultSize = 22;
      const heightPercent = (defaultSize / pageHeight) * 100;
      let adjustedYPercent = yPercent - heightPercent;
      adjustedYPercent = Math.max(0, adjustedYPercent);
      adjustedYPercent = Math.min(100 - heightPercent, adjustedYPercent);
      const newAnnotation = {
        ...baseAnnotation,
        id: Date.now(),
        type: "checkmark",
        checked: true, // default unchecked
        width: (defaultSize / pageWidth) * 100,
        height: heightPercent,
        y: adjustedYPercent,
      };
      setAnnotations((prev) => {
        const updatedAnnotations = {
          ...prev,
          [activePage]: [...(prev[activePage] || []), newAnnotation],
        };

        // Get the index of the newly added annotation
        const newIndex = updatedAnnotations[activePage].length - 1;

        // Set the selected annotation immediately after creation
        setSelectedAnnotation({
          ...newAnnotation,
          pageNum: activePage,
          index: newIndex,
        });

        return updatedAnnotations;
      });
      return;
    }
    if (annotationType === "signer_checkmark") {
      const defaultSize = 22;
      const heightPercent = (defaultSize / pageHeight) * 100;
      let adjustedYPercent = yPercent - heightPercent;
      adjustedYPercent = Math.max(0, adjustedYPercent);
      adjustedYPercent = Math.min(100 - heightPercent, adjustedYPercent);
      const newAnnotation = {
        ...baseAnnotation,
        id: Date.now(),
        // x,
        // y,
        type: "signer_checkmark",

        backgroundColor: `${selectedSigner?.color}`, // Add 20 for opacity
        signerColor: `${selectedSigner?.color}`, // Add 20 for opacity

        borderColor: selectedSigner?.color,
        page_no: pageNum, //
        checked: false,
        signerId: selectedSigner?.signer_id,

        width: (defaultSize / pageWidth) * 100,
        height: heightPercent,
        y: adjustedYPercent,
        isRequired: globalIsRequired,
      };

      setAnnotations((prev) => {
        const updatedAnnotations = {
          ...prev,
          [activePage]: [...(prev[activePage] || []), newAnnotation],
        };

        // Get the index of the newly added annotation
        const newIndex = updatedAnnotations[activePage].length - 1;

        // Set the selected annotation immediately after creation
        setSelectedAnnotation({
          ...newAnnotation,
          pageNum: activePage,
          index: newIndex,
        });

        return updatedAnnotations;
      });
      return;
    }
    // In App.js, add to handlePdfClick function
    if (annotationType === "highlight") {
      console.log("highlight");
      const heightPercent = (30 / pageRect?.height) * 100;
      let adjustedYPercent = yPercent - heightPercent;
      adjustedYPercent = Math.max(0, adjustedYPercent);
      adjustedYPercent = Math.min(100 - heightPercent, adjustedYPercent);
      const newAnnotation = {
        ...baseAnnotation,
        id: Date.now(),
        // x,
        // y,
        type: "highlight",
        width: (120 / pageRect?.width) * 100,
        height: heightPercent,
        y: adjustedYPercent,
        page_no: pageNum, //
        // height: 25 / scale,
        backgroundColor: "rgba(255, 255, 0, 0.3)", // Light yellow with opacity
      };
      // setAnnotations((prev) => {
      //   const updatedAnnotations = {
      //     ...prev,
      //     [activePage]: [...(prev[activePage] || []), newAnnotation],
      //   };

      //   // Get the index of the newly added annotation
      //   const newIndex = updatedAnnotations[activePage]?.length - 1;

      //   // Set the selected annotation immediately after creation
      //   setSelectedAnnotation({
      //     ...newAnnotation,
      //     pageNum: activePage,
      //     index: newIndex,
      //   });

      //   // Set the active annotation ID
      //   setActiveAnnotationId(`${activePage}-${newIndex}`);
      //   setActiveAnnotation(`${activePage}-${newIndex}`);

      setAnnotations((prev) => {
        const updatedAnnotations = {
          ...prev,
          [activePage]: [...(prev[activePage] || []), newAnnotation],
        };
        const newIndex = updatedAnnotations[activePage].length - 1;

        // Set the selected annotation immediately after creation
        setSelectedAnnotation({
          ...newAnnotation,
          pageNum: activePage,
          index: newIndex,
        });

        // Set the active annotation ID and active annotation for selection
        setActiveAnnotationId(`${activePage}-${newIndex}`);
        setActiveAnnotation(`${activePage}-${newIndex}`);

        return updatedAnnotations;
      });
      // });
      console.log("highlight set");

      return;
    }

    if (annotationType === "my_signature") {
      const loadingId = `${pageNum}-${Date.now()}`;
      const defaultHeightPct = (100 / pageRect.height) * 100;
      const defaultWidthPct = (250 / pageRect.width) * 100;
      const remembered = lastMeSignatureDimensionsRef.current;
      const heightPercent = remembered?.height ?? defaultHeightPct;
      const widthPercent = remembered?.width ?? defaultWidthPct;
      let adjustedYPercent = yPercent - heightPercent;
      adjustedYPercent = Math.max(0, adjustedYPercent);
      adjustedYPercent = Math.min(100 - heightPercent, adjustedYPercent);
      // Create temporary loading annotation
      const tempAnnotation = {
        ...baseAnnotation,
        id: Date.now(),
        type: annotationType,
        width: widthPercent,
        height: heightPercent,
        y: adjustedYPercent,
        isLoading: true,
        page_no: pageNum,
      };

      // Adopt and Sign: if we have a persisted signature, place it without opening modal
      if (adoptedSignatureData) {
        setAnnotations((prev) => ({
          ...prev,
          [pageNum]: [...(prev[pageNum] || []), tempAnnotation],
        }));
        setLastClickPosition({ x: xPercent, y: adjustedYPercent });
        setLastClickPageNum(pageNum);
        setTimeout(() => applyAdoptedSignature(pageNum, adoptedSignatureData, false), 0);
        return;
      }

      // Add the temporary annotation and open modal
      setAnnotations((prev) => ({
        ...prev,
        [pageNum]: [...(prev[pageNum] || []), tempAnnotation],
      }));
      setLastClickPosition({ x: xPercent, y: adjustedYPercent });
      setLastClickPageNum(pageNum);
      setInitialBox(false); // Ensure modal shows "Add Signature" when adding signature
      setSignatureModalOpen(true);
      setLoadingPositions((prev) => ({
        ...prev,
        [loadingId]: tempAnnotation,
      }));
      return;
    }
    if (annotationType === "my_initials") {
      const defaultHeightPct = (100 / pageRect.height) * 100;
      const defaultWidthPct = (100 / pageRect.width) * 100;
      const remembered = lastMeInitialsDimensionsRef.current;
      const heightPercent = remembered?.height ?? defaultHeightPct;
      const widthPercent = remembered?.width ?? defaultWidthPct;
      let adjustedYPercent = yPercent - heightPercent;
      adjustedYPercent = Math.max(0, adjustedYPercent);
      adjustedYPercent = Math.min(100 - heightPercent, adjustedYPercent);
      const tempAnnotation = {
        ...baseAnnotation,
        id: Date.now(),
        type: annotationType,
        width: widthPercent,
        height: heightPercent,
        y: adjustedYPercent,
        isLoading: true,
        page_no: pageNum,
      };

      // Adopt and Sign: if we have persisted initials, place without opening modal
      if (adoptedInitialsData) {
        setAnnotations((prev) => ({
          ...prev,
          [pageNum]: [...(prev[pageNum] || []), tempAnnotation],
        }));
        setLastClickPosition({ x: xPercent, y: adjustedYPercent });
        setLastClickPageNum(pageNum);
        setPageNoClicked(pageNum);
        setTimeout(() => applyAdoptedSignature(pageNum, adoptedInitialsData, true), 0);
        return;
      }

      const loadingId = `${pageNum}-${Date.now()}`;
      setAnnotations((prev) => ({
        ...prev,
        [pageNum]: [...(prev[pageNum] || []), tempAnnotation],
      }));
      setLastClickPosition({ x: xPercent, y: adjustedYPercent });
      setLastClickPageNum(pageNum);
      setPageNoClicked(pageNum);
      setInitialBox(annotationType.includes("initials"));
      setSignatureModalOpen(true);
      setLoadingPositions((prev) => ({
        ...prev,
        [loadingId]: tempAnnotation,
      }));
      return;
    }
    if (
      [
        "signer_initials",
        "signer_initials_text",
        "signer_chooseImgStamp",
        "signer_chooseImgDrivingL",
        "signer_chooseImgPassportPhoto",
      ].includes(annotationType)
    ) {
      const dimensions = getDefaultDimensions(annotationType, scale);
      console.log("dimenesisosn", dimensions);
      const rememberedSignerDimensions =
        annotationType === "signer_initials"
          ? lastSignerSignatureDimensionsRef.current
          : annotationType === "signer_initials_text"
            ? lastSignerInitialsDimensionsRef.current
            : null;
      const widthPercent =
        rememberedSignerDimensions?.width ??
        (dimensions.width / pageRect.width) * 100;
      const heightPercent =
        rememberedSignerDimensions?.height ??
        (dimensions.height / pageRect.height) * 100;
      let adjustedYPercent = yPercent - heightPercent;
      adjustedYPercent = Math.max(0, adjustedYPercent);
      adjustedYPercent = Math.min(100 - heightPercent, adjustedYPercent);
      const newAnnotation = {
        ...baseAnnotation,
        id: Date.now(),
        // x,
        // y,
        type: annotationType,
        width: widthPercent,
        height: heightPercent,
        y: adjustedYPercent,
        signerId: selectedSigner?.signer_id,
        page_no: pageNum, //
        signerColor: selectedSigner?.color,
        signerName: selectedSigner?.name,
        imageUrl: null, // Will be filled when user adds content
        backgroundColor: `${selectedSigner?.color}`,
        borderColor: selectedSigner?.color,
        isRequired: globalIsRequired,
      };

      // setAnnotations((prev) => ({
      //   ...prev,
      //   [activePage]: [...(prev[activePage] || []), newAnnotation],
      // }));
      setAnnotations((prev) => {
        const updatedAnnotations = {
          ...prev,
          [activePage]: [...(prev[activePage] || []), newAnnotation],
        };

        // Get the index of the newly added annotation
        const newIndex = updatedAnnotations[activePage].length - 1;

        // Set the selected annotation immediately after creation
        setSelectedAnnotation({
          ...newAnnotation,
          pageNum: activePage,
          index: newIndex,
        });

        // Set the active annotation ID
        setActiveAnnotationId(`${activePage}-${newIndex}`);
        setActiveAnnotation(`${activePage}-${newIndex}`);

        return updatedAnnotations;
      });
    }
  };
  // Inside App.js, modify the handlePdfClick function

  const handleAnnotationClick = (pageNum, index, annotation) => {
    console.log("clicked texct ");
    console.log("clicked texct ", annotation);

    const annotationId = `${pageNum}-${index}`;
    setActiveAnnotationId(annotationId);
    setActiveAnnotation(annotationId);
    setSelectedAnnotation({
      ...annotation,
      pageNum,
      index,
    });
    // Set focused annotation
    setFocusedAnnotation(annotationId);

    // Auto-detected fillable fields: edit like FOR ME toolbar placements
    if (annotation.type === "my_text") {
      const empty = !(annotation.text && String(annotation.text).trim());
      if (empty) {
        handleEditText(pageNum, index, annotation);
      }
      return;
    }

    if (annotation.type === "checkmark") {
      setAnnotations((prev) => {
        const pageAnnotations = [...(prev[pageNum] || [])];
        if (!pageAnnotations[index]) return prev;
        pageAnnotations[index] = {
          ...pageAnnotations[index],
          checked: !pageAnnotations[index].checked,
        };
        setSelectedAnnotation({
          ...pageAnnotations[index],
          pageNum,
          index,
        });
        return { ...prev, [pageNum]: pageAnnotations };
      });
      return;
    }

    if (annotation.type === "my_signature" && !annotation.imageUrl) {
      handleEditSignature(pageNum, index, annotation);
      return;
    }

    if (
      annotation.type === "date" &&
      !(annotation.text && String(annotation.text).trim())
    ) {
      const dateFormat = annotation.dateFormat || "MMM dd, yyyy";
      const displayText = format(new Date(), dateFormat);
      setAnnotations((prev) => {
        const pageAnnotations = [...(prev[pageNum] || [])];
        if (!pageAnnotations[index]) return prev;
        pageAnnotations[index] = {
          ...pageAnnotations[index],
          text: displayText,
          date: new Date(),
          dateFormat,
        };
        setSelectedAnnotation({
          ...pageAnnotations[index],
          pageNum,
          index,
        });
        return { ...prev, [pageNum]: pageAnnotations };
      });
    }
  };

  // Add this new state at the top of your EsignSetup component

  const handleAnnotationTextChange = (e, pageNum, index) => {
    if (selectedAnnotation?.type === "my_text") {
      // Enforce 500 character limit for my_text fields
      const MAX_CHARACTERS = 500;
      let newText = e.target.value;

      // Truncate if exceeds limit
      if (newText.length > MAX_CHARACTERS) {
        newText = newText.substring(0, MAX_CHARACTERS);
        // Update the input value to reflect truncation
        e.target.value = newText;
      }

      const inputEl = annotationRefs.current[`${pageNum}-${index}`];
      if (!inputEl) return;

      const currentAnnotation = annotations[pageNum][index];
      const pageElement = document.querySelector(`#img-${pageNum} .pdf-image`);
      if (!pageElement) return;
      const pageWidthPx = pageElement.offsetWidth;
      const pageHeightPx = pageElement.offsetHeight;

      // Calculate width automatically based on actual text width
      const fontSize = currentAnnotation.fontSize || 21;
      const fontFamily = currentAnnotation.fontFamily || "Helvetica";
      const lineHeight = currentAnnotation.lineHeight || 1;

      // Calculate natural text width (as if on one line)
      let calculatedWidthPx = calculateTextWidth(newText, fontSize, fontFamily);

      // If text is empty or very short, use a small default
      if (calculatedWidthPx === 0 || calculatedWidthPx < 20) {
        calculatedWidthPx = 20; // Minimum for empty text
      }

      // Add buffer to prevent text cutoff on the right side
      const bufferPx = 8; // Extra breathing space on right side
      const boxWidthPx = calculatedWidthPx + bufferPx;

      // Calculate maximum allowed width (PDF container width minus current X position)
      const currentXPercent = currentAnnotation.x || 0;
      const currentXPx = (currentXPercent / 100) * pageWidthPx;
      const maxAllowedWidthPx = pageWidthPx - currentXPx;

      // Single row: use text width (no wrap), cap at container if needed
      const finalWidthPx = boxWidthPx > maxAllowedWidthPx ? maxAllowedWidthPx : boxWidthPx;
      const widthPercent = (finalWidthPx / pageWidthPx) * 100;

      // Single row: height is always one line
      const effectiveLineHeight = lineHeight || 1;
      const textHeightPx = fontSize * effectiveLineHeight;
      const heightPercent = (textHeightPx / pageHeightPx) * 100;

      // Resize from bottom: keep bottom position fixed when text height changes
      const currentBottomPercent = currentAnnotation.y + currentAnnotation.height;
      const newHeightPx = (heightPercent / 100) * pageHeightPx;
      const currentBottomPx = (currentBottomPercent / 100) * pageHeightPx;

      // Adjust Y position so bottom stays fixed: newY = bottom - newHeight
      let adjustedYPercent = ((currentBottomPx - newHeightPx) / pageHeightPx) * 100;

      // Ensure Y doesn't go negative (above page)
      adjustedYPercent = Math.max(0, adjustedYPercent);

      // ✅ Update annotation (main state update) - width adjusts automatically
      setAnnotations((prev) => {
        const pageAnnotations = [...(prev[pageNum] || [])];
        pageAnnotations[index] = {
          ...pageAnnotations[index],
          text: newText,
          width: widthPercent, // Width adjusts automatically based on text
          height: heightPercent, // Height adjusts based on wrapped text
          y: adjustedYPercent, // Keep bottom position fixed
        };
        return { ...prev, [pageNum]: pageAnnotations };
      });

      // ✅ Update live metrics for UI (this stays in px)
      setTextFieldMetrics((prev) => ({
        ...prev,
        width: calculatedWidthPx,
      }));

      // ✅ Optional: If you want to preset this for future fields
      setAnnotationSettings((prev) => ({
        ...prev,
        my_text: {
          ...prev.my_text,
          width: calculatedWidthPx, // next new field gets calculated width
        },
      }));
    }
  };

  const [isDeleting, setIsDeleting] = useState(false);

  // Cancel text entry — only remove toolbar placeholders; keep AcroForm/seeded fields
  const handleTextEntryCancel = () => {
    if (pendingTextAnnotation) {
      const { pageNum, index } = pendingTextAnnotation;
      const current = annotations[pageNum]?.[index];
      if (current?.isPendingText) {
        setAnnotations((prev) => {
          const pageAnnotations = [...(prev[pageNum] || [])];
          const updatedAnnotations = pageAnnotations.filter((_, i) => i !== index);
          return {
            ...prev,
            [pageNum]: updatedAnnotations,
          };
        });
      }
    }
    setTextEntryDialogOpen(false);
    setPendingTextAnnotation(null);
    setTextEntryInitialText("");
  };

  // Handler to complete text entry and update annotation
  const handleTextEntryComplete = (enteredText) => {
    if (!pendingTextAnnotation) {
      return;
    }

    const { pageNum, index } = pendingTextAnnotation;
    const currentAnnotation = annotations[pageNum]?.[index];

    if (!enteredText.trim()) {
      if (currentAnnotation?.isPendingText) {
        handleTextEntryCancel();
      } else {
        setTextEntryDialogOpen(false);
        setPendingTextAnnotation(null);
        setTextEntryInitialText("");
      }
      return;
    }

    // Enforce 500 character limit for my_text fields
    const MAX_CHARACTERS = 500;
    const truncatedText = enteredText.length > MAX_CHARACTERS
      ? enteredText.substring(0, MAX_CHARACTERS)
      : enteredText;

    if (!currentAnnotation) {
      handleTextEntryCancel();
      return;
    }

    // Get page element for dimension calculations
    const pageElement = document.querySelector(`#img-${pageNum} .pdf-image`);
    if (!pageElement) {
      handleTextEntryCancel();
      return;
    }

    const pageRect = pageElement.getBoundingClientRect();
    const pageWidthPx = pageRect.width;
    const pageHeightPx = pageRect.height;

    // Get font properties from annotation
    const fontSize = currentAnnotation.fontSize || annotationSettings.my_text.fontSize || 21;
    const fontFamily = currentAnnotation.fontFamily || annotationSettings.my_text.fontFamily || "Helvetica";
    const lineHeight = currentAnnotation.lineHeight || annotationSettings.my_text.lineHeight || 1;

    // Use truncated text for calculations
    const textToUse = truncatedText;

    // Keep AcroForm / seeded box geometry so merge lands on the original field
    if (preserveAcroformBox(currentAnnotation)) {
      setAnnotations((prev) => {
        const pageAnnotations = [...(prev[pageNum] || [])];
        const updatedAnnotation = {
          ...pageAnnotations[index],
          text: textToUse,
          isPendingText: false,
        };
        pageAnnotations[index] = updatedAnnotation;
        setActiveAnnotationId(`${pageNum}-${index}`);
        setActiveAnnotation(`${pageNum}-${index}`);
        setSelectedAnnotation({
          ...updatedAnnotation,
          pageNum,
          index,
        });
        return {
          ...prev,
          [pageNum]: pageAnnotations,
        };
      });
      setTextEntryDialogOpen(false);
      setPendingTextAnnotation(null);
      setTextEntryInitialText("");
      return;
    }

    // Calculate width automatically based on actual text width
    let calculatedWidthPx = calculateTextWidth(textToUse, fontSize, fontFamily);

    // If text is empty or very short, use a small default
    if (calculatedWidthPx === 0 || calculatedWidthPx < 20) {
      calculatedWidthPx = 20; // Minimum for empty text
    }

    // Add buffer to prevent text cutoff on the right side
    const bufferPx = 20; // Extra breathing space on right side
    const boxWidthPx = calculatedWidthPx + bufferPx;

    // Calculate maximum allowed width (PDF container width minus current X position)
    const currentXPercent = currentAnnotation.x || 0;
    const currentXPx = (currentXPercent / 100) * pageWidthPx;
    const maxAllowedWidthPx = pageWidthPx - currentXPx;

    // Single row: use text width, cap at container if needed
    const finalWidthPx = boxWidthPx > maxAllowedWidthPx ? maxAllowedWidthPx : boxWidthPx;
    const widthPercent = (finalWidthPx / pageWidthPx) * 100;

    // Single row: height is always one line
    const effectiveLineHeight = lineHeight || 1;
    const textHeightPx = fontSize * effectiveLineHeight;
    const heightPercent = (textHeightPx / pageHeightPx) * 100;

    // Adjust Y position so text appears above the click point (invert height)
    // The original Y was set when box was created, now adjust based on actual calculated height
    const originalY = currentAnnotation.y;
    const originalHeightPercent = currentAnnotation.height;
    // Calculate the bottom of the original box (where the click point was)
    const clickPointY = originalY + originalHeightPercent;
    // Position new box above click point by subtracting new height
    // But ensure the box doesn't go above the page or below the page
    let adjustedYPercent = clickPointY - heightPercent;
    // Ensure box stays within page bounds
    adjustedYPercent = Math.max(0, adjustedYPercent); // Don't go above page
    adjustedYPercent = Math.min(100 - heightPercent, adjustedYPercent); // Don't go below page

    // Update annotation with text and calculated dimensions
    setAnnotations((prev) => {
      const pageAnnotations = [...(prev[pageNum] || [])];
      const updatedAnnotation = {
        ...pageAnnotations[index],
        text: textToUse, // Use truncated text if it exceeded limit
        width: widthPercent, // Width adjusts automatically based on text
        height: heightPercent, // Height adjusts based on wrapped text
        y: adjustedYPercent, // Position box above click point
        isPendingText: false, // Remove pending flag
      };
      pageAnnotations[index] = updatedAnnotation;

      // Set the annotation as active so icons are visible
      setActiveAnnotationId(`${pageNum}-${index}`);
      setActiveAnnotation(`${pageNum}-${index}`);
      setSelectedAnnotation({
        ...updatedAnnotation,
        pageNum,
        index,
      });

      return {
        ...prev,
        [pageNum]: pageAnnotations,
      };
    });

    // Update annotation settings for future fields
    setAnnotationSettings((prev) => ({
      ...prev,
      my_text: {
        ...prev.my_text,
        width: calculatedWidthPx, // Width adjusts automatically
        height: textHeightPx,
      },
    }));

    // Close dialog and clear pending state
    setTextEntryDialogOpen(false);
    setPendingTextAnnotation(null);
    setTextEntryInitialText("");
  };

  // Handler to delete an annotation
  const handleDeleteAnnotation = (pageNum, index) => {
    const deletedType = annotations[pageNum]?.[index]?.type;
    if (deletedType === "my_signature") setAdoptedSignatureData(null);
    if (deletedType === "my_initials") setAdoptedInitialsData(null);

    setIsDeleting(true);
    const annotationElement = document.querySelector(
      `[data-annot-id="${pageNum}-${annotations[pageNum][index].id}"]`
    );
    if (annotationElement) {
      annotationElement.style.transition = "none";
    }

    setAnnotations((prev) => ({
      ...prev,
      [pageNum]: Array.isArray(prev[pageNum]) ? prev[pageNum].filter((_, i) => i !== index) : [],
    }));
    setSelectedAnnotation(null);
    setAnnotationType(null);
    setIsAnnotating(false);
    // setAnnotations((prev) => ({
    //   ...prev,
    //   [pageNum]: prev[pageNum].filter((_, i) => i !== index),
    // }));
  };

  // Memoize render image function
  const renderImage = useCallback((image, index, isMainView = true) => {
    return (
      <img
        src={image}
        alt={`Page ${index + 1}`}
        className={isMainView ? "pdf-image" : "thumbnail-image"}
        loading="lazy"
      />
    );
  }, []);
  //  //correct

  // correct
  const handleUpdateAnnotation = (updatedProps) => {
    if (!selectedAnnotation) return;

    const { pageNum, index } = selectedAnnotation;
    const currentAnnotation = annotations[pageNum][index];

    const type = currentAnnotation.type;

    // Merge current annotation with updated properties
    let mergedAnnotation = {
      ...currentAnnotation,
      ...updatedProps,
    };
    // For signer_date (FOR OTHERS), never store or display a date value — keep empty for backend and merge
    if (type === "signer_date") {
      mergedAnnotation.text = "";
      mergedAnnotation.date = null;
    }
    console.log("current ", mergedAnnotation);
    console.log("current1 ", currentAnnotation);
    console.log("updatedProps ", updatedProps);

    if (
      type === "my_text" ||
      type === "signer_text" ||
      type === "date" ||
      type === "signer_date"
    ) {
      const pageElement = document.querySelector(`#img-${pageNum} .pdf-image`);
      if (!pageElement) return;

      const pageWidth = pageElement.offsetWidth;
      const pageHeight = pageElement.offsetHeight;

      // 1️⃣ Create offscreen span for accurate measurement
      const tempSpan = document.createElement("span");
      tempSpan.style.visibility = "hidden";
      tempSpan.style.position = "absolute";
      tempSpan.style.whiteSpace = "pre";

      // const newFontSize =
      //   updatedProps.fontSize || currentAnnotation.fontSize || 16;
      // const newFontFamily =
      //   updatedProps.fontFamily || currentAnnotation.fontFamily || "Helvetica";
      // const newFontWeight = updatedProps.format?.includes("bold")
      //   ? "bold"
      //   : "normal";
      // const newFontStyle = updatedProps.format?.includes("italic")
      //   ? "italic"
      //   : "normal";
      // const letterSpacing =
      //   updatedProps.letterSpacing ||
      //   currentAnnotation.letterSpacing ||
      //   "normal";
      const defaultFontSize = type === "signer_text"
        ? (annotationSettings.signer_text?.fontSize || 21)
        : (annotationSettings.my_text?.fontSize || 21);
      const defaultFontFamily = type === "signer_text"
        ? (annotationSettings.signer_text?.fontFamily || "Helvetica")
        : (annotationSettings.my_text?.fontFamily || "Helvetica");

      const newFontSize =
        mergedAnnotation.fontSize || currentAnnotation.fontSize || defaultFontSize;
      const newFontFamily =
        mergedAnnotation.fontFamily ||
        currentAnnotation.fontFamily ||
        defaultFontFamily;
      const newFontWeight = mergedAnnotation.format?.includes("bold")
        ? "bold"
        : "normal";
      const newFontStyle = mergedAnnotation.format?.includes("italic")
        ? "italic"
        : "normal";
      const letterSpacing = mergedAnnotation.letterSpacing || "normal";
      tempSpan.style.fontSize = `${newFontSize}px`;
      tempSpan.style.fontFamily = newFontFamily;
      tempSpan.style.fontWeight = newFontWeight;
      tempSpan.style.fontStyle = newFontStyle;
      tempSpan.style.letterSpacing = letterSpacing;

      // 2️⃣ Preserve original baseline before any changes (y is percent 0–100)
      const oldHeightPx = (currentAnnotation.height / 100) * pageHeight;
      const oldTopPx = (currentAnnotation.y / 100) * pageHeight;
      const baselinePx = oldTopPx + oldHeightPx; // Fixed bottom position

      // Detect which style props actually changed (callers often re-send unchanged values)
      const fontSizeChanged =
        updatedProps.fontSize !== undefined &&
        updatedProps.fontSize !== currentAnnotation.fontSize;
      const fontFamilyChanged =
        updatedProps.fontFamily !== undefined &&
        updatedProps.fontFamily !== currentAnnotation.fontFamily;
      const formatStyleChanged =
        updatedProps.format !== undefined &&
        JSON.stringify(updatedProps.format || []) !==
        JSON.stringify(currentAnnotation.format || []);
      const lineHeightChanged =
        updatedProps.lineHeight !== undefined &&
        updatedProps.lineHeight !== currentAnnotation.lineHeight;
      const isDateType = type === "date" || type === "signer_date";
      // Date format / text-only edits must not move the box — only widen if needed
      const dateContentOnlyUpdate =
        isDateType &&
        !fontSizeChanged &&
        !fontFamilyChanged &&
        !formatStyleChanged &&
        !lineHeightChanged;

      // 3️⃣ Measure new text size after applying the changes
      const textToMeasure = mergedAnnotation.text || "Text";
      tempSpan.innerText = textToMeasure;

      document.body.appendChild(tempSpan);

      const measuredWidth = tempSpan.getBoundingClientRect().width;
      const measuredHeight = tempSpan.getBoundingClientRect().height;

      document.body.removeChild(tempSpan);

      // For my_text, recalculate width when fontSize changes, otherwise preserve width
      if (type === "my_text") {
        let newWidthPercent;

        // If fontSize is being changed, recalculate width based on text content
        if (updatedProps.fontSize !== undefined && updatedProps.fontSize !== currentAnnotation.fontSize) {
          // Recalculate width based on text with new font size
          const text = currentAnnotation.text || "";
          const calculatedWidthPx = calculateTextWidth(text, newFontSize, newFontFamily);

          // Add buffer to prevent text cutoff on the right side
          const bufferPx = 20; // Extra breathing space on right side
          const boxWidthPx = text.trim() ? Math.max(20, calculatedWidthPx) + bufferPx : 20 + bufferPx;

          // Calculate max allowed width (PDF container width minus current X position)
          const currentXPx = (currentAnnotation.x / 100) * pageWidth;
          const maxAllowedWidthPx = pageWidth - currentXPx;
          const finalWidthPx = Math.min(boxWidthPx, maxAllowedWidthPx);
          newWidthPercent = (finalWidthPx / pageWidth) * 100;
        } else {
          // Preserve the current width (don't reset if user has resized)
          newWidthPercent = currentAnnotation.width; // Keep current width
        }

        // Single row: height is always one line
        const lineHeight = mergedAnnotation.lineHeight || currentAnnotation.lineHeight || 1;
        const effectiveLineHeight = lineHeight || 1;
        const textHeightPx = newFontSize * effectiveLineHeight;
        const newHeightPercent = (textHeightPx / pageHeight) * 100;

        // Resize from bottom: keep bottom position fixed, text grows upward when font size increases
        // Calculate current bottom position (Y + height)
        const currentBottomPercent = currentAnnotation.y + currentAnnotation.height;
        const newHeightPx = (newHeightPercent / 100) * pageHeight;
        const currentBottomPx = (currentBottomPercent / 100) * pageHeight;

        // Adjust Y position so bottom stays fixed: newY = bottom - newHeight
        let newYPercent = ((currentBottomPx - newHeightPx) / pageHeight) * 100;

        // Ensure Y doesn't go negative (above page)
        newYPercent = Math.max(0, newYPercent);

        mergedAnnotation.width = newWidthPercent; // Use recalculated or preserved width
        mergedAnnotation.height = newHeightPercent;
        mergedAnnotation.y = newYPercent; // Fixed from bottom
        mergedAnnotation.pageWidth = pageWidth; // Store page width for font scaling in PDF
      } else {
        // For other types, use original logic
        // 4️⃣ Add consistent padding (same as your MUI TextField)
        const paddingX = 8; // Horizontal padding (left+right)
        const paddingY = 6; // Vertical padding (top+bottom)

        const finalWidthPx = measuredWidth + paddingX * 2;
        const finalHeightPx = measuredHeight + paddingY;

        // 5️⃣ Convert to percentage (for your positioning system)
        const newWidthPercent = (finalWidthPx / pageWidth) * 100;
        const newHeightPercent = (finalHeightPx / pageHeight) * 100;

        // Date format / text-only: keep y + height locked so the field does not drift down
        if (dateContentOnlyUpdate) {
          mergedAnnotation.y = currentAnnotation.y;
          mergedAnnotation.height = currentAnnotation.height;
          // Allow width to grow/shrink with the new date string; never move vertically
          if (type === "signer_date") {
            // signer_date already has special min-width handling below
          } else {
            mergedAnnotation.width = Math.max(
              currentAnnotation.width || 0,
              newWidthPercent
            );
          }
          mergedAnnotation.pageWidth = pageWidth;
        } else {
          // Keep Y position fixed from top-left when line height changes
          let newYPercent = currentAnnotation.y;

          // Only adjust Y when font size / family / style actually changed
          if (fontSizeChanged && !lineHeightChanged) {
            const heightDiffPx = finalHeightPx - oldHeightPx;
            const heightDiffPercent = (heightDiffPx / pageHeight) * 100;
            newYPercent = currentAnnotation.y - heightDiffPercent;
          } else if (fontFamilyChanged || formatStyleChanged) {
            // Keep bottom baseline fixed when family/style changes
            newYPercent = ((baselinePx - finalHeightPx) / pageHeight) * 100;
          }

          // 7️⃣ Special Handling for signer_text minimum width
          if (type === "signer_text") {
            const calculatedWidth = calculateTextWidth(
              "Text ....",
              newFontSize,
              newFontFamily
            );
            console.log("tet width", calculatedWidth);
            const minWidthPx = calculatedWidth;
            const minWidthPercent = (minWidthPx / pageWidth) * 100;
            if (mergedAnnotation.width < minWidthPercent) {
              mergedAnnotation.width = Math.max(newWidthPercent, minWidthPercent);
            }
          } else {
            mergedAnnotation.width = newWidthPercent;
          }

          mergedAnnotation.height = newHeightPercent;
          mergedAnnotation.y = newYPercent;
          mergedAnnotation.pageWidth = pageWidth;
        }

        // signer_date content-only: still enforce min width without touching y/height
        if (dateContentOnlyUpdate && type === "signer_date") {
          const calculatedWidth = calculateTextWidth(
            "Text ....",
            newFontSize,
            newFontFamily
          );
          const minWidthPercent = (calculatedWidth / pageWidth) * 100;
          mergedAnnotation.width = Math.max(
            currentAnnotation.width || 0,
            newWidthPercent,
            minWidthPercent
          );
        }
      }
    }

    // ✅ Update annotations state
    setAnnotations((prevAnnotations) => {
      const pageAnnotations = [...(prevAnnotations[pageNum] || [])];
      pageAnnotations[index] = mergedAnnotation;

      return {
        ...prevAnnotations,
        [pageNum]: pageAnnotations,
      };
    });

    // ✅ Sync updated styles to annotationSettings (optional)
    setAnnotationSettings((prevSettings) => ({
      ...prevSettings,
      [selectedAnnotation.type]: {
        ...prevSettings[selectedAnnotation.type],
        ...updatedProps,
      },
    }));

    // ✅ Global `isRequired` handling
    if (updatedProps.isRequired !== undefined) {
      setGlobalIsRequired(updatedProps.isRequired);
    }
  };

  const renderAnnotations = useCallback(
    (pageNum) => {
      if (pageNum === "_lastUpdate") return null;
      const pageAnnotations = annotations[pageNum] || [];
      // Add this safety check to ensure it's always an array
      if (!Array.isArray(pageAnnotations)) {
        return null;
      }
      const imageElem = document.querySelector(`#img-${pageNum} .pdf-image`);
      // if (!imageElem) return null; // Safe check if page not rendered yet
      if (!imageElem) {
        console.warn(`Image element not found for page ${pageNum}`);
        return null;
      }
      // const pageWidth = imageElem.offsetWidth;
      // const pageHeight = imageElem.offsetHeight;
      // Get the actual rendered PDF dimensions
      const imageRect = imageElem.getBoundingClientRect();
      if (!imageRect || imageRect.width <= 0 || imageRect.height <= 0) {
        console.warn(`Invalid image dimensions for page ${pageNum}`);
        return null;
      }
      const pageWidth = imageRect.width;
      const pageHeight = imageRect.height;
      return pageAnnotations
        .map((annot, index) => {
          // Add safety check for each annotation
          if (!annot || typeof annot !== "object") {
            console.warn(
              `Invalid annotation at page ${pageNum}, index ${index}:`,
              annot
            );
            return null;
          }
          // ✅ Add safety checks for required properties
          // const x = typeof annot.x === "number" ? annot.x : 0;
          // const y = typeof annot.y === "number" ? annot.y : 0;
          // const width = typeof annot.width === "number" ? annot.width : 10;
          // const height = typeof annot.height === "number" ? annot.height : 10;

          // const pixelX = (x / 100) * pageWidth;
          // const pixelY = (y / 100) * pageHeight;
          // const pixelWidth = (width / 100) * pageWidth;
          // const pixelHeight = (height / 100) * pageHeight;
          const pixelX = (annot.x / 100) * pageWidth;
          const pixelY = (annot.y / 100) * pageHeight;
          const pixelWidth = (annot.width / 100) * pageWidth;
          let pixelHeight = (annot.height / 100) * pageHeight;

          const isEmptyText = !annot?.text || !String(annot.text).trim();
          const isMyTextLabel = annot.type === "my_text" && isEmptyText;
          const isSignerTextLabel =
            annot.type === "signer_text" && isEmptyText;
          const isDateLabel = annot.type === "date" && isEmptyText;
          const isSignerDateLabel =
            annot.type === "signer_date" &&
            (annot.text == null ||
              annot.text === "Date..." ||
              (typeof annot.text === "string" && !annot.text.trim()));
          const isAnyFieldLabel =
            isMyTextLabel ||
            isSignerTextLabel ||
            isDateLabel ||
            isSignerDateLabel;

          // Respect stored box height on reload (Math.min was crushing tall fields to one line).
          if (
            annot.type === "signer_text" ||
            annot.type === "my_text" ||
            annot.type === "date" ||
            annot.type === "signer_date"
          ) {
            const normalizedLineHeight = annot.lineHeight || 1;
            const baseFs =
              annot.type === "signer_text"
                ? Math.max(
                  10,
                  Math.min(
                    72,
                    annot.fontSize ||
                    annotationSettings.signer_text?.fontSize ||
                    21
                  )
                )
                : annot.type === "my_text"
                  ? Math.max(
                    10,
                    Math.min(
                      72,
                      annot.fontSize || annotationSettings.my_text?.fontSize || 21
                    )
                  )
                  : Math.max(
                    10,
                    Math.min(
                      72,
                      annot.fontSize ||
                      annotationSettings.date?.fontSize ||
                      annotationSettings.signer_date?.fontSize ||
                      annotationSettings.my_text?.fontSize ||
                      21
                    )
                  );
            const fsForMin = isAnyFieldLabel
              ? LABEL_PLACEHOLDER_FONT_PX
              : baseFs;
            const idealTextHeightPx = fsForMin * normalizedLineHeight;
            if (Number.isFinite(idealTextHeightPx) && idealTextHeightPx > 0) {
              pixelHeight = Math.max(pixelHeight, idealTextHeightPx);
            }
          }

          // Calculate pixel positions with rounding to prevent sub-pixel issues

          return (
            <Rnd
              size={{ width: pixelWidth, height: pixelHeight }}
              position={{ x: pixelX, y: pixelY }}
              // className="react-rnd-resizable-handle"
              // scale={scale}
              key={`${pageNum}-${index}`}
              data-annot-id={`${pageNum}-${annot.id}`}
              default={{
                x: annot.x,
                y: annot.y,
              }}
              bounds="parent"
              dragGrid={annot.type === "my_text" ? [1, 1] : [5, 5]}
              // size={{ width: annot.width, height: annot.height }}
              // position={{ x: annot.x, y: annot.y }}
              enableResizing={
                !isDragging &&
                activeAnnotation === `${pageNum}-${index}` &&
                annot.type !== "checkmark" &&
                annot.type !== "signer_checkmark" &&
                getResizeHandles()
              }
              onClick={(e) => {
                e.stopPropagation();
                // Don't select if clicking on edit/delete buttons
                if (e.target.closest('.MuiIconButton-root')) {
                  return;
                }
                setActiveAnnotation(`${pageNum}-${index}`);
                handleAnnotationClick(pageNum, index, annot);
                if (shouldLockAspectRatio(annot.type)) {
                  setActiveAnnotation(`${pageNum}-${index}`);
                }
              }}
              onTouchStart={(e) => {
                // Stop propagation to prevent parent from capturing touch for text fields
                if (annot.type === "signer_text" || annot.type === "my_text") {
                  // Allow touch for buttons
                  if (!e.target.closest('.MuiIconButton-root')) {
                    e.stopPropagation();
                    e.nativeEvent.stopImmediatePropagation();
                  }
                }
              }}
              onTouchEnd={(e) => {
                if (annot.type === "signer_text" || annot.type === "my_text") {
                  if (!e.target.closest('.MuiIconButton-root')) {
                    e.stopPropagation();
                    e.nativeEvent.stopImmediatePropagation();
                  }
                }
              }}
              onMouseDown={(e) => {
                // Don't interfere with button clicks
                if (e.target.closest('.MuiIconButton-root')) {
                  return;
                }
                if (shouldLockAspectRatio(annot.type)) {
                  setActiveAnnotation(`${pageNum}-${index}`);
                }
              }}
              disableDragging={isResizing || isInteracting}
              // cancel=".react-rnd-resizable-handle"
              enableUserSelectHack={false}
              style={{
                transition:
                  isDragging || isResizing || isDeleting
                    ? "none"
                    : "transform 0.15s ease-out",
                cursor: isDragging
                  ? "move !important"
                  : isResizing
                    ? "nwse-resize !important"
                    : "move !important",
                touchAction: (annot.type === "signer_text" || annot.type === "my_text") ? "manipulation" : "auto",
                WebkitTapHighlightColor: (annot.type === "signer_text" || annot.type === "my_text") ? "transparent" : "auto",
                pointerEvents: "auto",
                zIndex: (annot.type === "signer_text" || annot.type === "my_text") ? 9998 : 5,
                isolation: (annot.type === "signer_text" || annot.type === "my_text") ? "isolate" : "auto",
                overflow: (annot.type === "signer_text" || annot.type === "my_text" || annot.type === "date" || annot.type === "signer_date") ? "visible" : undefined,
                outline: (annot.type === "checkmark" || annot.type === "signer_checkmark") ? "none" : undefined,
                boxShadow: (annot.type === "checkmark" || annot.type === "signer_checkmark") ? "none" : undefined,
              }}
              onDragStart={(e) => {
                // Don't drag if clicking on buttons
                if (e.target.closest('.MuiIconButton-root')) {
                  e.preventDefault();
                  return;
                }
                e.stopPropagation();
                setIsDragging(true);
                setIsInteracting(true);
                document.body.style.cursor = "move";
              }}
              onDragStop={(e, d) => {
                setIsDragging(false);

                setTimeout(() => {
                  setIsInteracting(false);
                }, 300);
                const imageElem = document.querySelector(
                  `#img-${pageNum} .pdf-image`
                );
                const imageRect = imageElem.getBoundingClientRect();

                // Calculate relative positions while maintaining scale
                // const relativeX = d.x / scale;
                // const relativeY = d.y / scale;
                const relativeX = (d.x / pageWidth) * 100;
                const relativeY = (d.y / pageHeight) * 100;
                setAnnotations((prev) => ({
                  ...prev,
                  [pageNum]: prev[pageNum].map((a, i) =>
                    i === index ? { ...a, x: relativeX, y: relativeY } : a
                  ),
                }));

                // Reset cursor back to move after drag
                document.body.style.cursor = "move";
              }}
              onResizeStart={(e, direction, ref) => {
                e.stopPropagation();
                setIsResizing(true);
                setIsInteracting(true);
                if (cursorRef.current) {
                  cursorRef.current.style.display = "none";
                }
                const resizeCursors = {
                  bottomRight: "nwse-resize",
                  topLeft: "nwse-resize",
                  bottomLeft: "nesw-resize",
                  topRight: "nesw-resize",
                };
                document.body.style.cursor = resizeCursors[direction] || "nwse-resize";
              }}
              onResize={(e, direction, ref, delta, position) => {
                if (cursorRef.current) cursorRef.current.style.display = "none";
                const resizeCursorsMap = { bottomRight: "nwse-resize", topLeft: "nwse-resize", bottomLeft: "nesw-resize", topRight: "nesw-resize" };
                document.body.style.cursor = resizeCursorsMap[direction] || "nwse-resize";
                if (!isDragging) {
                  const imageElem = document.querySelector(
                    `#img-${pageNum} .pdf-image`
                  );

                  let newWidth = (ref.offsetWidth / pageWidth) * 100;
                  let newHeight = (ref.offsetHeight / pageHeight) * 100;
                  let newX = (position.x / pageWidth) * 100;
                  let newY = (position.y / pageHeight) * 100;
                  // For all types except signer_text, we allow free resizing or aspect ratio lock
                  if (annot.type === "highlight" || annot.type === "my_text") {
                    // No minimum width - allow free resizing
                    newHeight = Math.max(1, newHeight);
                    // newWidth = newWidth;
                    // newHeight = newHeight;
                  } else if (annot.type === "signer_chooseImgStamp") {
                    newWidth = Math.max(4, newWidth);
                    newHeight = Math.max(4, newHeight);
                  } else if (
                    annot.type === "signer_chooseImgDrivingL" ||
                    annot.type === "signer_chooseImgPassportPhoto"
                  ) {
                    newWidth = Math.max(15, newWidth);
                    newHeight = Math.max(12, newHeight);
                  }

                  // Restrict to bounds
                  // newWidth = Math.min(newWidth, pageWidth - newX);
                  // newHeight = Math.min(newHeight, pageHeight - newY);
                  // Ensure within bounds
                  newWidth = Math.min(newWidth, 100 - newX);
                  newHeight = Math.min(newHeight, 100 - newY);

                  console.log("newWidth11", newWidth);
                  console.log("newHeight11", newHeight);
                  if (annot.type === "signer_text") {
                    // No minimum width - allow free resizing
                    setTextFieldMetrics((prev) => ({
                      ...prev,
                      width: newWidth * scale,
                    }));
                    // ✅ Special handling for `signer_text` - only allow width resize
                    requestAnimationFrame(() => {
                      setAnnotations((prev) => ({
                        ...prev,
                        [pageNum]: prev[pageNum].map((a, i) =>
                          i === index
                            ? {
                              ...a,
                              width: newWidth,
                              x: newX, // Allow dragging too
                              y: newY, // Allow dragging too
                              pageWidth: pageWidth, // Update page width reference for font scaling
                            }
                            : a
                        ),
                      }));
                    });

                    // Optional: Update annotation settings for signer_text width
                    setAnnotationSettings((prev) => ({
                      ...prev,
                      [annot.type]: {
                        ...prev[annot.type],
                        width: (newWidth / 100) * pageWidth,
                      },
                    }));
                  } else if (annot.type === "my_text") {
                    // Regular resizing for my_text - keep X and Y fixed (anchor from top-left)
                    requestAnimationFrame(() => {
                      setAnnotations((prev) => {
                        const currentAnnot = prev[pageNum][index];
                        return {
                          ...prev,
                          [pageNum]: prev[pageNum].map((a, i) =>
                            i === index
                              ? {
                                ...a,
                                width: newWidth,
                                height: newHeight,
                                x: currentAnnot.x, // Keep X fixed (top-left anchor)
                                y: currentAnnot.y, // Keep Y fixed (top-left anchor)
                                pageWidth: pageWidth, // Update page width reference for font scaling
                              }
                              : a
                          ),
                        };
                      });
                    });
                  } else if (annot.type === "date" || annot.type === "signer_date") {
                    // Date fields - same resize behavior as my_text (keep X and Y fixed from top-left)
                    requestAnimationFrame(() => {
                      setAnnotations((prev) => {
                        const currentAnnot = prev[pageNum][index];
                        return {
                          ...prev,
                          [pageNum]: prev[pageNum].map((a, i) =>
                            i === index
                              ? {
                                ...a,
                                width: newWidth,
                                height: newHeight,
                                x: currentAnnot.x, // Keep X fixed (top-left anchor)
                                y: currentAnnot.y, // Keep Y fixed (top-left anchor)
                                pageWidth: pageWidth, // Update page width reference for font scaling
                              }
                              : a
                          ),
                        };
                      });
                    });
                  } else if (shouldLockAspectRatio(annot.type)) {
                    // Other image-based types keep aspect ratio
                    const aspectRatio = annot.width / annot.height;
                    newHeight = newWidth / aspectRatio;

                    console.log("newWidth", newWidth);
                    console.log("newHeight", newHeight);
                    requestAnimationFrame(() => {
                      setAnnotations((prev) => ({
                        ...prev,
                        [pageNum]: prev[pageNum].map((a, i) =>
                          i === index
                            ? {
                              ...a,
                              width: newWidth,
                              height: newHeight,
                              x: newX,
                              y: newY,
                            }
                            : a
                        ),
                      }));
                    });

                    setAnnotationSettings((prev) => ({
                      ...prev,
                      [annot.type]: {
                        ...prev[annot.type],
                        width: (newWidth / 100) * pageWidth,
                        height: (newHeight / 100) * pageHeight,
                      },
                    }));
                  } else {
                    // Other free-form types (highlight etc.)
                    requestAnimationFrame(() => {
                      setAnnotations((prev) => ({
                        ...prev,
                        [pageNum]: prev[pageNum].map((a, i) =>
                          i === index
                            ? {
                              ...a,
                              width: newWidth,
                              height: newHeight,
                              x: newX,
                              y: newY,
                            }
                            : a
                        ),
                      }));
                    });

                    setAnnotationSettings((prev) => ({
                      ...prev,
                      [annot.type]: {
                        ...prev[annot.type],
                        width: newWidth,
                        height: newHeight,
                      },
                    }));
                  }

                  // if (annot.type === "signer_text") {
                  //   setAnnotations((prev) => ({
                  //     ...prev,
                  //     [pageNum]: prev[pageNum].map((a, i) =>
                  //       i === index
                  //         ? { ...a, width: newWidth, x: newX, y: newY }
                  //         : a
                  //     ),
                  //   }));
                  // } else if (shouldLockAspectRatio(annot.type)) {
                  //   const aspectRatio = annot.width / annot.height;
                  //   newHeight = newWidth / aspectRatio;

                  //   setAnnotations((prev) => ({
                  //     ...prev,
                  //     [pageNum]: prev[pageNum].map((a, i) =>
                  //       i === index
                  //         ? {
                  //             ...a,
                  //             width: newWidth,
                  //             height: newHeight,
                  //             x: newX,
                  //             y: newY,
                  //           }
                  //         : a
                  //     ),
                  //   }));
                  // } else {
                  //   setAnnotations((prev) => ({
                  //     ...prev,
                  //     [pageNum]: prev[pageNum].map((a, i) =>
                  //       i === index
                  //         ? {
                  //             ...a,
                  //             width: newWidth,
                  //             height: newHeight,
                  //             x: newX,
                  //             y: newY,
                  //           }
                  //         : a
                  //     ),
                  //   }));
                  // }
                }
              }}
              onResizeStop={(e, direction, ref, delta, position) => {
                setIsResizing(false);
                setTimeout(() => {
                  setIsInteracting(false);
                }, 300);
                document.body.style.cursor = "move";
                // cursorRef.current.style.display = "block"; // Restore custom cursor
                // document.body.style.cursor = "default";
                setActiveAnnotation(`${pageNum}-${index}`);
                if (
                  annot.type === "my_signature" ||
                  annot.type === "my_initials" ||
                  annot.type === "signer_initials" ||
                  annot.type === "signer_initials_text"
                ) {
                  let newWidth = (ref.offsetWidth / pageWidth) * 100;
                  let newHeight = (ref.offsetHeight / pageHeight) * 100;
                  const newX = (position.x / pageWidth) * 100;
                  const newY = (position.y / pageHeight) * 100;
                  newWidth = Math.min(newWidth, 100 - newX);
                  newHeight = Math.min(newHeight, 100 - newY);
                  if (newWidth > 0.5 && newHeight > 0.5) {
                    if (annot.type === "my_signature") {
                      lastMeSignatureDimensionsRef.current = {
                        width: newWidth,
                        height: newHeight,
                      };
                    } else if (annot.type === "my_initials") {
                      lastMeInitialsDimensionsRef.current = {
                        width: newWidth,
                        height: newHeight,
                      };
                    } else if (annot.type === "signer_initials") {
                      lastSignerSignatureDimensionsRef.current = {
                        width: newWidth,
                        height: newHeight,
                      };
                    } else if (annot.type === "signer_initials_text") {
                      lastSignerInitialsDimensionsRef.current = {
                        width: newWidth,
                        height: newHeight,
                      };
                    }
                  }
                }
              }}
              resizeHandleClasses={{
                bottomRight: "react-rnd-resizable-handle react-rnd-resizable-handle-se",
                bottomLeft: "react-rnd-resizable-handle react-rnd-resizable-handle-sw",
                topLeft: "react-rnd-resizable-handle react-rnd-resizable-handle-nw",
                topRight: "react-rnd-resizable-handle react-rnd-resizable-handle-ne",
              }}
              resizeHandleStyles={{
                bottomRight: {
                  width: "16px",
                  height: "16px",
                  background: "rgb(0, 145, 255)",
                  borderRadius: "50%",
                  bottom: "-8px",
                  right: "-8px",
                  zIndex: 10001,
                  pointerEvents: "auto",
                  border: "2px solid white",
                  boxShadow: "0 2px 4px rgba(0,0,0,0.2)",
                  transition: "all 0.2s ease",
                },
                bottomLeft: {
                  width: "16px",
                  height: "16px",
                  background: "rgb(0, 145, 255)",
                  borderRadius: "50%",
                  bottom: "-8px",
                  left: "-8px",
                  zIndex: 10001,
                  pointerEvents: "auto",
                  border: "2px solid white",
                  boxShadow: "0 2px 4px rgba(0,0,0,0.2)",
                  transition: "all 0.2s ease",
                },
                topLeft: {
                  width: "16px",
                  height: "16px",
                  background: "rgb(0, 145, 255)",
                  borderRadius: "50%",
                  top: "-8px",
                  left: "-8px",
                  zIndex: 10001,
                  pointerEvents: "auto",
                  border: "2px solid white",
                  boxShadow: "0 2px 4px rgba(0,0,0,0.2)",
                  transition: "all 0.2s ease",
                },
                topRight: {
                  width: "16px",
                  height: "16px",
                  background: "rgb(0, 145, 255)",
                  borderRadius: "50%",
                  top: "-8px",
                  right: "-8px",
                  zIndex: 10001,
                  pointerEvents: "auto",
                  border: "2px solid white",
                  boxShadow: "0 2px 4px rgba(0,0,0,0.2)",
                  transition: "all 0.2s ease",
                },
              }}
            >
              <Box
                className="annotation"
                data-type={annot.type}
                sx={{
                  position: "absolute",
                  top: 0,
                  left: 0,
                  right: 0,
                  bottom: 0,
                  width: "100%",
                  height: "100%",
                  display: "flex",
                  cursor: "move !important",
                  alignItems:
                    annot.type === "my_text" && isMyTextLabel
                      ? "center"
                      : annot.type === "my_text"
                        ? "flex-start"
                        : "center",
                  transition:
                    isDragging || isResizing || isDeleting
                      ? "none"
                      : "width 0.1s ease-out",
                  boxSizing: "border-box",
                  margin: 0,
                  padding: 0,
                  "&:hover": {
                    cursor: "move !important",
                    "& .resize-handle": {
                      opacity: 1,
                    },
                  },
                }}
              >
                {annot?.type === "my_text" ? (
                  // Box annotation that displays text and fits it within the box
                  <Box
                    onClick={(e) => {
                      // Don't select if clicking on buttons
                      if (e.target.closest('.MuiIconButton-root')) {
                        return;
                      }
                      e.stopPropagation();
                      setFocusedAnnotation(`${pageNum}-${index}`);
                      handleAnnotationClick(pageNum, index, annot);
                    }}
                    onDoubleClick={(e) => {
                      if (e.target.closest('.MuiIconButton-root')) {
                        return;
                      }
                      e.stopPropagation();
                      e.preventDefault();
                      handleEditText(pageNum, index, annot);
                    }}
                    onMouseEnter={(e) => {
                      e.stopPropagation();
                      if (!e.target.closest('.MuiIconButton-root')) {
                        document.body.style.cursor = "move";
                      }
                      if (cursorRef.current) {
                        cursorRef.current.style.display = "none";
                      }
                    }}
                    onMouseLeave={(e) => {
                      e.stopPropagation();
                      // Don't manage cursor here - let the main moveCursor handler do it
                      // This prevents cursor blinking and ensures consistent behavior
                      // The main handler will show cursor when over PDF container
                    }}
                    sx={{
                      position: "absolute",
                      top: 0,
                      left: 0,
                      right: 0,
                      bottom: 0,
                      width: "100%",
                      height: "100%",
                      padding: "0px",
                      margin: "0px",
                      display: "flex",
                      flexDirection: "column",
                      alignItems: isMyTextLabel
                        ? "center"
                        : annot.alignment === "center"
                          ? "center"
                          : annot.alignment === "right"
                            ? "flex-end"
                            : "flex-start",
                      justifyContent: isMyTextLabel
                        ? "center"
                        : annot.alignment === "center"
                          ? "center"
                          : annot.alignment === "right"
                            ? "flex-end"
                            : "flex-start",
                      overflow: "visible",
                      overflowY: "visible",
                      overflowX: "auto",
                      cursor: "move",
                      boxSizing: "border-box",
                      gap: 0,
                      fontFamily: annot.fontFamily || annotationSettings.my_text?.fontFamily || "Helvetica, Arial, sans-serif",
                      fontSize: `${isMyTextLabel ? LABEL_PLACEHOLDER_FONT_PX : Math.max(
                        10,
                        Math.min(72, annot.fontSize || annotationSettings.my_text?.fontSize || 21)
                      )}px`,
                      color:
                        annot?.text && annot.text.trim()
                          ? annot.color || "rgba(0, 0, 0, 0.87)"
                          : PLACEHOLDER_LABEL_COLOR,
                      letterSpacing: annot.letterSpacing || 0,
                      opacity: annot.opacity || 1,
                      backgroundColor:
                        annot.backgroundColor || "rgba(0, 247, 255, 0.25)",
                      textAlign: isMyTextLabel ? "center" : annot.alignment || "left",
                      fontWeight: annot.format?.includes("bold")
                        ? "bold"
                        : "normal",
                      fontStyle: annot.format?.includes("italic")
                        ? "italic"
                        : "normal",
                      textDecoration: annot.format?.includes("underline")
                        ? "underline"
                        : "none",
                      border:
                        activeAnnotationId === `${pageNum}-${index}`
                          ? "2px solid rgb(0, 145, 255)"
                          : "1px solid rgba(0, 145, 255, 0.3)",
                      "&:hover": {
                        border: "2px solid rgb(0, 145, 255)",
                        backgroundColor: "rgba(0, 247, 255, 0.3)",
                      },
                      transition: "all 0.2s ease",
                      pointerEvents: "auto",
                      zIndex: 9999,
                      isolation: "isolate",
                    }}
                  >
                    <p
                      style={{
                        width: "100%",
                        height: "100%",
                        margin: "0",
                        padding: "0",
                        overflowX: "auto",
                        overflowY: "hidden",
                        whiteSpace: "nowrap",
                        fontFamily: "inherit",
                        fontSize: "inherit",
                        color: "inherit",
                        letterSpacing: "inherit",
                        fontWeight: "inherit",
                        fontStyle: "inherit",
                        textDecoration: "inherit",
                        textAlign: isMyTextLabel ? "center" : annot.alignment || "left",
                        lineHeight: annot.lineHeight ?? 1,
                        boxSizing: "border-box",
                        ...(isMyTextLabel
                          ? {
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                          }
                          : {}),
                      }}
                    >
                      {(annot?.text && annot.text.trim()) ? annot.text : "TEXT"}
                    </p>
                  </Box>
                ) : null}
                {annot?.type === "signer_text" ? (
                  <Box
                    onClick={(e) => {
                      // Don't select if clicking on buttons
                      if (e.target.closest('.MuiIconButton-root')) {
                        return;
                      }
                      e.stopPropagation();
                      setFocusedAnnotation(`${pageNum}-${index}`);
                      handleAnnotationClick(pageNum, index, annot);
                    }}
                    onMouseEnter={(e) => {
                      e.stopPropagation();
                      if (!e.target.closest('.MuiIconButton-root')) {
                        document.body.style.cursor = "move";
                      }
                      if (cursorRef.current) {
                        cursorRef.current.style.display = "none";
                      }
                    }}
                    onMouseLeave={(e) => {
                      e.stopPropagation();
                      // Don't manage cursor here - let the main moveCursor handler do it
                      // This prevents cursor blinking and ensures consistent behavior
                      // The main handler will show cursor when over PDF container
                    }}
                    sx={{
                      position: "absolute",
                      top: 0,
                      left: 0,
                      right: 0,
                      bottom: 0,
                      width: "100%",
                      height: "100%",
                      padding: "0px",
                      margin: "0px",
                      display: "flex",
                      flexDirection: "column",
                      alignItems: isSignerTextLabel
                        ? "center"
                        : annot.alignment === "center"
                          ? "center"
                          : annot.alignment === "right"
                            ? "flex-end"
                            : "flex-start",
                      justifyContent: isSignerTextLabel
                        ? "center"
                        : annot.alignment === "center"
                          ? "center"
                          : annot.alignment === "right"
                            ? "flex-end"
                            : "flex-start",
                      overflow: "hidden",
                      cursor: "move",
                      boxSizing: "border-box",
                      gap: 0,
                      fontFamily: annot.fontFamily || annotationSettings.signer_text?.fontFamily || "Helvetica, Arial, sans-serif",
                      fontSize: `${isSignerTextLabel ? LABEL_PLACEHOLDER_FONT_PX : Math.max(
                        10,
                        Math.min(72, annot.fontSize || annotationSettings.signer_text?.fontSize || 21)
                      )}px`,
                      color:
                        annot?.text && annot.text.trim()
                          ? annot.color || "rgba(0, 0, 0, 0.87)"
                          : PLACEHOLDER_LABEL_COLOR,
                      letterSpacing: annot.letterSpacing || 0,
                      opacity: annot.opacity || 1,
                      backgroundColor: getColorWithNewOpacity(
                        getSignerColorById(annot.signerId, signers),
                        annot.isRequired
                      ),
                      textAlign: isSignerTextLabel ? "center" : annot.alignment || "left",
                      fontWeight: annot.format?.includes("bold")
                        ? "bold"
                        : "normal",
                      fontStyle: annot.format?.includes("italic")
                        ? "italic"
                        : "normal",
                      textDecoration: annot.format?.includes("underline")
                        ? "underline"
                        : "none",
                      border:
                        activeAnnotationId === `${pageNum}-${index}`
                          ? "2px solid rgb(0, 145, 255)"
                          : "1px solid rgba(0, 0, 0, 0.23)",
                      "&:hover": {
                        border: `2px solid ${annot.borderColor || "rgb(0, 145, 255)"}`,
                        backgroundColor: getColorWithNewOpacity(
                          getSignerColorById(annot.signerId, signers),
                          annot.isRequired,
                          0.3
                        ),
                      },
                      transition: "all 0.2s ease",
                      pointerEvents: "auto",
                      zIndex: 9999,
                      isolation: "isolate",
                    }}
                  >
                    <p
                      style={{
                        width: "100%",
                        height: "100%",
                        margin: "0",
                        padding: "0",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap",
                        fontFamily: "inherit",
                        fontSize: "inherit",
                        color: "inherit",
                        letterSpacing: "inherit",
                        fontWeight: "inherit",
                        fontStyle: "inherit",
                        textDecoration: "inherit",
                        textAlign: isSignerTextLabel ? "center" : annot.alignment || "left",
                        lineHeight: annot.lineHeight ?? 1,
                        boxSizing: "border-box",
                        ...(isSignerTextLabel
                          ? {
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                          }
                          : {}),
                      }}
                    >
                      {(annot?.text && annot.text.trim()) ? annot.text : "TEXT"}
                    </p>
                  </Box>
                ) : null}

                {annot?.type === "checkmark" && (
                  <Box
                    sx={{
                      width: "100%",
                      height: "100%",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: isDateLabel ? "center" : "flex-end",
                      cursor: "move !important",
                      pointerEvents: "auto",
                      backgroundColor: "transparent",
                      border:
                        activeAnnotationId === `${pageNum}-${index}`
                          ? "2px solid rgb(0, 145, 255)"
                          : "1px solid rgba(0, 0, 0, 0.54)",
                      borderRadius: "4px",
                      boxShadow: "none",
                      outline: "none",
                      "&:hover": {
                        border: "2px solid rgb(0, 145, 255)",
                        cursor: "move !important",
                      },
                      "& *": {
                        cursor: "move !important",
                        pointerEvents: "auto !important",
                      },
                    }}
                    className="checkbox-annotation"
                    onMouseEnter={(e) => {
                      e.stopPropagation();
                      document.body.style.cursor = "move";
                      if (cursorRef.current) {
                        cursorRef.current.style.display = "none";
                      }
                    }}
                    onMouseLeave={(e) => {
                      e.stopPropagation();
                      if (isAnnotating && !focusedAnnotation) {
                        document.body.style.cursor = "none";
                        if (cursorRef.current) {
                          cursorRef.current.style.display = "block";
                        }
                      }
                    }}
                  >
                    {annot.checked ? (
                      <CheckBoxIcon
                        sx={{
                          width: "100%",
                          height: "100%",
                          color: "rgb(0, 145, 255)",
                          cursor: "move !important",
                          pointerEvents: "auto",
                        }}
                      />
                    ) : (
                      <CheckBoxOutlineBlankIcon
                        sx={{
                          width: "100%",
                          height: "100%",
                          color: "rgba(0, 0, 0, 0.54)",
                          cursor: "move !important",
                          pointerEvents: "auto",
                        }}
                      />
                    )}
                  </Box>
                )}
                {annot?.type === "signer_checkmark" && (
                  <Box
                    sx={{
                      width: "100%",
                      height: "100%",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: isSignerDateLabel ? "center" : "flex-end",
                      backgroundColor: "transparent",
                      border:
                        activeAnnotationId === `${pageNum}-${index}`
                          ? `2px solid ${getSignerColorById(annot.signerId, signers) || "rgb(0, 145, 255)"}`
                          : `1px solid ${getSignerColorById(annot.signerId, signers) || "rgba(0, 0, 0, 0.54)"}`,
                      borderRadius: "4px",
                      boxShadow: "none",
                      outline: "none",
                      cursor: "move",
                      "&:hover": {
                        border: `2px solid ${getSignerColorById(annot.signerId, signers) || "rgb(0, 145, 255)"}`,
                        cursor: "move",
                      },
                    }}
                  >
                    {annot.checked ? (
                      <CheckBoxIcon
                        sx={{
                          width: "100%",
                          height: "100%",
                          color: getSignerColorById(annot.signerId, signers) || "rgb(0, 145, 255)",
                          cursor: "move",
                        }}
                      />
                    ) : (
                      <CheckBoxOutlineBlankIcon
                        sx={{
                          width: "100%",
                          height: "100%",
                          color: getSignerColorById(annot.signerId, signers) || "rgba(0, 0, 0, 0.54)",
                          cursor: "move",
                        }}
                      />
                    )}
                  </Box>
                )}
                {annot?.type === "date" && (
                  <Box
                    onClick={(e) => {
                      if (e.target.closest('.MuiIconButton-root')) {
                        return;
                      }
                      e.stopPropagation();
                      setFocusedAnnotation(`${pageNum}-${index}`);
                      handleAnnotationClick(pageNum, index, annot);
                    }}
                    onMouseEnter={(e) => {
                      e.stopPropagation();
                      if (!e.target.closest('.MuiIconButton-root')) {
                        document.body.style.cursor = "move";
                      }
                      if (cursorRef.current) {
                        cursorRef.current.style.display = "none";
                      }
                    }}
                    onMouseLeave={(e) => {
                      e.stopPropagation();
                      // Don't manage cursor here - let the main moveCursor handler do it
                      // This prevents cursor blinking and ensures consistent behavior
                      // The main handler will show cursor when over PDF container
                    }}
                    sx={{
                      position: "absolute",
                      top: 0,
                      left: 0,
                      right: 0,
                      bottom: 0,
                      width: "100%",
                      height: "100%",
                      padding: "2px 4px",
                      margin: "0px",
                      display: "flex",
                      flexDirection: "column",
                      alignItems: isDateLabel
                        ? "center"
                        : annot.alignment === "center"
                          ? "center"
                          : annot.alignment === "right"
                            ? "flex-end"
                            : "flex-start",
                      justifyContent: "center",
                      overflow: "visible",
                      overflowY: "visible",
                      overflowX: "visible",
                      cursor: "move",
                      boxSizing: "border-box",
                      gap: 0,
                      fontFamily: annot.fontFamily || annotationSettings.my_text?.fontFamily || "Helvetica, Arial, sans-serif",
                      fontSize: `${isDateLabel ? LABEL_PLACEHOLDER_FONT_PX : Math.max(
                        10,
                        Math.min(72, annot.fontSize || annotationSettings.my_text?.fontSize || 21)
                      )}px`,
                      color:
                        annot?.text && annot.text.trim()
                          ? annot.color || "rgba(0, 0, 0, 0.87)"
                          : PLACEHOLDER_LABEL_COLOR,
                      letterSpacing: annot.letterSpacing || 0,
                      opacity: annot.opacity || 1,
                      backgroundColor: annot.backgroundColor || "rgba(0, 247, 255, 0.25)",
                      textAlign: isDateLabel ? "center" : annot.alignment || "left",
                      fontWeight: annot.format?.includes("bold")
                        ? "bold"
                        : "normal",
                      fontStyle: annot.format?.includes("italic")
                        ? "italic"
                        : "normal",
                      textDecoration: annot.format?.includes("underline")
                        ? "underline"
                        : "none",
                      border:
                        activeAnnotationId === `${pageNum}-${index}`
                          ? "2px solid rgb(0, 145, 255)"
                          : "1px solid rgba(0, 145, 255, 0.3)",
                      "&:hover": {
                        border: "2px solid rgb(0, 145, 255)",
                        backgroundColor: "rgba(0, 247, 255, 0.3)",
                        cursor: "move",
                      },
                      transition: "all 0.2s ease",
                      pointerEvents: "auto",
                      zIndex: 9999,
                      isolation: "isolate",
                      "& p": {
                        margin: "0",
                        padding: "0",
                        lineHeight: annot.lineHeight ?? 1,
                      },
                    }}
                  >
                    <p
                      style={{
                        width: "100%",
                        height: "auto",
                        margin: "0",
                        padding: "0",
                        overflow: "visible",
                        whiteSpace: "nowrap",
                        fontFamily: "inherit",
                        fontSize: "inherit",
                        color: "inherit",
                        letterSpacing: "inherit",
                        fontWeight: "inherit",
                        fontStyle: "inherit",
                        textDecoration: "inherit",
                        textAlign: isDateLabel ? "center" : annot.alignment || "left",
                        lineHeight: isDateLabel ? 1 : annot.lineHeight ?? 1,
                        boxSizing: "border-box",
                        ...(isDateLabel
                          ? {
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            height: "100%",
                          }
                          : {}),
                      }}
                    >
                      {(annot?.text && annot.text.trim()) ? annot.text : "DATE"}
                    </p>
                  </Box>
                )}
                {annot?.type === "signer_date" && (
                  <Box
                    onClick={(e) => {
                      if (e.target.closest('.MuiIconButton-root')) {
                        return;
                      }
                      e.stopPropagation();
                      setFocusedAnnotation(`${pageNum}-${index}`);
                      handleAnnotationClick(pageNum, index, annot);
                    }}
                    onMouseEnter={(e) => {
                      e.stopPropagation();
                      if (!e.target.closest('.MuiIconButton-root')) {
                        document.body.style.cursor = "move";
                      }
                      if (cursorRef.current) {
                        cursorRef.current.style.display = "none";
                      }
                    }}
                    onMouseLeave={(e) => {
                      e.stopPropagation();
                    }}
                    sx={{
                      position: "absolute",
                      top: 0,
                      left: 0,
                      right: 0,
                      bottom: 0,
                      width: "100%",
                      height: "100%",
                      padding: "2px 4px",
                      margin: "0px",
                      display: "flex",
                      flexDirection: "column",
                      alignItems: isSignerDateLabel ? "center" : "flex-start",
                      justifyContent: "center",
                      overflow: "visible",
                      overflowY: "visible",
                      overflowX: "visible",
                      cursor: "move",
                      boxSizing: "border-box",
                      gap: 0,
                      fontFamily: annot.fontFamily || annotationSettings.signer_text?.fontFamily || "Helvetica, Arial, sans-serif",
                      fontSize: `${isSignerDateLabel ? LABEL_PLACEHOLDER_FONT_PX : Math.max(
                        10,
                        Math.min(72, annot.fontSize || annotationSettings.signer_text?.fontSize || 21)
                      )}px`,
                      color:
                        annot?.text && annot.text.trim() && annot.text !== "Date..."
                          ? "rgba(0, 0, 0, 0.87)"
                          : PLACEHOLDER_LABEL_COLOR,
                      letterSpacing: annot.letterSpacing || 0,
                      opacity: annot.opacity || 1,
                      backgroundColor: getColorWithNewOpacity(
                        getSignerColorById(annot.signerId, signers),
                        annot.isRequired
                      ),
                      textAlign: isSignerDateLabel ? "center" : "left",
                      fontWeight: annot.format?.includes("bold") ? "bold" : "normal",
                      fontStyle: annot.format?.includes("italic") ? "italic" : "normal",
                      textDecoration: annot.format?.includes("underline") ? "underline" : "none",
                      border: activeAnnotationId === `${pageNum}-${index}`
                        ? "2px solid rgb(0, 145, 255)"
                        : "1px solid rgba(0, 0, 0, 0.23)",
                      "&:hover": {
                        border: "2px solid rgb(0, 145, 255)",
                      },
                      transition: "all 0.2s ease",
                      pointerEvents: "auto",
                      zIndex: 9999,
                      isolation: "isolate",
                    }}
                  >
                    <p
                      style={{
                        width: "100%",
                        height: "auto",
                        margin: "0",
                        padding: "0",
                        overflow: "visible",
                        whiteSpace: "nowrap",
                        fontFamily: "inherit",
                        fontSize: "inherit",
                        color: "inherit",
                        letterSpacing: "inherit",
                        fontWeight: "inherit",
                        fontStyle: "inherit",
                        textDecoration: "inherit",
                        textAlign: isSignerDateLabel ? "center" : "left",
                        lineHeight: isSignerDateLabel ? 1 : annot.lineHeight ?? 1,
                        boxSizing: "border-box",
                        ...(isSignerDateLabel
                          ? {
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            height: "100%",
                          }
                          : {}),
                      }}
                    >
                      {(!annot?.text || annot?.text === "Date...") ? "DATE" : annot.text}
                    </p>
                  </Box>
                )}
                {annot?.type === "highlight" && (
                  <Box
                    sx={{
                      width: pixelWidth,
                      height: pixelHeight,
                      // width: "100%",
                      // height: "100%",
                      backgroundColor:
                        annot.backgroundColor || "rgba(255, 255, 0, 0.3)",
                      border:
                        activeAnnotationId === `${pageNum}-${index}`
                          ? "2px solid rgb(0, 145, 255)"
                          : "1px solid rgba(0, 145, 255, 0.3)",
                      borderRadius: "2px",
                      cursor: "move !important",
                      "&:hover": {
                        border: "2px solid rgb(0, 145, 255)",
                        cursor: "move !important",
                      },
                    }}
                    onClick={(e) => {
                      e.stopPropagation();
                      setFocusedAnnotation(`${pageNum}-${index}`);
                      handleAnnotationClick(pageNum, index, annot);
                      setActiveAnnotation(`${pageNum}-${index}`);
                    }}
                  />
                )}
                {annot?.type === "my_signature" ||
                  annot.type === "my_initials" ? (
                  <Box
                    onClick={(e) => {
                      e.stopPropagation();
                      setFocusedAnnotation(`${pageNum}-${index}`);
                      handleAnnotationClick(pageNum, index, annot);
                    }}
                    sx={{
                      width: pixelWidth,
                      height: pixelHeight,
                      position: "relative",
                      cursor: "move !important",

                      transition: "all 0.2s ease-out",
                      backgroundColor:
                        annot.backgroundColor || "rgba(0, 247, 255, 0.25)",
                      border:
                        activeAnnotation === `${pageNum}-${index}`
                          ? "2px solid rgb(0, 145, 255)"
                          : "2px solid rgba(0, 145, 255, 0.5)",
                      borderRadius: "4px",
                      "&:hover": {
                        cursor: "move !important",
                      },
                      "& *": {
                        cursor: "move !important",
                      },
                    }}
                    onBlur={(e) => {
                      setFocusedAnnotation(null);
                    }}
                    onMouseEnter={(e) => {
                      e.stopPropagation();
                      document.body.style.cursor = "move";
                      if (cursorRef.current) {
                        cursorRef.current.style.display = "none";
                      }
                    }}
                    onMouseLeave={(e) => {
                      e.stopPropagation();
                      if (isAnnotating && !focusedAnnotation) {
                        document.body.style.cursor = "none";
                        if (cursorRef.current) {
                          cursorRef.current.style.display = "block";
                        }
                      }
                    }}
                  >
                    <div
                      style={{
                        width: "100%",
                        height: "100%",
                        position: "relative",
                        overflow: "hidden",
                        display: "flex",
                        alignItems: "flex-end",
                        justifyContent: "flex-start",
                        // padding: "4px",
                        // overflow: "hidden",
                      }}
                    >
                      {(annot.isLoading || loadingAnnotations.has(`${pageNum}-${index}`)) ? (
                        <Box
                          sx={{
                            width: "100%",
                            height: "100%",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            backgroundColor: "rgba(255, 255, 255, 0.8)",
                            border: "1px dashed rgba(0, 145, 255, 0.5)",
                            borderRadius: "4px",
                          }}
                        >
                          <CircularProgress
                            size={24}
                            sx={{
                              color: "rgb(0, 145, 255)",
                            }}
                          />
                        </Box>
                      ) : (
                        <img
                          src={annot.imageUrl}
                          alt="annotation"
                          style={{
                            maxWidth: "100%",
                            maxHeight: "100%",
                            objectFit: "contain",
                            objectPosition: "left bottom",
                            pointerEvents: "none",
                            transition: "all 0.2s ease-out",
                            display: "block",
                            cursor: "move !important",
                            opacity: loadingAnnotations.has(`${pageNum}-${index}`) ? 0.5 : 1,
                          }}
                          onMouseEnter={(e) => {
                            document.body.style.cursor = "move";
                            if (cursorRef.current) {
                              cursorRef.current.style.display = "none";
                            }
                          }}
                          onMouseLeave={(e) => {
                            if (isAnnotating && !focusedAnnotation) {
                              document.body.style.cursor = "none";
                              if (cursorRef.current) {
                                cursorRef.current.style.display = "block";
                              }
                            } else {
                              document.body.style.cursor = "move";
                            }
                          }}
                        />
                      )}
                    </div>
                  </Box>
                ) : null}
                {annot.type === "stamp" && (
                  <Box
                    sx={{
                      width: pixelWidth,
                      height: pixelHeight,
                      position: "relative",
                      cursor: "move !important",

                      transition: "all 0.2s ease-out",
                      border:
                        activeAnnotation === `${pageNum}-${index}`
                          ? "2px solid rgb(0, 145, 255)"
                          : "2px solid rgba(0, 145, 255, 0.5)",
                      borderRadius: "4px",
                      "&:hover": {
                        border: "2px solid rgb(0, 145, 255)",
                        cursor: "move !important",
                      },
                    }}
                  >
                    {annot.isLoading ? (
                      <Box
                        sx={{
                          width: "100%",
                          height: "100%",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          backgroundColor: "rgba(255, 255, 255, 0.8)",
                          border: "1px dashed rgba(0, 145, 255, 0.5)",
                          borderRadius: "4px",
                        }}
                      >
                        <CircularProgress
                          size={24}
                          sx={{
                            color: "rgb(0, 145, 255)",
                          }}
                        />
                      </Box>
                    ) : (
                      <img
                        src={annot.imageUrl}
                        alt="stamp"
                        style={{
                          width: pixelWidth,
                          height: pixelHeight,
                          objectFit: "contain",
                          pointerEvents: "none",
                        }}
                      />
                    )}
                  </Box>
                )}

                {[
                  "signer_initials",
                  "signer_initials_text",
                  "signer_chooseImgStamp",
                  "signer_chooseImgDrivingL",
                  "signer_chooseImgPassportPhoto",
                ].includes(annot.type) && (
                    <Box
                      onClick={(e) => {
                        e.stopPropagation();
                        setFocusedAnnotation(`${pageNum}-${index}`);
                        handleAnnotationClick(pageNum, index, annot);
                      }}
                      InputProps={{
                        readOnly: true,
                        style: { cursor: "move !important" },
                      }}
                      onMouseEnter={(e) => {
                        e.stopPropagation();
                        document.body.style.cursor = "move";
                        if (cursorRef.current) {
                          cursorRef.current.style.display = "none";
                        }
                      }}
                      onMouseLeave={(e) => {
                        e.stopPropagation();
                        if (isAnnotating && !focusedAnnotation) {
                          document.body.style.cursor = "none";
                          if (cursorRef.current) {
                            cursorRef.current.style.display = "block";
                          }
                        }
                      }}
                      sx={{
                        width: pixelWidth,
                        height: pixelHeight,
                        position: "relative",
                        cursor: "move !important",
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        justifyContent: "center",
                        // backgroundColor: `${annot?.signerColor}`,
                        backgroundColor: getColorWithNewOpacity(
                          getSignerColorById(annot.signerId, signers), // Use signerId to get color
                          annot.isRequired
                        ),
                        border:
                          activeAnnotationId === `${pageNum}-${index}`
                            ? "2px solid rgb(0, 145, 255)"
                            : "1px solid rgba(0, 145, 255, 0.3)",
                        borderRadius: "4px",
                        // gap: 0.5,
                        transition: "all 0.2s ease-out",
                        "&:hover": {
                          border: "2px solid rgb(0, 145, 255)",
                          cursor: "move !important",
                        },
                        "& *": {
                          cursor: "move !important",
                          pointerEvents: "auto !important",
                        },
                      }}
                    >
                      <>
                        <Box
                          sx={{
                            cursor: "move !important",
                            pointerEvents: "auto !important",
                          }}
                        >
                          {getSignerBoxContent(annot.type)?.icon}
                        </Box>
                        <Typography
                          variant="caption"
                          sx={{
                            color: "rgba(0, 0, 0, 0.87)",
                            fontSize: "19px",
                            textAlign: "center",
                            cursor: "move !important",
                            pointerEvents: "auto !important",
                          }}
                        >
                          {getSignerBoxContent(annot.type)?.text}
                        </Typography>
                      </>
                    </Box>
                  )}
                {annot.type === "signer_dropdown" && (
                  <>
                    <TextField
                      select
                      fullWidth
                      variant="outlined"
                      value=""
                      placeholder="Select..."
                      InputProps={{
                        readOnly: true,
                        style: { cursor: "move" },
                      }}
                      onClick={(e) => {
                        e.stopPropagation();
                        setFocusedAnnotation(`${pageNum}-${index}`);
                        handleAnnotationClick(pageNum, index, annot);
                      }}
                      onBlur={(e) => {
                        setFocusedAnnotation(null);
                      }}
                      onMouseEnter={(e) => {
                        e.stopPropagation();
                        document.body.style.cursor = "move";
                        if (cursorRef.current) {
                          cursorRef.current.style.display = "none";
                        }
                      }}
                      onMouseLeave={(e) => {
                        e.stopPropagation();
                        if (isAnnotating && !focusedAnnotation) {
                          document.body.style.cursor = "none";
                          if (cursorRef.current) {
                            cursorRef.current.style.display = "block";
                          }
                        }
                      }}
                      sx={{
                        "& .MuiOutlinedInput-root": {
                          backgroundColor: getColorWithNewOpacity(
                            getSignerColorById(annot.signerId, signers),
                            annot.isRequired
                          ),
                          width: pixelWidth,
                          height: pixelHeight,
                          cursor: "move !important",
                          "& .MuiSelect-select": {
                            cursor: "move !important",
                          },
                          "& .MuiOutlinedInput-input": {
                            cursor: "move !important",
                          },

                          border:
                            activeAnnotationId === `${pageNum}-${index}`
                              ? "2px solid rgb(0, 145, 255)"
                              : "1px solid rgba(0, 0, 0, 0.23)",
                          "&:hover": {
                            border: `2px solid ${annot.borderColor || "rgb(0, 145, 255)"
                              }`,
                            cursor: "move !important",
                          },
                          "& *": {
                            cursor: "move !important",
                          },
                        },
                      }}
                    >
                      {annot.options && annot.options.length > 0 ? (
                        annot.options.map((option, idx) => (
                          <MenuItem key={idx} value={option}>
                            {option}
                          </MenuItem>
                        ))
                      ) : (
                        <MenuItem disabled>No options</MenuItem>
                      )}
                    </TextField>
                  </>
                )}
                {/* Close button only - top right when annotation is active */}
                {activeAnnotation === `${pageNum}-${index}` && (
                  <IconButton
                    size="small"
                    aria-label="close"
                    sx={{
                      position: "absolute",
                      top: "-28px",
                      right: "10px",
                      backgroundColor: "red",
                      padding: "4px",
                      minWidth: "24px",
                      minHeight: "24px",
                      width: "24px",
                      height: "24px",
                      zIndex: 10002,
                      cursor: "pointer !important",
                      boxShadow: "0 2px 6px rgba(0,0,0,0.2)",
                      transition: "all 0.2s ease",
                      "&:hover": {
                        backgroundColor: "#d32f2f",
                        transform: "scale(1.1)",
                        boxShadow: "0 4px 8px rgba(0,0,0,0.3)",
                        cursor: "pointer !important",
                      },
                      "&:active": {
                        transform: "scale(0.95)",
                      },
                    }}
                    disableRipple
                    onClick={(e) => {
                      e.stopPropagation();
                      e.preventDefault();
                      handleDeleteAnnotation(pageNum, index);
                    }}
                    onMouseDown={(e) => {
                      e.stopPropagation();
                      e.preventDefault();
                    }}
                    onMouseUp={(e) => {
                      e.stopPropagation();
                      e.preventDefault();
                    }}
                  >
                    <CloseIcon
                      sx={{
                        color: "white",
                        fontSize: "14px",
                        pointerEvents: "none",
                      }}
                    />
                  </IconButton>
                )}
              </Box>
            </Rnd>
          );
        })
        .filter(Boolean);
      // Remove any null values
    },
    [annotations, isAnnotating, focusedAnnotation, scale, isInteracting]
  );

  // Add a class to the main container when annotation mode is active
  const mainContainerClass = isAnnotating ? "custom-cursor" : "";
  // Add pdfImages as dependency to recalculate when PDF loads// Add scale to dependencies if you want cursor to adapt to PDF zoom
  const cursorConfig = useMemo(() => {
    // Get current font size from settings to calculate dynamic heights
    const signerTextFontSize = annotationSettings.signer_text?.fontSize || 21;
    const dateFontSize = annotationSettings.signer_date?.fontSize || annotationSettings.date?.fontSize || 21;

    // Material-UI TextField adds visual height beyond the stored annotation height:
    // - Border adds 2px (1px top + 1px bottom when unselected, or 4px when selected)
    // - Material-UI's internal structure adds some visual spacing
    // For my_text (image type): needs small buffer for visual match
    // For signer_text (imageWithBackground): match exactly to prevent yellow background overflow
    const myTextVisualBuffer = 4; // Small buffer for my_text image cursor

    // Calculate heights to match actual text field visual heights
    // my_text uses 33px stored height (line 1700), add small buffer for visual match
    const myTextHeight = 33 + myTextVisualBuffer;

    // signer_text uses Math.max(33, fontSize * 1.7) (line 1746)
    // Match exactly without buffer to prevent yellow background overflow
    // The imageWithBackground type shows background color, so height must match precisely
    const signerTextHeight = Math.max(33, signerTextFontSize * 1.7);

    // date fields use fontSize * lineHeight (same as text fields, no extra padding)
    const dateHeight = dateFontSize * 1; // Match text field height calculation

    // Calculate default text box height: fontSize * lineHeight
    const defaultFontSize = annotationSettings.my_text?.fontSize || 21;
    const defaultLineHeight = annotationSettings.my_text?.lineHeight || 1;
    const defaultTextHeight = defaultFontSize * defaultLineHeight;

    return {
      my_text: {
        type: "textCursor", // Custom text cursor indicator
        width: 80,
        height: defaultTextHeight, // Match the default text box height
      },
      my_signature: {
        type: "image",
        image: "/signature11.png",
        width: 250,
        height: 100,
      },
      my_initials: {
        type: "image",
        image: "/initial.png",
        width: 100,
        height: 100,
      },
      date: {
        type: "textCursor", // Custom text cursor indicator (same as my_text)
        width: 80,
        height: dateHeight, // Must match placed date box height (fontSize * 1)
      },
      checkmark: { type: "image", image: "/check.png", width: 22, height: 22 },
      highlight: {
        type: "image",
        image: "/highlight.png",
        width: 120,
        height: 30,
      },
      stamp: { type: "image", image: "/stamp.png", width: 150, height: 150 },

      signer_initials: {
        type: "imageWithBackground",

        // type: "image",
        image: "/signer_signature.png",
        width: 250,
        height: 100,
        backgroundColor: selectedSigner.color, // Background color for the image
      },
      signer_text: {
        type: "textCursor", // Custom text cursor indicator (same as my_text)
        width: 80,
        height: defaultTextHeight, // Match the default text box height
      },
      signer_initials_text: {
        type: "imageWithBackground",
        image: "/signer_initial.png",
        width: 100,
        height: 100,
        backgroundColor: selectedSigner.color, // Background color for the image
      },
      signer_checkmark: {
        type: "imageWithBackground",
        image: "/signer_check.png",
        width: 22,
        height: 22,
        backgroundColor: selectedSigner.color, // Background color for the image
      },
      signer_date: {
        type: "textCursor", // Custom text cursor indicator (same as date)
        width: 80,
        height: dateHeight, // Must match placed date box height (fontSize * 1)
      },
      signer_chooseImgStamp: {
        type: "imageWithBackground",
        image: "/signer_stamp.png",
        width: 150,
        height: 150,
        backgroundColor: selectedSigner.color, // Background color for the image
      },
      signer_chooseImgDrivingL: {
        type: "imageWithBackground",
        image: "/signer_driving_license.png",
        width: 350,
        height: 200,
        backgroundColor: selectedSigner.color, // Background color for the image
      },
      signer_chooseImgPassportPhoto: {
        type: "imageWithBackground",
        image: "/signer_passport_photo.png",
        width: 450,
        height: 299,
        backgroundColor: selectedSigner.color, // Background color for the image
      },
      signer_dropdown: {
        type: "imageWithBackground",
        image: "/signer_dropdown.png",
        width: 110,
        height: 27,
        backgroundColor: selectedSigner.color, // Background color for the image
      },
    };
    // For Other - Box based
    // signer_initials: { type: "box", color: "#f0f0f0" },
    // signer_initials_text: { type: "box", color: "#f0f0f0" },
    // signer_chooseImgStamp: { type: "box", color: "#f0f0f0" },
    // signer_chooseImgDrivingL: { type: "box", color: "#f0f0f0" },
    // signer_chooseImgPassportPhoto: { type: "box", color: "#f0f0f0" },
    // signer_checkmark: { type: "box", color: "#f0f0f0" },
    // signer_text: { type: "box", color: "#f0f0f0" },
    // signer_dropdown: { type: "box", color: "#f0f0f0" },
  }, [selectedSigner, annotationSettings]);
  useEffect(() => {
    if (isAnnotating) {
      // Check if annotationType exists in cursorConfig
      // If it's explicitly null, don't fallback to stamp - use default cursor
      const cursorConfigItem = annotationType in cursorConfig
        ? cursorConfig[annotationType]
        : cursorConfig["stamp"];

      if (cursorRef.current) {
        document.body.removeChild(cursorRef.current);
        cursorRef.current = null;
      }

      // If cursorConfigItem is null, use default browser cursor (no custom cursor)
      if (cursorConfigItem === null || cursorConfigItem === undefined) {
        document.body.style.cursor = "default";
        return;
      }

      // Label + arrow cursor (same box style as text/date) for image and imageWithBackground - no preview images
      const getLabelForAnnotationType = (type) => {
        const labels = {
          my_signature: "SIGN",
          my_initials: "INITIALS",
          checkmark: "",
          highlight: "HIGHLIGHT",
          stamp: "STAMP",
          signer_initials: "SIGN",
          signer_initials_text: "INITIALS",
          signer_checkmark: "",
          signer_chooseImgStamp: "STAMP",
          signer_chooseImgDrivingL: "LICENSE",
          signer_chooseImgPassportPhoto: "PHOTO",
          signer_dropdown: "DROP",
        };
        return labels[type] || "";
      };

      const isCheckboxType = annotationType === "checkmark" || annotationType === "signer_checkmark";

      if (cursorConfigItem.type === "imageWithBackground" || cursorConfigItem.type === "image") {
        const labelText = getLabelForAnnotationType(annotationType);
        const isEmptyLabel = !labelText;
        // Same size as placed checkbox (22px) when no text (checkbox or unknown). Otherwise 58x25.
        const boxWidth = isEmptyLabel ? 22 : 58;
        const boxHeight = isEmptyLabel ? 22 : 25;
        const isSignerField = cursorConfigItem.type === "imageWithBackground" && selectedSigner;
        const cursorColor = isSignerField && selectedSigner
          ? selectedSigner.color
          : (annotationType === "my_signature" || annotationType === "my_initials") && (primaryColorComp || colortheme)
            ? (primaryColorComp || colortheme)
            : "rgb(0, 145, 255)";
        const borderColor = cursorColor;
        const backgroundColor = isEmptyLabel
          ? "transparent"
          : isSignerField && selectedSigner
            ? getColorWithNewOpacity(selectedSigner.color, false)
            : "rgba(0, 145, 255, 0.1)";
        const textColor = isSignerField ? "rgb(128, 128, 128)" : cursorColor;
        const emptyBoxBorder = isEmptyLabel && isSignerField && selectedSigner
          ? selectedSigner.color
          : isEmptyLabel
            ? "rgba(0, 0, 0, 0.54)"
            : borderColor;

        const cursorElement = document.createElement("div");
        cursorElement.classList.add("custom-cursor-text");
        cursorElement.innerHTML = `
          <div style="
            width: 100%;
            height: 100%;
            border: 1.5px solid ${isEmptyLabel ? emptyBoxBorder : borderColor};
            border-radius: ${isEmptyLabel ? "4px" : "3px"};
            background-color: ${backgroundColor};
            display: flex;
            align-items: center;
            justify-content: center;
            font-family: 'Helvetica', 'Arial', sans-serif;
            font-size: 11px;
            color: ${textColor};
            font-weight: 600;
            letter-spacing: 0.5px;
            box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);
          ">${labelText}</div>
        `;
        Object.assign(cursorElement.style, {
          width: `${boxWidth}px`,
          height: `${boxHeight}px`,
          position: "fixed",
          zIndex: 9999,
          pointerEvents: "none",
          transformOrigin: "0 0",
          transform: `translate(0, -${boxHeight}px)`, // Box bottom at cursor
        });
        document.body.appendChild(cursorElement);
        cursorRef.current = cursorElement;
      } else if (cursorConfigItem.type === "textCursor") {
        // ---- TEXT CURSOR - Label box only (no arrow), box bottom at cursor ----
        const cursorElement = document.createElement("div");
        cursorElement.classList.add("custom-cursor-text");

        const boxHeight = cursorConfigItem.height;
        const boxWidth = 58;
        // Fine-tune anchor so preview bottom aligns with visible pointer tip.
        const pointerTipYOffset = 6;

        // Determine label text: DATE for date and signer_date; CHECK/TEXT for others
        const labelText =
          annotationType === "signer_date" ? "DATE" :
            annotationType === "date" ? "DATE" :
              annotationType === "checkmark" || annotationType === "signer_checkmark" ? "CHECK" :
                annotationType === "signer_text" ? "TEXT" :
                  "TEXT";

        // Determine colors based on annotation type (signer fields use signer color)
        const isSignerField = annotationType === "signer_text" || annotationType === "signer_date";
        const cursorColor = isSignerField && selectedSigner
          ? selectedSigner.color
          : "rgb(0, 145, 255)";
        const borderColor = cursorColor;
        const backgroundColor = isSignerField && selectedSigner
          ? getColorWithNewOpacity(selectedSigner.color, false)
          : "rgba(0, 145, 255, 0.1)";
        const textColor = isSignerField ? "rgb(128, 128, 128)" : cursorColor;

        const textCursorHTML = `
          <div style="
            width: 100%;
            height: 100%;
            border: 1.5px solid ${borderColor};
            border-radius: 3px;
            background-color: ${backgroundColor};
            display: flex;
            align-items: center;
            justify-content: center;
            font-family: 'Helvetica', 'Arial', sans-serif;
            font-size: 11px;
            color: ${textColor};
            font-weight: 600;
            letter-spacing: 0.5px;
            box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);
          ">${labelText}</div>
        `;

        cursorElement.innerHTML = textCursorHTML;

        Object.assign(cursorElement.style, {
          width: `${boxWidth}px`,
          height: `${boxHeight}px`,
          position: "fixed",
          zIndex: 9999,
          pointerEvents: "none",
          transformOrigin: "0 0",
          transform: `translate(0, -${boxHeight + pointerTipYOffset}px)`, // Align closer to pointer tip
        });

        document.body.appendChild(cursorElement);
        cursorRef.current = cursorElement;
      } else if (cursorConfigItem.type === "box") {
        // ---- BOX Cursor ----
        const boxElement = document.createElement("div");
        boxElement.classList.add("custom-cursor-box");
        document.body.appendChild(boxElement);
        cursorRef.current = boxElement;
        const calculatedWidth = calculateTextWidth(
          "Text ....",
          16,
          "Helvetica"
        );
        // Dynamic size map
        const sizeMap = {
          my_text: { width: calculatedWidth, height: "27px" },
          date: { width: "120px", height: "25px" },
          signer_initials: { width: "250px", height: "74px" },
          signer_initials_text: { width: "100px", height: "74px" },
          signer_chooseImgStamp: { width: "150px", height: "100px" },
          signer_chooseImgDrivingL: { width: "350px", height: "120px" },
          signer_chooseImgPassportPhoto: { width: "450px", height: "170px" },
          signer_checkmark: { width: "22px", height: "22px" },
          signer_date: { width: "120px", height: "25px" },
          signer_text: { width: calculatedWidth, height: "27px" },
          signer_dropdown: { width: "120px", height: "25px" },
        };

        const { width, height } = sizeMap[annotationType] || {
          width: "120px",
          height: "50px",
        };

        const getPaddingTop = (type) => {
          switch (type) {
            case "signer_chooseImgDrivingL":
              return "78px";
            case "signer_chooseImgPassportPhoto":
              return "128px";
            case "signer_checkmark":
              return "0px";
            case "signer_initials":
            case "signer_initials_text":
            // case "signer_chooseImgStamp":
            case "signer_chooseImgDrivingL":
            case "signer_chooseImgPassportPhoto":
              return "25px";
            case "signer_chooseImgStamp":
              return "50px";
            default:
              return "2px";
          }
        };

        Object.assign(boxElement.style, {
          position: "fixed",
          zIndex: 9999,
          pointerEvents: "none",
          paddingTop: getPaddingTop(annotationType),
          width,
          height,
          // backgroundColor: selectedSigner.color,
          backgroundColor:
            cursorConfigItem.backgroundColor || "rgba(255, 255, 255, 0.8)",

          // padding: annotationType === "signer_checkmark" ? "5px" : null,
          border: "1px solid rgba(0,0,0,0.2)",
          opacity: 0.6,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          fontFamily: "Arial",
          fontWeight: "bold",
          color: "#000",
          borderRadius: "4px",
          // padding: annotationType === "signer_checkmark" ? "5px" : "0px",
        });

        // Dynamic content rendering per type
        if (annotationType === "signer_checkmark") {
          // boxElement.innerHTML = `
          //   <div style="width: 20px; height: 20px; border: 2px solid black; background-color: white;margin:2px"></div>
          // `;
          boxElement.innerHTML = `
        <div style="
            width: 100%;
            height: 100%;
            display: flex;
            align-items: center;
            justify-content: center;
            background-color: ${selectedSigner.color};
            border-radius: 4px;
            box-sizing: border-box;
            /* This is the padding behind the checkbox */
        ">
            <div style="
                width: 20px;
                height: 20px;
                background-color: white;
                border: 2px solid black;
                box-sizing: border-box;
            "></div>
        </div>
    `;
        } else if (annotationType === "date" || annotationType === "signer_date") {
          // boxElement.innerHTML = `
          //   <div style="font-size: 16px; font-weight: 400;padding-left:2px;">Date</div>
          // `;
          boxElement.innerHTML = `
          <div style="
            font-size: ${LABEL_PLACEHOLDER_FONT_PX}px;
            font-weight: 400;
            color: ${PLACEHOLDER_LABEL_COLOR};
            padding-left: 2px;
            padding-right: 2px;
            display: flex;
            align-items: center;
            justify-content: center;
            position: relative;
            height: 100%;
          ">
            DATE
            <div style="
              position: absolute;
              bottom: 2px;
              left: 0;
              width: calc(100% - 4px); 
              height: 1px;
              background-color: rgba(0, 0, 0, 0.35);
            "></div>
          </div>
        `;
        } else if (annotationType === "my_text" || annotationType === "signer_text") {
          boxElement.innerHTML = `
            <div style="width:100%;height:100%;display:flex;align-items:center;justify-content:center;font-size:${LABEL_PLACEHOLDER_FONT_PX}px;font-weight:400;color:${PLACEHOLDER_LABEL_COLOR};text-decoration:none;">TEXT</div>
          `;
        } else if (annotationType === "signer_dropdown") {
          boxElement.innerHTML = `
            <div style="font-size: 18px; font-weight: 400; padding-left:4px;padding-top:2px;text-decoration: none;">Dropdown ...</div>
          `;
        } else {
          const boxContent = getSignerBoxContentSvg(annotationType);
          if (boxContent) {
            boxElement.innerHTML = `
              <div style="display: flex; flex-direction: column; align-items: center; justify-content: center; gap: 4px;">
                ${boxContent.icon}
                <div style="font-size: 21px; font-weight: 400;">${boxContent.text}</div>
              </div>
            `;
          }
        }
      }

      const moveCursor = (e) => {
        const target = e.target;

        // If text entry dialog is open, use default cursor behavior
        if (textEntryDialogOpen) {
          if (cursorRef.current) {
            cursorRef.current.style.display = "none";
          }
          // Check if over dialog content (input field, buttons, etc.)
          if (
            target.tagName === "INPUT" ||
            target.closest(".MuiTextField-root") ||
            target.closest(".MuiDialog-root") ||
            target.closest(".MuiDialog-container")
          ) {
            if (target.tagName === "INPUT" || target.closest(".MuiTextField-root")) {
              document.body.style.cursor = "text";
            } else if (target.closest(".MuiButton-root")) {
              document.body.style.cursor = "pointer";
            } else {
              document.body.style.cursor = "default";
            }
          } else {
            document.body.style.cursor = "default";
          }
          return;
        }

        // 1. Check if we're on a scrollbar
        const isScrollbar = (element) => {
          if (!element || !element.classList) return false;

          if (element.classList.contains("pdf-container")) {
            const rect = element.getBoundingClientRect();
            // Detect vertical scrollbar
            if (
              element.scrollHeight > element.clientHeight &&
              e.clientX > rect.right - 17
            ) {
              return true;
            }
            // Detect horizontal scrollbar
            if (
              element.scrollWidth > element.clientWidth &&
              e.clientY > rect.bottom - 17
            ) {
              return true;
            }
          }
          return false;
        };
        if (isResizing) {
          // Hide custom cursor and show two-arrow resize cursor when resizing
          if (cursorRef.current) {
            cursorRef.current.style.display = "none";
          }
          if (target.closest(".react-rnd-resizable-handle")) {
            document.body.style.cursor = window.getComputedStyle(target).cursor || "nwse-resize";
          } else {
            document.body.style.cursor = "nwse-resize"; // Two-arrow diagonal resize cursor
          }
          return;
        }
        const elementsAtPoint = document.elementsFromPoint(e.clientX, e.clientY);
        const overHandleEl = elementsAtPoint.find((el) => el.closest && el.closest(".react-rnd-resizable-handle"));
        const resizeHandle = overHandleEl ? overHandleEl.closest(".react-rnd-resizable-handle") : target.closest(".react-rnd-resizable-handle");
        if (resizeHandle) {
          cursorRef.current.style.display = "none";
          const isSE = resizeHandle.classList.contains("react-rnd-resizable-handle-se");
          const isNW = resizeHandle.classList.contains("react-rnd-resizable-handle-nw");
          document.body.style.cursor = (isSE || isNW) ? "nwse-resize" : "nesw-resize";
          return;
        }
        // Check for all cases where we should hide custom cursor
        // Note: We check for annotations but allow cursor to show when not directly over annotation content
        const isOverAnnotationContent = target.closest(".annotation") &&
          !target.closest(".react-rnd-resizable-handle") &&
          !target.closest(".MuiIconButton-root");

        const shouldHideCustomCursor =
          // Text fields
          target.tagName === "INPUT" ||
          target.closest(".MuiTextField-root") ||
          // Annotations (but allow cursor when moving between annotations)
          isOverAnnotationContent ||
          // Resize handles
          // target.closest(".react-rnd-resizable-handle") ||
          // Edit/Delete buttons
          target.closest(".MuiIconButton-root") ||
          target.closest('[aria-label="edit"]') ||
          target.closest('[aria-label="close"]') ||
          // Sidebars
          target.closest(".left-sidebar") ||
          target.closest(".right-sidebar") ||
          target.closest(".zoom-container");

        // Check if we're in the PDF container
        const isPdfContainer = target.closest(".pdf-container");

        if (shouldHideCustomCursor) {
          // Hide custom cursor
          cursorRef.current.style.display = "none";
          document.body.style.cursor = getCursorForElement(target);
          // Set appropriate cursor style
          // if (target.closest(".react-rnd-resizable-handle")) {
          //   document.body.style.cursor = "nw-resize";
          // } else
          if (target.classList.contains("annotation-resize-handle")) {
            cursorRef.current.style.display = "none"; // Hide your custom cursor
            document.body.style.cursor = window.getComputedStyle(target).cursor;
            return;
          }
          if (target.closest(".react-rnd-resizable-handle")) {
            cursorRef.current.style.display = "none"; // Hide custom cursor
            document.body.style.cursor = window.getComputedStyle(target).cursor;
            return; // Let Rnd's default cursor handling work
          }
          if (
            target.closest(".MuiIconButton-root") ||
            target.closest('[aria-label="edit"]') ||
            target.closest('[aria-label="close"]')
          ) {
            document.body.style.cursor = "pointer";
          } else if (isOverAnnotationContent) {
            document.body.style.cursor = "move";
          } else if (
            target.tagName === "INPUT" ||
            target.closest(".MuiTextField-root")
          ) {
            document.body.style.cursor = "text";
          } else {
            document.body.style.cursor = "default";
          }
        } else if (isPdfContainer) {
          // Show custom cursor only in PDF container and not over any special elements
          // Ensure cursor is visible when moving from annotations back to PDF area
          if (cursorRef.current) {
            cursorRef.current.style.display = "block";
            cursorRef.current.style.left = `${e.clientX}px`;
            cursorRef.current.style.top = `${e.clientY}px`;
          }
          // For text cursor, show both pointer and custom indicator
          // Show pointer (hand) + custom field design for all field types (text, date, signature, etc.)
          document.body.style.cursor = "pointer";
        } else {
          // Hide custom cursor outside PDF container
          if (cursorRef.current) {
            cursorRef.current.style.display = "none";
          }
          document.body.style.cursor = "default";
        }
      };

      const getCursorForElement = (target) => {
        if (target.closest(".react-resizable-handle"))
          return window.getComputedStyle(target).cursor;
        if (
          target.closest(".MuiIconButton-root") ||
          target.closest('[aria-label="edit"]') ||
          target.closest('[aria-label="close"]')
        ) {
          return "pointer";
        }
        if (target.closest(".annotation")) return "move";
        if (target.tagName === "INPUT" || target.closest(".MuiTextField-root"))
          return "text";
        return "default";
      };

      document.addEventListener("mousemove", moveCursor);

      return () => {
        document.removeEventListener("mousemove", moveCursor);
        if (cursorRef.current?.parentNode) {
          document.body.removeChild(cursorRef.current);
          cursorRef.current = null;
        }
        document.body.style.cursor = "default";
      };
    }
  }, [isAnnotating, annotationType, selectedSigner, textEntryDialogOpen]);

  // In your App component
  const [isDownloading, setIsDownloading] = useState(false);
  const handleSaveAndGoBack = async () => {
    try {
      setIsSaving(true);
      await saveData(documentId, annotations);
      setSaveConfirmModalOpen(false);
      window.location.href = `${FrontendBaseUrl}home?status=${hasParamsD}`;
    } catch (error) {
      console.error("Error saving:", error);
    } finally {
      setIsSaving(false);
    }
  };

  const handleDownloadOriginal = async () => {
    if (!originalPdf) return;

    setIsDownloading(true);
    try {
      // Filter annotations to only include text types and my section annotations
      const textTypes = ["my_text", "signer_text", "date", "signer_date", "my_signature", "my_initials", "checkmark", "stamp", "highlight"];
      const filteredAnnotations = {};

      Object.entries(annotations).forEach(([pageNum, pageAnnotations]) => {
        if (pageNum === "_lastUpdate" || !Array.isArray(pageAnnotations)) return;
        const textAnnotations = pageAnnotations.filter((annot) =>
          textTypes.includes(annot.type)
        );
        if (textAnnotations.length > 0) {
          filteredAnnotations[pageNum] = textAnnotations;
        }
      });

      // If there are text annotations, merge them with PDF
      if (Object.keys(filteredAnnotations).length > 0) {
        // Use actual rendered page width so downloaded font size matches editor (A4, A3, Letter, etc.)
        let editorPageWidthPx = null;
        const firstPageKey = Object.keys(filteredAnnotations)[0];
        if (firstPageKey) {
          const pageEl = document.querySelector(`#img-${firstPageKey} .pdf-image`);
          if (pageEl) {
            const rect = pageEl.getBoundingClientRect();
            if (rect?.width > 0) editorPageWidthPx = rect.width;
          }
        }
        if (editorPageWidthPx != null) {
          console.log("[Download] Using editor page width for font scaling (px):", Math.round(editorPageWidthPx));
        }

        const success = await downloadPdfWithTextAnnotations(
          originalPdf,
          filteredAnnotations,
          fileName || "document.pdf",
          {
            editorPageWidthPx: editorPageWidthPx ?? undefined,
            logFontScale: true,
            textVerticalNudgeUpPoints: 1.5,
          }
        );
        if (!success) {
          toastAlert("error", "Failed to download PDF with annotations");
        }
      } else {
        // No text annotations, just download original PDF
        const success = await downloadOriginalPdf(originalPdf, fileName);
        if (!success) {
          toastAlert("error", "Failed to download PDF");
        }
      }
    } catch (error) {
      console.error("Error downloading PDF:", error);
      toastAlert("error", "Failed to download PDF");
    } finally {
      setIsDownloading(false);
    }
  };

  const [isMobileDialogOpen, setIsMobileDialogOpen] = useState(false);

  useEffect(() => {
    if (window.innerWidth < 780) {
      setIsMobileDialogOpen(true);
    }
  }, []);
  useEffect(() => {
    // Track page size changes using ResizeObserver
    const resizeObserver = new ResizeObserver((entries) => {
      // Update page sizes when observed elements change size
      const newSizes = {};
      pdfImages.forEach((_, pageIndex) => {
        const pageElement = document.getElementById(`img-${pageIndex + 1}`);
        if (pageElement) {
          newSizes[pageIndex + 1] = {
            width: pageElement.clientWidth,
            height: pageElement.clientHeight,
          };
        }
      });
      setPageSizes(newSizes);
    });

    // Observe all PDF pages
    pdfImages.forEach((_, pageIndex) => {
      const pageElement = document.getElementById(`img-${pageIndex + 1}`);
      if (pageElement) {
        resizeObserver.observe(pageElement);
      }
    });

    return () => resizeObserver.disconnect();
  }, [pdfImages]);

  // Add this useEffect after your existing effects
  useEffect(() => {
    const handleResize = debounce(() => {
      // Force re-render of annotations when screen size changes
      setAnnotations((prev) => ({ ...prev }));
      // setAnnotations((prev) => {
      //   const updated = { ...prev };
      //   // Add a timestamp to force re-render without changing data
      //   updated._lastUpdate = Date.now();
      //   return updated;
      // });
      // Force re-render by updating state properly
      // setAnnotations((prev) => {
      //   // Ensure we're working with valid annotation structure
      //   const validAnnotations = {};

      //   Object.keys(prev).forEach((pageNum) => {
      //     if (Array.isArray(prev[pageNum])) {
      //       validAnnotations[pageNum] = [...prev[pageNum]];
      //     } else if (pageNum !== "_lastUpdate") {
      //       // Reset invalid page annotations to empty array
      //       validAnnotations[pageNum] = [];
      //     }
      //   });

      //   // Add timestamp for re-render
      //   validAnnotations._lastUpdate = Date.now();

      //   return validAnnotations;
      // });
    }, 100);

    const handleZoom = debounce(() => {
      // Detect zoom changes and recalculate
      const currentZoom = window.devicePixelRatio;
      if (Math.abs(currentZoom - (window.lastZoom || 1)) > 0.1) {
        window.lastZoom = currentZoom;
        // setAnnotations((prev) => {
        //   const updated = { ...prev };
        //   updated._lastUpdate = Date.now();
        //   return updated;
        // });
        setAnnotations((prev) => ({ ...prev }));
      }
      // if (Math.abs(currentZoom - (window.lastZoom || 1)) > 0.1) {
      //   window.lastZoom = currentZoom;

      //   setAnnotations((prev) => {
      //     // Same validation as above
      //     const validAnnotations = {};

      //     Object.keys(prev).forEach((pageNum) => {
      //       if (Array.isArray(prev[pageNum])) {
      //         validAnnotations[pageNum] = [...prev[pageNum]];
      //       } else if (pageNum !== "_lastUpdate") {
      //         validAnnotations[pageNum] = [];
      //       }
      //     });

      //     validAnnotations._lastUpdate = Date.now();
      //     return validAnnotations;
      //   });
      // }
    }, 100);

    window.addEventListener("resize", handleResize);
    window.addEventListener("wheel", handleZoom, { passive: true });

    return () => {
      window.removeEventListener("resize", handleResize);
      window.removeEventListener("wheel", handleZoom);
    };
  }, []);
  // Add this right after your state declarations, before any useEffects

  // Replace your existing resize effect with this improved version:

  // Add this function after your existing functions
  // Add this useEffect after your existing ones
  useEffect(() => {
    if (pdfImages.length > 0 && pdfContainerRef.current) {
      // Auto-fit PDF to container on initial load
      const timeoutId = setTimeout(() => {
        const container = pdfContainerRef.current;
        const firstPage = container?.querySelector(".pdf-page-container");

        if (firstPage && container) {
          const containerWidth = container.offsetWidth;
          const pageWidth = firstPage.scrollWidth;

          // If PDF is much smaller than container, increase scale slightly
          if (pageWidth < containerWidth * 0.7) {
            const newScale = Math.min(1.2, (containerWidth * 0.9) / pageWidth);
            setScale(newScale);
          }
        }
      }, 500);

      return () => clearTimeout(timeoutId);
    }
  }, [pdfImages]);

  // Add this enhanced scale effect
  useEffect(() => {
    const handleScaleChange = debounce(() => {
      // Detect if the PDF container size has changed significantly
      const container = pdfContainerRef.current;
      if (!container) return;

      const newContainerWidth = container.offsetWidth;
      const widthDifference = Math.abs(newContainerWidth - containerWidth);

      // Only trigger recalculation if change is significant (more than 50px)
      if (widthDifference > 50) {
        setContainerWidth(newContainerWidth);

        // Force annotation recalculation
        setTimeout(() => {
          setAnnotations((prev) => {
            const updated = { ...prev };
            updated._lastUpdate = Date.now();
            return updated;
          });
        }, 100); // Small delay to ensure PDF has rendered
      }
    }, 200);

    // Use ResizeObserver for more accurate container size tracking
    const resizeObserver = new ResizeObserver(handleScaleChange);

    if (pdfContainerRef.current) {
      resizeObserver.observe(pdfContainerRef.current);
    }

    return () => {
      resizeObserver.disconnect();
    };
  }, [containerWidth]);

  return (
    <>
      <style>{`
        .react-rnd-resizable-handle-se,
        .react-rnd-resizable-handle-nw {
          cursor: nwse-resize !important;
        }
        .react-rnd-resizable-handle-sw,
        .react-rnd-resizable-handle-ne {
          cursor: nesw-resize !important;
        }
        .react-rnd-resizable-handle-se:hover,
        .react-rnd-resizable-handle-nw:hover,
        .react-rnd-resizable-handle-sw:hover,
        .react-rnd-resizable-handle-ne:hover {
          transform: scale(1.2);
          background: rgb(0, 120, 215) !important;
        }
        .annotation {
          cursor: move !important;
        }
      `}</style>
      {isLoading && <FullScreenLoader />}
      <Box className={mainContainerClass}>
        {/* small screen dialog  */}
        <Dialog
          open={isMobileDialogOpen}
        // onClose={() => setIsMobileDialogOpen(false)}
        >
          <DialogTitle>Notice</DialogTitle>
          <DialogContent>
            <Typography variant="body1">
              This screen is only editable on laptops or desktop computers.
              Mobile view is not supported for editing.
            </Typography>
          </DialogContent>
        </Dialog>
        {/* Add this near the end of your return statement, alongside other modals */}

        <input
          type="file"
          ref={stampInputRef}
          style={{ display: "none" }}
          accept="image/*"
          onChange={handleStampFileSelect} // Remove lastClickPosition parameter
        />
        <FileUpload
          showTour={false}
          setShowTour={() => { }}
          logo={logo}
          primaryColorComp={primaryColorComp}
          setFileName={(name) => setFileName(name)}
          emailSubject={emailSubject}
          setEmailSubject={setEmailSubject}
          emailMessage={emailMessage}
          setEmailMessage={setEmailMessage}
          originalPdf={originalPdf}
          uniqIdDoc={uniqIdDoc}
          user_email={user_email}
          file_id={documentId}
          annotations={annotations}
          signers={signers}
          setSigners={setSigners}
          user_id={userId}
          file_name={fileName || "Document"}
          // pdfUrl="https://y5f8.c1.e2-7.dev/requiresign-testing-bucket/112316_riazirim22%2F20241106%2F0019_Invoice-2C6D4BDF-0024.pdf" // Add your PDF URL here
          onDownloadOriginal={handleDownloadOriginal}
          isDownloading={isDownloading}
        />

        {!pdfFile ? (
          <></>
        ) : (
          <Grid2 container spacing={0} height="90vh">
            {/* Left Sidebar */}
            <Grid2
              item
              xs={2}
              ref={sidebarRef}
              sx={styles.sidebarStyle}
              onMouseDown={(e) => e.stopPropagation()}
              onMouseUp={(e) => e.stopPropagation()}
              className="left-sidebar"
            >
              {/* <Button
                style={{ width: "100%" }}
                onClick={downloadPdfWithAnnotations}
              >
                Download
              </Button> */}
              {/* // Add Fit to Width button in your zoom controls */}
              {/* <Button
                onClick={fitToWidth}
                variant="outlined"
                size="small"
                sx={{ mb: 1, width: "100%" }}
              >
                Fit to Width
              </Button> */}
              <Button
                variant="outlined"
                component="span"
                onClick={() => {
                  setSaveConfirmModalOpen(true);
                }}
                sx={{
                  textTransform: "none",
                  color: "#000",
                  width: "100%",
                  cursor: "pointer !important",
                  fontWeight: 600,
                  borderColor: "rgba(0, 0, 0, 0.23)",
                  borderRadius: "8px",
                  boxShadow: "none",
                  marginBottom: "16px", // consistent spacing to Deselect or FOR ME
                  "&:hover": {
                    borderColor: "rgba(0, 0, 0, 0.4)",
                    backgroundColor: "rgba(0, 0, 0, 0.04)",
                  },
                }}
              >
                Back
              </Button>
              {annotationType && (
                <Button
                  onClick={() => {
                    setSelectedAnnotation(null);
                    setAnnotationType(null);
                    setIsAnnotating(false);
                  }}
                  variant="contained"
                  component="span"
                  sx={{
                    width: "100%",
                    boxShadow: "none",
                    backgroundColor: "#ea5455",
                    textTransform: "none",
                    mt: 2, // 16px gap below Back
                    mb: 0,
                    "&:hover": {
                      backgroundColor: "#d32524",
                      boxShadow: "none",
                    },
                  }}
                >
                  Deselect
                </Button>
              )}
              <Box sx={{ display: "flex", flexDirection: "column", gap: 2, mt: 2 }}>
                {/* FOR ME Section */}
                <Box>
                  <Typography
                    component="span"
                    sx={{
                      display: "inline-block",
                      px: 2,
                      py: 1,
                      borderRadius: "20px",
                      backgroundColor:
                        primaryColorComp === null || primaryColorComp === undefined
                          ? colortheme
                          : primaryColorComp,
                      color: "#fff",
                      fontWeight: 700,
                      fontSize: "1rem",
                      textTransform: "uppercase",
                      letterSpacing: "0.04em",
                      mb: 1,
                    }}
                  >
                    FOR ME
                  </Typography>
                  <ForYou
                    type={(t) => {
                      const meValue = {
                        signer_id: "me",
                        name: "Me",
                        email: user_email,
                        color: primaryColorComp || colortheme,
                        isMe: true,
                      };
                      setActive("1");
                      setSelectedSignerId(meValue);
                      setSelectedSigner(meValue);
                      getTypeListItem(t);
                    }}
                    typeData={annotationType}
                    compPrimaryColor={primaryColorComp || colortheme}
                  />
                </Box>

                {/* FOR OTHERS Section */}
                <Box sx={{ display: "flex", flexDirection: "column" }}>
                  <Typography
                    component="span"
                    sx={{
                      display: "inline-block",
                      px: 2,
                      py: 1,
                      borderRadius: "20px",
                      backgroundColor:
                        primaryColorComp === null || primaryColorComp === undefined
                          ? colortheme
                          : primaryColorComp,
                      color: "#fff",
                      fontWeight: 700,
                      fontSize: "1rem",
                      textTransform: "uppercase",
                      letterSpacing: "0.04em",
                      mb: 0.5,
                    }}
                  >
                    FOR OTHERS
                  </Typography>
                  <Typography
                    component="button"
                    onClick={() => setSignersDialogOpen(true)}
                    sx={{
                      background: "none",
                      border: "none",
                      padding: 0,
                      cursor: "pointer",
                      color:
                        primaryColorComp === null || primaryColorComp === undefined
                          ? colortheme
                          : primaryColorComp,
                      fontSize: "0.9375rem",
                      fontWeight: 600,
                      textDecoration: "underline",
                      mb: 1,
                      "&:hover": { opacity: 0.85 },
                    }}
                  >
                    Add/Manage Signers
                  </Typography>

                  {signers.length > 0 && (
                    <Box
                      sx={{
                        display: "flex",
                        flexDirection: "column",
                        gap: 0.5,
                        mb: 1.5,
                      }}
                    >
                      <Typography
                        variant="subtitle2"
                        sx={{
                          fontSize: "0.9375rem",
                          fontWeight: 600,
                          color: "rgba(0, 0, 0, 0.7)",
                        }}
                      >
                        Signer
                      </Typography>
                      <FormControl
                        fullWidth
                        size="small"
                        sx={{
                          "& .MuiOutlinedInput-root": {
                            backgroundColor: "rgba(0, 0, 0, 0.04)",
                            borderRadius: "8px",
                            fontWeight: 600,
                            "& fieldset": {
                              borderWidth: "1.5px",
                              borderColor: "rgba(0, 0, 0, 0.23)",
                            },
                            "&:hover fieldset": {
                              borderColor:
                                primaryColorComp ||
                                colortheme ||
                                "rgba(0, 145, 255, 0.5)",
                            },
                            "&.Mui-focused fieldset": {
                              borderWidth: "1.5px",
                              borderColor:
                                primaryColorComp || colortheme || "rgb(35, 179, 232)",
                            },
                          },
                        }}
                      >
                        <Select
                          value={selectedSignerId || ""}
                          onChange={(e) => {
                            const newSigner = e.target.value;

                            setSelectedSignerId(e.target.value);
                            setSelectedSigner(e.target.value);

                            // Type mapping for conversion between "For You" and "For Others"
                            const typeMapping = {
                              // For You (Tab 1) -> For Others (Tab 2)
                              my_text: "signer_text",
                              my_signature: "signer_initials",
                              my_initials: "signer_initials_text",
                              date: "signer_date",
                              checkmark: "signer_checkmark",
                              stamp: "signer_chooseImgStamp",

                              // For Others (Tab 2) -> For You (Tab 1)
                              signer_text: "my_text",
                              signer_initials: "my_signature",
                              signer_initials_text: "my_initials",
                              signer_date: "date",
                              signer_checkmark: "checkmark",
                              signer_chooseImgStamp: "stamp",
                            };

                            // If selecting "Me" option, switch to "For You" tab
                            // If selecting "Me" option, switch to "For You" tab
                            if (newSigner?.isMe) {
                              setActive("1");

                              // Convert annotation type if needed
                              if (
                                annotationType &&
                                annotationType.startsWith("signer_")
                              ) {
                                const newType = typeMapping[annotationType];
                                if (newType) {
                                  setAnnotationType(newType);
                                }
                              }
                            } else {
                              setActive("2");

                              // Convert annotation type if needed
                              if (
                                annotationType &&
                                !annotationType.startsWith("signer_")
                              ) {
                                const newType = typeMapping[annotationType];
                                if (newType) {
                                  setAnnotationType(newType);
                                }
                              }
                            }
                          }}
                          // Add this to fix the value comparison for virtual "Me" option
                          renderValue={(selected) => {
                            // For "Me" signer, render the dropdown value manually
                            if (selected?.isMe) {
                              return (
                                <Box
                                  sx={{
                                    display: "flex",
                                    alignItems: "center",
                                    gap: 1,
                                  }}
                                >
                                  <Box
                                    sx={{
                                      width: 20,
                                      height: 20,
                                      borderRadius: "50%",
                                      backgroundColor:
                                        primaryColorComp || colortheme,
                                      flexShrink: 0,
                                    }}
                                  />
                                  <Typography
                                    sx={{
                                      maxWidth: "120px",
                                      overflow: "hidden",
                                      textOverflow: "ellipsis",
                                      whiteSpace: "nowrap",
                                    }}
                                  >
                                    Me
                                  </Typography>
                                </Box>
                              );
                            }

                            // For regular signers with name property
                            if (selected?.name) {
                              return (
                                <Box
                                  sx={{
                                    display: "flex",
                                    alignItems: "center",
                                    gap: 1,
                                    minWidth: 0,
                                    flex: 1,
                                  }}
                                >
                                  <Box
                                    sx={{
                                      width: 20,
                                      height: 20,
                                      borderRadius: "50%",
                                      backgroundColor: selected.color,
                                      flexShrink: 0,
                                    }}
                                  />
                                  <Typography
                                    sx={{
                                      minWidth: 0,
                                      overflow: "hidden",
                                      textOverflow: "ellipsis",
                                      whiteSpace: "nowrap",
                                    }}
                                  >
                                    {selected.name}
                                  </Typography>
                                </Box>
                              );
                            }

                            return "";
                          }}
                          sx={{
                            height: "46px",
                            "& .MuiSelect-select": {
                              display: "flex",
                              alignItems: "center",
                              gap: 1,
                              padding: "8px 14px",
                              minHeight: "0px !important",
                              fontSize: "0.9375rem",
                            },
                            "& .MuiOutlinedInput-notchedOutline": {
                              borderColor: "rgba(0, 0, 0, 0.23)",
                            },
                          }}
                          MenuProps={{
                            PaperProps: {
                              sx: {
                                "& .MuiMenuItem-root": {
                                  minHeight: "35px",
                                  padding: "4px 14px",
                                },
                              },
                            },
                          }}
                        >
                          {/* Add "Me" option manually - this is the virtual option that doesn't exist in your signers array */}
                          <MenuItem
                            key="me-default"
                            value={{
                              signer_id: "me",
                              name: "Me",
                              email: user_email,
                              color: primaryColorComp || colortheme,
                              isMe: true,
                            }}
                            onClick={() => {
                              const meValue = {
                                signer_id: "me",
                                name: "Me",
                                email: user_email,
                                color: primaryColorComp || colortheme,
                                isMe: true,
                              };
                              setSelectedSignerId(meValue);
                              setSelectedSigner(meValue);
                              setActive("1"); // Switch to "For You" tab
                            }}
                            sx={{
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "space-between",
                              gap: 1,
                              pr: 1,
                              backgroundColor: selectedSignerId?.isMe
                                ? "rgba(0, 145, 255, 0.08)"
                                : "transparent",
                            }}
                          >
                            <Box
                              sx={{
                                display: "flex",
                                alignItems: "center",
                                gap: 1,
                              }}
                            >
                              <Box
                                sx={{
                                  width: 20,
                                  height: 20,
                                  borderRadius: "50%",
                                  backgroundColor:
                                    primaryColorComp || colortheme,
                                  flexShrink: 0,
                                }}
                              />
                              <Typography
                                sx={{
                                  maxWidth: "120px",
                                  overflow: "hidden",
                                  textOverflow: "ellipsis",
                                  whiteSpace: "nowrap",
                                }}
                              >
                                Me
                              </Typography>
                            </Box>
                          </MenuItem>

                          {/* Show actual signers from your signers array */}
                          {signers.map((signer, index) => (
                            <MenuItem
                              key={`other-${index}`}
                              value={signer}
                              onClick={() => {
                                setSelectedSignerId(signer);
                                setSelectedSigner(signer);
                                setActive("2"); // Switch to "For Others" tab
                              }}
                              sx={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "space-between",
                                gap: 1,
                                pr: 1,
                                backgroundColor:
                                  selectedSignerId?.signer_id ===
                                    signer.signer_id
                                    ? "rgba(0, 145, 255, 0.08)"
                                    : "transparent",
                              }}
                            >
                              <Box
                                sx={{
                                  display: "flex",
                                  alignItems: "center",
                                  gap: 1,
                                }}
                              >
                                <Box
                                  sx={{
                                    width: 20,
                                    height: 20,
                                    borderRadius: "50%",
                                    backgroundColor: signer.color,
                                    flexShrink: 0,
                                  }}
                                />
                                <Typography
                                  sx={{
                                    overflow: "hidden",
                                    textOverflow: "ellipsis",
                                    whiteSpace: "nowrap",
                                  }}
                                >
                                  {signer.name}
                                </Typography>
                              </Box>
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </Box>
                  )}
                  <Box className="zoom-container esign-toolbar">
                    <ForOthers
                      type={(t) => {
                        setActive("2");
                        if (
                          signers.length > 0 &&
                          (selectedSignerId?.isMe || !selectedSignerId?.signer_id)
                        ) {
                          setSelectedSignerId(signers[0]);
                          setSelectedSigner(signers[0]);
                        }
                        getTypeListItem(t);
                      }}
                      typeData={annotationType}
                      selectedSigner={selectedSigner}
                      disabled={signers.length === 0}
                      onDisabledClick={() => setSignersDialogOpen(true)}
                    />
                  </Box>
                </Box>
                {/* end  */}
              </Box>
            </Grid2>
            {/* Main PDF Viewer */}
            <Grid2 xs={8} className="main-container esign-document-canvas">
              <Grid2
                item
                // className="pdf-container"
                className={`pdf-container ${isAnnotating ? "custom-cursor" : ""
                  }`}
                ref={pdfContainerRef}
                onClick={handlePdfClick} // Enable click for annotations if in annotation mode
                sx={{
                  height: "100%", // Use full height
                  overflow: "auto",
                  display: "flex",
                  justifyContent: "center",
                  padding: "10px", // Reduce padding
                }}
              >
                <Box
                  className="pdf-content-box"
                  // sx={{
                  //   minWidth:
                  //     scale > 1
                  //       ? `${100 * scale}%`
                  //       : `${calculateImageWidth(scale)}%`,
                  //   maxWidth: scale > 1 ? `${100 * scale}%` : "100%",
                  //   position: "relative",
                  //   // overflow: scale > 1 ? "auto" : "hidden",
                  //   // minWidth: `${calculateImageWidth(scale)}%`,
                  //   alignContent: scale <= 1 ? "center" : "flex-start",
                  //   justifyContent: scale <= 1 ? "center" : "flex-start",
                  //   alignItems: scale <= 1 ? "center" : "flex-start",
                  //   display: scale <= 1 ? "flex" : "block",
                  //   // marginBottom: "400px",

                  //   transformOrigin: "top left",
                  // }}
                  sx={{
                    width: "100%", // Use full width of container
                    position: "relative",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    minHeight: "100%",
                    // Remove transform-related properties that might interfere
                    transformOrigin: "top center",
                  }}
                >
                  {pdfImages.length > 0 ? (
                    pdfImages.map((image, index) => (
                      <div
                        key={index}
                        className="pdf-page-container"
                        id={`img-${index + 1}`}
                        onMouseEnter={() => handlePageHover(index + 1)}
                        // style={{
                        //   width: `${calculateImageWidth(scale)}%`,
                        //   maxWidth: "800px", // Prevent excessive scaling on large screens
                        //   minWidth: "400px",

                        //   position: "relative",
                        // }} // Ensure relative positioning
                        style={{
                          width: `${calculateImageWidth(scale)}%`,
                          maxWidth: scale > 1 ? "none" : "100%", // Remove max-width limit when zoomed
                          minWidth: "300px", // Reduce minimum width
                          position: "relative",
                          margin: "0 auto",
                          marginBottom: "20px",
                          // Ensure the PDF uses available height efficiently
                          display: "flex",
                          flexDirection: "column",
                        }}
                      >
                        {/* {renderImage(image, index)}
                        {renderAnnotations(index + 1)} */}
                        {/* <img
                          src={image}
                          alt={`Page ${index + 1}`}
                          className="pdf-image"
                          style={{
                            width: "100%",
                            height: "auto",
                            display: "block",
                            objectFit: "contain",
                          }}
                        />
                        {renderAnnotations(index + 1)} */}
                        <img
                          src={image}
                          alt={`Page ${index + 1}`}
                          className="pdf-image"
                          style={{
                            width: "100%",
                            height: "auto",
                            display: "block",
                            objectFit: "contain",
                            // Remove any height restrictions
                            maxHeight: "none",
                          }}
                        />
                        {renderAnnotations(index + 1)}
                      </div>
                    ))
                  ) : (
                    <Typography>Loading PDF...</Typography>
                  )}
                </Box>
              </Grid2>
            </Grid2>
            {/* Right Sidebar */}
            <Grid2
              item
              xs={2}
              className="right-sidebar esign-page-preview"
              ref={sidebarRef}
              sx={styles.sidebarStyle}
            >
              {/* start – key so switching annotation unmounts prev panel and shows new one */}
              {selectedAnnotation &&
                (selectedAnnotation?.type === "my_text" ||
                  selectedAnnotation?.type === "signer_text") && (
                  <Box
                    key={`right-panel-${selectedAnnotation?.pageNum}-${selectedAnnotation?.index}-${selectedAnnotation?.type}`}
                    sx={{ width: "100%" }}
                  >
                    <TextPropertiesPanel
                      closeButton={() => {
                        setSelectedAnnotation(null);
                        setAnnotationType(null);
                        setIsAnnotating(false);
                      }}
                      type={annotationType}
                      selectedAnnotation={selectedAnnotation}
                      onUpdateAnnotation={handleUpdateAnnotation}
                      setTextFieldMetrics={setTextFieldMetrics}
                      setAnnotationSettings={setAnnotationSettings}
                      scale={scale}
                    />
                  </Box>
                )}
              {selectedAnnotation?.type === "signer_dropdown" && (
                <Box
                  key={`right-panel-${selectedAnnotation?.pageNum}-${selectedAnnotation?.index}-${selectedAnnotation?.type}`}
                  sx={{ width: "100%" }}
                >
                  <DropdownPropertiesPanel
                    selectedAnnotation={selectedAnnotation}
                    onUpdateAnnotation={handleUpdateAnnotation}
                    closeButton={() => {
                      setSelectedAnnotation(null);
                      setAnnotationType(null);
                      setIsAnnotating(false);
                    }}
                  />
                </Box>
              )}
              {(selectedAnnotation?.type === "signer_initials" ||
                selectedAnnotation?.type === "signer_initials_text" ||
                selectedAnnotation?.type === "signer_chooseImgStamp" ||
                selectedAnnotation?.type === "signer_chooseImgDrivingL" ||
                // selectedAnnotation?.type !== "signer_checkmark" ||
                selectedAnnotation?.type ===
                "signer_chooseImgPassportPhoto") && (
                  <Box
                    key={`right-panel-${selectedAnnotation?.pageNum}-${selectedAnnotation?.index}-${selectedAnnotation?.type}`}
                    sx={{ width: "100%" }}
                  >
                    <SignerFieldProperties
                      selectedAnnotation={selectedAnnotation}
                      onUpdateAnnotation={handleUpdateAnnotation}
                      closeButton={() => {
                        setSelectedAnnotation(null);
                        setAnnotationType(null);
                        setIsAnnotating(false);
                      }}
                    />
                  </Box>
                )}
              {selectedAnnotation &&
                (selectedAnnotation?.type === "date" ||
                  selectedAnnotation?.type === "signer_date") && (
                  <Box
                    key={`right-panel-${selectedAnnotation?.pageNum}-${selectedAnnotation?.index}-${selectedAnnotation?.type}`}
                    sx={{ width: "100%" }}
                  >
                    <DatePickerComponent
                      selectedAnnotation={selectedAnnotation}
                      onUpdateAnnotation={handleUpdateAnnotation}
                      type={selectedAnnotation?.type}
                      closeButton={() => {
                        setSelectedAnnotation(null);
                        setAnnotationType(null);
                        setIsAnnotating(false);
                      }}
                    />
                  </Box>
                )}

              {/* end  */}
              {(!selectedAnnotation?.type?.startsWith("signer_") ||
                selectedAnnotation?.type === "signer_checkmark") &&
                selectedAnnotation?.type !== "my_text" &&
                selectedAnnotation?.type !== "date" && (
                  <>
                    <Typography variant="h6">Preview</Typography>
                    {pdfImages.length > 0 &&
                      pdfImages.map((image, index) => (
                        <>
                          <Box
                            key={index}
                            sx={{
                              scrollMarginTop: "8px",
                              scrollMarginBottom: "8px",
                              transition: "all 0.1s ease",
                            }}
                            id={`thumbnail-${index + 1}`}
                            className={`thumbnail-container ${activePage === index + 1 ? "active" : ""
                              }`}
                            onClick={() => {
                              document
                                .getElementById(`img-${index + 1}`)
                                .scrollIntoView({ behavior: "smooth" });
                              setActivePage(index + 1);
                            }}
                          >
                            {renderImage(image, index, false)}
                          </Box>
                          <p
                            className={`page-number ${activePage === index + 1 ? "active" : ""
                              }`}
                          >
                            Page {index + 1}
                          </p>
                        </>
                      ))}{" "}
                  </>
                )}
            </Grid2>{" "}
          </Grid2>
        )}
        {signatureModalOpen && (
          <Dialog
            key={`signature-modal-${editingAnnotation?.pageNum}-${editingAnnotation?.index}-${editingAnnotation?.annot?.type}`}
            open={signatureModalOpen}
            onClose={() => {
              setSignatureModalOpen(false);
              setEditingAnnotation(null);
              setInitialBox(false);
              setLastClickPosition(null);
              // Remove loading placeholder when user closes without adding signature
              setAnnotations((prev) => {
                const next = {};
                for (const page in prev) {
                  if (page === "_lastUpdate") {
                    next[page] = prev[page];
                    continue;
                  }
                  next[page] = Array.isArray(prev[page]) ? prev[page].filter((a) => !a.isLoading) : [];
                }
                return next;
              });
            }}
            fullScreen={isMobileOrTablet}
            maxWidth={false}
            slotProps={{
              paper: {
                sx: {
                  width: isMobileOrTablet ? "100vw" : "100vw",
                  maxWidth: isMobileOrTablet ? "100vw" : "1200px",
                  height: isMobileOrTablet ? "100vh!important" : "70vh!important",
                  maxHeight: isMobileOrTablet ? "100vh!important" : "70vh!important",
                  margin: isMobileOrTablet ? 0 : "auto",
                  borderRadius: isMobileOrTablet ? 0 : "8px",
                  display: "flex",
                  flexDirection: "column",
                  padding: 0,
                  overflow: "hidden",
                  position: "fixed",
                  top: isMobileOrTablet ? 0 : "15vh",
                  left: 0,
                  right: 0,
                  bottom: isMobileOrTablet ? 0 : "auto",
                  zIndex: 20000, // Ensure modal appears above text fields (10000+)
                }
              },
              backdrop: {
                sx: {
                  backgroundColor: "rgba(0, 0, 0, 0.5)",
                  zIndex: 19999, // Backdrop should be just below modal
                }
              }
            }}
            sx={{
              zIndex: 20000, // Ensure Dialog container is above text fields
              "& .MuiDialog-container": {
                alignItems: isMobileOrTablet ? "stretch" : "center",
                justifyContent: isMobileOrTablet ? "stretch" : "center",
              },
              "& .MuiDialogTitle-root": {
                padding: isMobileOrTablet ? "12px 16px" : "16px 24px",
                width: "100%",
                boxSizing: "border-box",
                flexShrink: 0,
              },
              "& .MuiDialogContent-root": {
                padding: 0,
                width: "100%!important",
                flex: 1,
                overflow: "hidden",
                boxSizing: "border-box",
                display: "flex",
                flexDirection: "column",
              },
            }}
          >
            <SignatureModalContent
              key={`signature-content-${editingAnnotation?.pageNum}-${editingAnnotation?.index}-${editingAnnotation?.annot?.type}`}
              primaryColorComp={primaryColorComp}
              modalClosingD={() => {
                setSignatureModalOpen(false);
                setEditingAnnotation(null);
                setInitialBox(false);
                setLastClickPosition(null);
                setAnnotations((prev) => {
                  const next = {};
                  for (const page in prev) {
                    if (page === "_lastUpdate") {
                      next[page] = prev[page];
                      continue;
                    }
                    next[page] = Array.isArray(prev[page]) ? prev[page].filter((a) => !a.isLoading) : [];
                  }
                  return next;
                });
              }}
              receiverSide={false}
              initialsBox={initialsBox}
              profile={false}
              returnedSignature={handleSignatureComplete}
              modalClose={() => {
                setSignatureModalOpen(false);
                setEditingAnnotation(null);
                setInitialBox(false);
                setLastClickPosition(null);
                setAnnotations((prev) => {
                  const next = {};
                  for (const page in prev) {
                    if (page === "_lastUpdate") {
                      next[page] = prev[page];
                      continue;
                    }
                    next[page] = Array.isArray(prev[page]) ? prev[page].filter((a) => !a.isLoading) : [];
                  }
                  return next;
                });
              }}
              user_id_user={userId} // Replace with actual user ID if needed
              user_email="rimshanimo22@gmail.com"
            />
          </Dialog>
        )}
      </Box>
      {/* // Add this instead (place it next to your other Dialog components): */}
      <Dialog
        open={cropperModalOpen}
        onClose={() => {
          setCropperModalOpen(false);
          setCropSrc(null);
          setPendingStampAction(null);
          setStampClickPosition(null);
        }}
        maxWidth="md"
        fullWidth
      >
        <DialogTitle>Crop Image</DialogTitle>
        <DialogContent>
          <ImageCropperModal
            cropSrc={cropSrc}
            isOpen={cropperModalOpen}
            toggle={() => {
              setCropperModalOpen(false);
              setCropSrc(null);
              setPendingStampAction(null);
              setStampClickPosition(null);
            }}
            onCancel={() => {
              setCropperModalOpen(false);
              setCropSrc(null);
              setPendingStampAction(null);
              setStampClickPosition(null);
            }}
            onImageCropped={handleCroppedStamp}
          />
        </DialogContent>
      </Dialog>
      {/* Text Entry Dialog */}
      <TextEntryDialog
        open={textEntryDialogOpen}
        onClose={handleTextEntryCancel}
        onDone={handleTextEntryComplete}
        initialText={textEntryInitialText}
        submitOnEnter={true}
      />
      {/* // Add the SignersDialog component in your return statement (near other dialogs) */}
      <SignersDialog
        primaryColorComp={primaryColorComp}
        annotations={annotations}
        setAnnotationsd={async (newAnnotations) => {
          console.log("=== SIGNERS DIALOG - UPDATE ANNOTATIONS START ===");
          console.log("Document ID:", documentId);
          console.log("New annotations:", newAnnotations);
          console.log("New annotations pages:", Object.keys(newAnnotations));
          console.log("Total new annotations:", Object.values(newAnnotations).reduce((sum, arr) => sum + (Array.isArray(arr) ? arr.length : 0), 0));
          console.log("Original PDF URL:", originalPdf);
          console.log("Is encrypted URL?", originalPdf?.includes('encrypted-view'));

          setAnnotations(newAnnotations);

          const saveResult = await saveData(documentId, newAnnotations);

          console.log("=== SIGNERS DIALOG - SAVE DATA RESULT ===");
          console.log("Save result:", saveResult);
          console.log("Save error:", saveResult?.error);
          console.log("Save message:", saveResult?.message);
        }}
        open={signersDialogOpen}
        onClose={(newSigner) => {
          setSignersDialogOpen(false);

          if (signers.length === 0) {
            // If no signers left, switch to "For You" tab
            const meValue = {
              signer_id: "me",
              name: "Me",
              email: user_email,
              color: primaryColorComp || colortheme,
              isMe: true,
            };
            setSelectedSignerId(meValue);
            setSelectedSigner(meValue);
            setActive("1"); // Switch to "For You" tab
          }
          // setSignerToEdit(null); // Clear edit state on close
          // if (newSigner) {
          //   setSelectedSignerId(newSigner);
          //   setSelectedSigner(newSigner);
          //   setActive("2"); // Switch to "For Others" tab
          // }
        }}
        signers={signers}
        file_id={documentId}
        setSigners={setSigners}
        signerToEdit={signerToEdit}
      // setSelectedSignerId={setSelectedSignerId}
      // setSelectedSigner={setSelectedSigner}
      // hideDefaultSigner={true}
      />
      <Dialog
        open={saveConfirmModalOpen}
        onClose={() => {
          if (!isSaving) {
            setSaveConfirmModalOpen(false);
          }
        }}
        maxWidth="sm"
        fullWidth
        PaperProps={{
          sx: {
            borderRadius: 2,
          },
        }}
      >
        <DialogTitle
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            borderBottom: "1px solid rgba(0,0,0,0.12)",
            pb: 2,
            backgroundColor: "#f8f9fa",
          }}
        >
          <Typography variant="h6" fontWeight={600}>
            Save Changes
          </Typography>
          <IconButton
            onClick={() => {
              if (!isSaving) {
                setSaveConfirmModalOpen(false);
              }
            }}
            size="small"
            disabled={isSaving}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent sx={{ mt: 2, pb: 1 }}>
          <Typography variant="body1" sx={{ color: "rgba(0, 0, 0, 0.87)" }}>
            Do you want to save the previous changes before going back?
          </Typography>
        </DialogContent>
        <DialogActions
          sx={{
            px: 3,
            pb: 2,
            pt: 1,
            gap: 1,
          }}
        >
          <Button
            onClick={() => {
              setSaveConfirmModalOpen(false);
            }}
            variant="outlined"
            disabled={isSaving}
            sx={{
              textTransform: "none",
              minWidth: 100,
            }}
          >
            Cancel
          </Button>
          <Button
            onClick={() => {
              setSaveConfirmModalOpen(false);
              window.location.href = `${FrontendBaseUrl}home?status=${hasParamsD}`;
            }}
            variant="outlined"
            disabled={isSaving}
            sx={{
              textTransform: "none",
              minWidth: 100,
              color: "#d32f2f",
              borderColor: "#d32f2f",
              "&:hover": {
                borderColor: "#b71c1c",
                backgroundColor: "rgba(211, 47, 47, 0.04)",
              },
            }}
          >
            Cancel & Don't Save
          </Button>
          <Button
            onClick={handleSaveAndGoBack}
            variant="contained"
            disabled={isSaving}
            sx={{
              textTransform: "none",
              minWidth: 100,
              backgroundColor:
                primaryColorComp === null || primaryColorComp === undefined
                  ? "#21b3e8"
                  : primaryColorComp,
              boxShadow: "none",
              "&:hover": {
                backgroundColor:
                  primaryColorComp === null || primaryColorComp === undefined
                    ? "#00bcff"
                    : primaryColorComp,
                boxShadow: "none",
              },
            }}
          >
            {isSaving ? (
              <>
                <CircularProgress
                  size={20}
                  sx={{
                    color: "white",
                    marginRight: 1,
                  }}
                />
                Saving...
              </>
            ) : (
              "Save & Go Back"
            )}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}

export default EsignSetupCopy;
